/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s, i, o, n, r) {
  "use strict";
  function a(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let l = p();
  function c() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = m('[data-section-type*="footer"]')),
      (t.headerHeight = m("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = m("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = m("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function h() {
    document.addEventListener("theme:resize", u), d();
  }
  function d() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = c();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function u() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = c(),
      n = p();
    (n !== l || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (l = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function p() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function m(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  function v(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }
  function g() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function f() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  }
  function y() {
    return g() >= window.theme.sizes.small;
  }
  function b() {
    return g() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let w = g(),
    E = f();
  let S = window.scrollY,
    L = null,
    k = null,
    A = null,
    C = null,
    T = 0;
  function q(e) {
    setTimeout(() => {
      T && clearTimeout(T),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function x(t) {
    const e = t.detail;
    e ? (T = setTimeout(M, e)) : M();
  }
  function M() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const P = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };
  function I(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      P(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      P(t, "rte__video-wrapper");
    });
  }
  function H(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const O = "is-loading",
    B = "img.is-loading";
  function D(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function F(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var $ = {};
  function _(t, e) {
    e = e || {};
    var s = F(t),
      i = e.elementToFocus || t,
      o = s[0],
      n = s[s.length - 1];
    N(),
      ($.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          o &&
          o === e.target &&
          o.focus(),
          (e.target !== t && e.target !== n && e.target !== o) ||
            document.addEventListener("keydown", $.keydown);
      }),
      ($.focusout = function () {
        document.removeEventListener("keydown", $.keydown);
      }),
      ($.keydown = function (e) {
        "Tab" === e.code &&
          (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
          (e.target !== t && e.target !== o) ||
            !e.shiftKey ||
            (e.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", $.focusout),
      document.addEventListener("focusin", $.focusin),
      D(i, e);
  }
  function N() {
    document.removeEventListener("focusin", $.focusin),
      document.removeEventListener("focusout", $.focusout),
      document.removeEventListener("keydown", $.keydown);
  }
  function R() {
    window.accessibility.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        var t;
        null === (t = window.accessibility.lastElement) ||
          void 0 === t ||
          t.focus();
      });
  }
  var W = Object.freeze({
    __proto__: null,
    forceFocus: D,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && D(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                D(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: F,
    trapFocus: _,
    removeTrapFocus: N,
    autoFocusLastElement: R,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s,
          i,
          o,
          n = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          r = e.prefix || "a11y",
          a = {
            newWindow: r + "-new-window-message",
            external: r + "-external-message",
            newWindowExternal: r + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            o = "_blank" === e,
            n = null === s || -1 === s.indexOf("noopener");
          if (o && n) {
            var r = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", r);
          }
          i && o
            ? t.setAttribute("aria-describedby", a.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", a.external)
            : o && t.setAttribute("aria-describedby", a.newWindow);
        }),
          (s = n),
          (i = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
          }, "")),
          i.setAttribute("hidden", !0),
          (i.innerHTML = o),
          document.body.appendChild(i);
      }
    },
  });
  const z = 'input[type="search"]',
    U = '[aria-selected="true"] a',
    V = 'button[type="reset"]',
    j = "hidden";
  let X = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(j);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(j)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(j);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(U);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(z).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(z)),
        (this.resetButton = this.querySelector(V)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            v((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", X);
  const J = '[role="option"]',
    Y = '[aria-selected="true"]',
    Q = "[data-popular-searches]",
    G = "predictive-search",
    K = "[data-predictive-search-results]",
    Z = "[data-predictive-search-status]",
    tt = 'input[type="search"]',
    et = "[data-popdown]",
    st = "[data-predictive-search-live-region-count-value]",
    it = "[data-search-results-groups-wrapper]",
    ot = "[data-predictive-search-search-for-text]",
    nt = "#shopify-section-predictive-search",
    rt = '[aria-selected="true"] a',
    at = '[aria-selected="true"] a, button[aria-selected="true"]';
  let lt = class extends X {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      var e;
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        null === (e = this.querySelector(it)) ||
        void 0 === e ||
        e.remove();
      this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(rt)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(rt);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(ot),
        i = null == s ? void 0 : s.innerText;
      if (i) {
        var o;
        if (
          (null === (o = i.match(new RegExp(t, "g"))) || void 0 === o
            ? void 0
            : o.length) > 1
        )
          return;
        const n = i.replace(t, e);
        s.innerText = n;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(Y),
        i = Array.from(this.querySelectorAll(J)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(at);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(nt).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== (null == t ? void 0 : t.code))
                  throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(Z)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(st).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0),
        this.predictiveSearchResults.style.setProperty(
          "--full-screen",
          `${window.visualViewport.height}px`
        );
    }
    close(t = !1) {
      this.closeResults(t),
        (this.isOpen = !1),
        this.predictiveSearchResults.style.removeProperty("--full-screen");
    }
    closeResults(t = !1) {
      var e;
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const s = this.querySelector(Y);
      s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        null === (e = this.predictiveSearchResults) ||
          void 0 === e ||
          e.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
    constructor() {
      var t;
      super(),
        (this.a11y = W),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(G)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(tt)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(K)),
        (this.searchPopdown = this.closest(et)),
        (this.popularSearches =
          null === (t = this.searchPopdown) || void 0 === t
            ? void 0
            : t.querySelector(Q)),
        (this.searchTerm = "");
    }
  };
  const ct = "[data-popout-list]",
    ht = "[data-popout-toggle]",
    dt = "[data-popout-toggle-text]",
    ut = "[data-popout-input]",
    pt = "[data-popout-option]",
    mt = "[data-product-image]",
    vt = "[data-grid-item]",
    gt = "popout-list--visible",
    ft = "is-visible",
    yt = "is-active",
    bt = "select-popout--top",
    wt = "aria-expanded",
    Et = "aria-current",
    St = "data-value",
    Lt = "data-popout-toggle-text",
    kt = "submit";
  let At = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector(ct)),
          (this.popoutToggle = this.querySelector(ht)),
          (this.popoutToggleText = this.querySelector(dt)),
          (this.popoutInput = this.querySelector(ut)),
          (this.popoutOptions = this.querySelectorAll(pt)),
          (this.productGridItem = this.popoutList.closest(vt)),
          (this.fireSubmitEvent = this.hasAttribute(kt)),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        const e = "true" === t.currentTarget.getAttribute(wt);
        if (this.productGridItem) {
          const t = this.productGridItem.querySelector(mt);
          t && t.classList.toggle(ft, !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGridItem.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(wt, !e),
          this.popoutList.classList.toggle(gt),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        const e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(gt) && !e && this._hideList();
      }
      toggleListPosition() {
        const t = "true" === this.querySelector(ht).getAttribute(wt),
          e = window.innerHeight,
          s = this.popoutList.getBoundingClientRect().bottom,
          i = () => {
            this.classList.remove(bt),
              this.popoutList.removeEventListener("transitionend", i);
          };
        t
          ? e < s && this.classList.add(bt)
          : this.popoutList.addEventListener("transitionend", i);
      }
      popupListMaxWidth() {
        this.popoutList.style.setProperty("--max-width", "100vw"),
          requestAnimationFrame(() => {
            this.popoutList.style.setProperty(
              "--max-width",
              `${parseInt(
                document.body.clientWidth -
                  this.popoutList.getBoundingClientRect().left
              )}px`
            );
          });
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(pt).attributes.href.value) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute(St)
            ? t.currentTarget.getAttribute(St)
            : "";
          if (
            ((this.popoutInput.value = e),
            this.popoutInput.disabled &&
              this.popoutInput.removeAttribute("disabled"),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            const s = t.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${yt}`),
              o = this.popoutList.querySelector(`[${Et}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i && (i.classList.remove(yt), s.classList.add(yt)),
              "quantity" != this.popoutInput.name ||
                s.nextSibling ||
                this.classList.add(yt),
              o &&
                o.hasAttribute(`${Et}`) &&
                (o.removeAttribute(`${Et}`),
                t.currentTarget.setAttribute(`${Et}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.innerHTML = e),
                this.popoutToggleText.hasAttribute(Lt) &&
                  "" !== this.popoutToggleText.getAttribute(Lt) &&
                  this.popoutToggleText.setAttribute(Lt, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        const e = this.contains(t.target);
        this.popoutList.classList.contains(gt) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        const t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(gt),
          this.popoutToggle.setAttribute(wt, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    Ct = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", { bubbles: !0 })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
          this.input.addEventListener("change", this.onQuantityChangeEvent),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value,
          s =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === s.name && this.input.stepUp(),
          "decrease" === s.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
      }
      onQuantityChange() {
        "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
      }
      constructor() {
        super();
      }
    };
  const Tt = "[data-aos]:not(.aos-animate)",
    qt = "[data-aos-anchor]",
    xt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    Mt = "aos-animate",
    Pt = { attributes: !1, childList: !0, subtree: !0 };
  let It = [];
  const Ht = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(Tt),
            i = t.querySelectorAll(qt);
          s.length &&
            s.forEach((t) => {
              Ot.observe(t);
            }),
            i.length && Dt(i);
        }
    },
    Ot = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(Mt), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    Bt = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(Tt);
            s.length &&
              s.forEach((t) => {
                t.classList.add(Mt);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function Dt(t) {
    t.length &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === It.indexOf(e)) {
          const t = document.querySelector(e);
          t && (Bt.observe(t), It.push(e));
        }
      });
  }
  const Ft = "[data-deferred-media-button]",
    $t = "video, model-viewer, iframe",
    _t = '[data-host="youtube"]',
    Nt = '[data-host="vimeo"]',
    Rt = "[data-grid-item]",
    Wt = ".shopify-section",
    zt = "template",
    Ut = "video",
    Vt = "product-model",
    jt = "loaded",
    Xt = "autoplay";
  let Jt = class extends HTMLElement {
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(jt) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(jt)) {
        const t = this.querySelector(_t),
          e = this.querySelector(Nt),
          s = t || e,
          i = this.querySelector(Ut);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(jt))) {
        const e = document.createElement("div"),
          s = this.querySelector(zt).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(jt, !0);
        const i = this.appendChild(e.querySelector($t));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(Xt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(_t).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(Nt).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Ut).forEach((t) => t.pause()),
        document.querySelectorAll(Vt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector(Ft);
      null == t || t.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(Wt)),
        (this.productGridItem = this.closest(Rt)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
  };
  const Yt = "product-modal",
    Qt = "[data-popup-close]",
    Gt = "[data-notification-form]",
    Kt = "has-success";
  let Zt = class extends HTMLElement {
    connectedCallback() {
      this.checkState(),
        this.notificationForm.addEventListener("submit", (t) =>
          this.notificationSubmitEvent(t)
        ),
        this.popupClose.addEventListener("click", () => {
          this.removeStorage();
        });
    }
    checkState() {
      -1 !== window.location.search.indexOf("?contact_posted=true") &&
        (this.closest(Yt).classList.add(Kt),
        this.popup.removeAttribute("inert"),
        "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.popup.setAttribute("open", ""));
    }
    notificationSubmitEvent(t) {
      this.preventSubmit &&
        (t.preventDefault(),
        this.removeStorage(),
        this.writeStorage(),
        (this.preventSubmit = !1),
        this.notificationForm.submit());
    }
    writeStorage() {
      void 0 !== window.sessionStorage &&
        window.sessionStorage.setItem(
          "notification_form_id",
          this.notificationForm.id
        );
    }
    removeStorage() {
      window.sessionStorage.removeItem("notification_form_id");
    }
    constructor() {
      super(),
        (this.notificationForm = this.querySelector(Gt)),
        (this.preventSubmit = !0),
        (this.popup = this.closest("dialog")),
        (this.popupClose = this.popup.querySelector(Qt));
    }
  };
  const te = "is-visible";
  class ee {
    init() {
      var t;
      const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(te)
            : t.target.classList.remove(te);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
  }
  const se = "is-dragging",
    ie = "is-enabled",
    oe = "is-scrolling",
    ne = "is-visible",
    re = "[data-grid-item]";
  class ae {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(se, oe),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(oe);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(se),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${re}.${ne}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(oe),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(ie),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(ie);
    }
  }
  const le = "[data-button-arrow]",
  ce = "[data-collection-image]",
  he = "[data-column-image]",
  de = "[data-product-image]",
  ue = "[data-grid-item]",
  pe = "[data-grid-slider]",
  me = "data-button-prev",
  ve = "data-button-next",
  ge = "align-arrows",
  fe = "slider__arrows",
  ye = "is-visible",
  be = "scroll-snap-disabled";

class we extends HTMLElement {
  connectedCallback() {
    this.init(), this.addEventListener("theme:grid-slider:init", this.init);
  }

  init() {
    var t;
    (this.slider = this.querySelector(pe)),
      (this.slides = this.querySelectorAll(ue)),
      (this.buttons = this.querySelectorAll(le)),
      this.slider.classList.add(be),
      this.toggleSlider(),
      document.addEventListener("theme:resize:width", this.toggleSlider),
      ((t = this),
      new Promise((e) => {
        const s = t.querySelectorAll("[data-aos]");
        let i = 0;
        function o(t) {
          i++,
            i === s.length && e(),
            t.target.removeEventListener("animationend", o);
        }
        s.forEach((t) => {
          t.addEventListener("animationend", o);
        });
      })).then(() => {
        this.slider.classList.remove(be);
        // After animations complete, ensure arrows reflect the current scroll position
        this.updateArrowDisabledState();
      });
  }

  toggleSlider() {
    if (
      !(this.slider.clientWidth < this.getSlidesWidth()) ||
      (!y() && window.theme.touch)
    )
      this.destroy();
    else {
      if (this.isInitialized) return;
      (this.slidesObserver = new ee(this.slider, ue)),
        this.initArrows(),
        (this.isInitialized = !0),
        (this.draggableSlider = new ae(this.slider));
    }
  }

  initArrows() {
    if (!this.buttons.length) {
      const t = document.createElement("div");
      t.classList.add(fe),
        (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
        this.append(t),
        (this.buttons = this.querySelectorAll(le)),
        (this.buttonPrev = this.querySelector(`[${me}]`)),
        (this.buttonNext = this.querySelector(`[${ve}]`));
    }
    this.toggleArrowsObserver(),
      this.hasAttribute(ge) &&
        (this.positionArrows(), this.arrowsResizeObserver()),
      this.buttons.forEach((t) => {
        t.addEventListener("click", this.onButtonArrowClick);
      });
  }

  buttonArrowClickEvent(t) {
    t.preventDefault();

    // Keep existing logic, but update arrow states after the scroll settles
    const btn = t.currentTarget;
    const e = this.slider.querySelector(`${ue}.${ye}`);
    let s = null;
    t.target.hasAttribute(me) &&
      (s = null == e ? void 0 : e.previousElementSibling),
      t.target.hasAttribute(ve) &&
        (s = null == e ? void 0 : e.nextElementSibling),
      this.goToSlide(s);

    setTimeout(() => this.updateArrowDisabledState(), 250);
  }

  removeArrows() {
    var t;
    null === (t = this.querySelector(`.${fe}`)) || void 0 === t || t.remove();
  }

  goToSlide(t) {
    t &&
      this.slider.scrollTo({
        top: 0,
        left: t.offsetLeft,
        behavior: "smooth",
      });
  }

  getSlidesWidth() {
    var t;
    return (
      (null === (t = this.slider.querySelector(ue)) || void 0 === t
        ? void 0
        : t.clientWidth) * this.slider.querySelectorAll(ue).length
    );
  }

  // NEW: compute disabled states from scroll position (works with multi-visible slides)
  updateArrowDisabledState() {
    if (!this.slider || !this.buttonPrev || !this.buttonNext) return;

    const max = this.slider.scrollWidth - this.slider.clientWidth;

    if (max <= 1) {
      this.buttonPrev.disabled = !0;
      this.buttonNext.disabled = !0;
      return;
    }

    // 1px tolerance to avoid rounding issues
    this.buttonPrev.disabled = this.slider.scrollLeft <= 1;
    this.buttonNext.disabled = this.slider.scrollLeft >= max - 1;
  }

  // REPLACED: old MutationObserver-based "is-visible" logic with scroll-based logic
  toggleArrowsObserver() {
    if (!this.buttonPrev || !this.buttonNext || !this.slider) return;

    // Clean up old observer if it exists (from previous theme versions / re-inits)
    if (this.firstLastSlidesObserver) {
      this.firstLastSlidesObserver.disconnect();
      this.firstLastSlidesObserver = null;
    }

    // Avoid double-binding if init() runs again
    if (this._scrollArrowsBound) return;
    this._scrollArrowsBound = !0;

    // Update now + on scroll + on resize
    this.updateArrowDisabledState();
    this.slider.addEventListener("scroll", this.updateArrowDisabledState, {
      passive: !0,
    });
    document.addEventListener("theme:resize:width", this.updateArrowDisabledState);

    // A few delayed updates to catch async render / injected items / fonts
    requestAnimationFrame(() => this.updateArrowDisabledState());
    setTimeout(() => this.updateArrowDisabledState(), 150);
    setTimeout(() => this.updateArrowDisabledState(), 600);
  }

  positionArrows() {
    const t =
      this.slider.querySelector(de) ||
      this.slider.querySelector(ce) ||
      this.slider.querySelector(he) ||
      this.slider;
    t &&
      this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
  }

  arrowsResizeObserver() {
    document.addEventListener("theme:resize:width", this.positionArrows);
  }

  disconnectedCallback() {
    this.destroy(),
      document.removeEventListener("theme:resize:width", this.toggleSlider);
  }

  destroy() {
    var t, e;

    // Remove our listeners
    if (this.slider) {
      this.slider.removeEventListener("scroll", this.updateArrowDisabledState);
    }
    document.removeEventListener("theme:resize:width", this.updateArrowDisabledState);
    this._scrollArrowsBound = !1;

    (this.isInitialized = !1),
      null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
      (this.draggableSlider = null),
      null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
      (this.slidesObserver = null),
      this.removeArrows(),
      document.removeEventListener("theme:resize:width", this.positionArrows);
  }

  constructor() {
    super(),
      (this.isInitialized = !1),
      (this.draggableSlider = null),
      (this.positionArrows = this.positionArrows.bind(this)),
      (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
      (this.updateArrowDisabledState = this.updateArrowDisabledState.bind(this)),
      (this.slidesObserver = null),
      (this.firstLastSlidesObserver = null),
      (this.isDragging = !1),
      (this.toggleSlider = this.toggleSlider.bind(this)),
      (this._scrollArrowsBound = !1);
  }
}
  const Ee = "time",
    Se = "[data-days]",
    Le = "[data-hours]",
    ke = "[data-minutes]",
    Ae = "[data-seconds]",
    Ce = ".shopify-section",
    Te = "[data-countdown-block]",
    qe = "[data-ticker-text]",
    xe = "data-expiration-behavior",
    Me = "data-clone",
    Pe = "show-message",
    Ie = "hidden",
    He = "hide-section",
    Oe = "show-message";
  let Be = class extends HTMLElement {
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.update(), (this.interval = setInterval(this.update, 1e3)));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= s * this.hoursInMs;
      const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= i * this.minutesInMs;
      return {
        days: e,
        hours: s,
        minutes: i,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      var t, e;
      (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
      this.shouldHideOnComplete) &&
        (null === (t = this.countdownParent) ||
          void 0 === t ||
          t.classList.add(Ie),
        null === (e = this.countdownParent) ||
          void 0 === e ||
          e.dispatchEvent(
            new CustomEvent("theme:countdown:hide", {
              detail: { element: this },
              bubbles: !0,
            })
          ));
      if (this.shouldShowMessage) {
        var s, i;
        if (
          (null === (s = this.classList) || void 0 === s || s.add(Pe),
          this.closest(qe).hasAttribute(Me))
        )
          return;
        null === (i = this.countdownParent) ||
          void 0 === i ||
          i.dispatchEvent(
            new CustomEvent("theme:countdown:expire", { bubbles: !0 })
          );
      }
    }
    update() {
      const t = new Date().getTime(),
        e = this.endDate - t;
      e < 1e3 && (this.stopTimer(), this.onComplete());
      const s = this.convertTime(e);
      this.render(s);
    }
    constructor() {
      super(),
        (this.section = this.closest(Ce)),
        (this.countdownParent = this.closest(Te) || this.section),
        (this.expirationBehavior = this.getAttribute(xe)),
        (this.time = this.querySelector(Ee)),
        (this.days = this.querySelector(Se)),
        (this.hours = this.querySelector(Le)),
        (this.minutes = this.querySelector(ke)),
        (this.seconds = this.querySelector(Ae)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === He),
        (this.shouldShowMessage = this.expirationBehavior === Oe),
        (this.update = this.update.bind(this));
    }
  };
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(xt);
        t.length &&
          t.forEach((t) => {
            Ot.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(qt);
        t.length && Dt(t);
      })(),
      new MutationObserver(Ht).observe(document.body, Pt),
      document.addEventListener("shopify:section:unload", (t) => {
        var e;
        const s =
            "#" +
            (null === (e = t.target.querySelector("[data-section-id]")) ||
            void 0 === e
              ? void 0
              : e.id),
          i = It.indexOf(s);
        -1 !== i && It.splice(i, 1);
      })),
    window.addEventListener(
      "resize",
      v(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          w !== g() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (w = g())),
          E !== f() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (E = f()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > S
                  ? ((k = !0), (L = !1))
                  : t < S
                  ? ((k = !1), (L = !0))
                  : ((L = null), (k = null)),
                  (S = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: L, down: k, position: t },
                      bubbles: !1,
                    })
                  ),
                  L &&
                    !A &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  k &&
                    !C &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (C = k),
                  (A = L);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", q),
        window.addEventListener("theme:scroll:unlock", x);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    d(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(O) &&
          (t.target.classList.remove(O),
          t.target.parentNode.classList.remove(O),
          t.target.parentNode.parentNode.classList.contains(O) &&
            t.target.parentNode.parentNode.classList.remove(O));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      h(),
        H(document),
        a(document),
        I(document),
        document.querySelectorAll(B).forEach((t) => {
          t.complete &&
            (t.classList.remove(O),
            t.parentNode.classList.remove(O),
            t.parentNode.parentNode.classList.contains(O) &&
              t.parentNode.parentNode.classList.remove(O));
        }),
        document.body.classList.add("is-loaded"),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      a(e), I(e), H(document), h();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", At),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", Ct),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", lt),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", Jt),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", we),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", Be),
    customElements.get("product-notification") ||
      customElements.define("product-notification", Zt);
  const De = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      target: "api-product-grid-item",
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n, l, c) => {
        s.length && e < c
          ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
              .then((t) => t.text())
              .then((t) => {
                const i = 100 * e,
                  r = o.id ? `#${o.id}` : "",
                  h = document.createElement("div");
                let d = t;
                (d = d.includes("||itemAnimationDelay||")
                  ? d.replaceAll("||itemAnimationDelay||", i)
                  : d),
                  (d = d.includes("||itemAnimationAnchor||")
                    ? d.replaceAll("||itemAnimationAnchor||", r)
                    : d),
                  (h.innerHTML = d),
                  (o.innerHTML +=
                    h.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n, l, c);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n, l, c);
              })
          : ((e, s) => {
              De(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const Fe = (t, e = [], s = !1) => {
    const i = Object.keys(t)
      .map((i) => {
        let o = t[i];
        if (
          "[object Object]" === Object.prototype.toString.call(o) ||
          Array.isArray(o)
        )
          return (
            Array.isArray(t) ? e.push("") : e.push(i),
            Fe(o, e, Array.isArray(o))
          );
        {
          let t = i;
          if (e.length > 0) {
            t = (s ? e : [...e, i]).reduce(
              (t, e) => ("" === t ? e : `${t}[${e}]`),
              ""
            );
          }
          return s ? `${t}[]=${o}` : `${t}=${o}`;
        }
      })
      .join("&");
    return e.pop(), i;
  };
  function $e(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  $e.prototype = Error.prototype;
  const _e = "is-focused",
    Ne = "[data-skip-content]",
    Re = 'a[href="#"]';
  window.accessibility = new (class {
    init() {
      (this.a11y = W),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(Ne)),
        (this.linkesWithOnlyHash = document.querySelectorAll(Re)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(_e);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(_e);
        });
    }
    constructor() {
      this.init();
    }
  })();
  const We = (t, e) => {
      let s, i;
      return function o(...n) {
        const r = Date.now();
        (i = clearTimeout(i)),
          !s || r - s >= e
            ? (t.apply(null, n), (s = r))
            : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
      };
    },
    ze = "is-animated",
    Ue = "is-added",
    Ve = "is-disabled",
    je = "is-empty",
    Xe = "is-hidden",
    Je = "is-hiding",
    Ye = "is-loading",
    Qe = "is-open",
    Ge = "is-removed",
    Ke = "is-success",
    Ze = "is-visible",
    ts = "is-expanded",
    es = "is-updated",
    ss = "variant--soldout",
    is = "variant--unavailable",
    os = "[data-api-content]",
    ns = "[data-api-line-items]",
    rs = "[data-api-upsell-items]",
    as = "[data-api-cart-price]",
    ls = "[data-animation]",
    cs = "[data-skip-upsell-product]",
    hs = "[data-add-to-cart-bar]",
    ds = "[data-cart-error-close]",
    us = "cart-drawer",
    ps = "[data-cart-drawer-close]",
    ms = "[data-cart-empty]",
    vs = "[data-cart-errors]",
    gs = "[data-item-remove]",
    fs = "[data-cart-page]",
    ys = "[data-cart-form]",
    bs = "[data-cart-acceptance-checkbox]",
    ws = "[data-cart-checkout-buttons]",
    Es = "[data-cart-checkout-button]",
    Ss = "[data-cart-total]",
    Ls = "[data-checkout-buttons]",
    ks = "[data-error-message]",
    As = "[data-close-error]",
    Cs = "[data-cart-errors-container]",
    Ts = "[data-form-wrapper]",
    qs = "[data-free-shipping]",
    xs = "[data-progress-graph]",
    Ms = "[data-progress-bar]",
    Ps = "[data-header-wrapper]",
    Is = "[data-item]",
    Hs = "[data-items-holder]",
    Os = "[data-left-to-spend]",
    Bs = "[data-drawer]",
    Ds = "[data-section-id]",
    Fs = "[data-cart-price-holder]",
    $s = "[data-quick-add-holder]",
    _s = "[data-quick-add-modal]",
    Ns = 'input[name="updates[]"]',
    Rs = "[data-upsell-products]",
    Ws = "[data-upsell-widget]",
    zs = "[data-terms-error-message]",
    Us = "[data-collapsible-body]",
    Vs = "recently-viewed-products-cart",
    js = "data-cart-total",
    Xs = "disabled",
    Js = "data-free-shipping",
    Ys = "data-free-shipping-limit",
    Qs = "data-item",
    Gs = "data-item-index",
    Ks = "data-item-title",
    Zs = "open",
    ti = "data-quick-add-holder",
    ei = "data-scroll-locked",
    si = "data-upsell-auto-open";
  let ii = class extends HTMLElement {
    connectedCallback() {
      (this.cartPage = document.querySelector(fs)),
        (this.cartForm = document.querySelector(ys)),
        (this.cartDrawer = document.querySelector(us)),
        (this.cartEmpty = document.querySelector(ms)),
        (this.cartTermsCheckbox = document.querySelector(bs)),
        (this.cartCheckoutButtonWrapper = document.querySelector(ws)),
        (this.cartCheckoutButton = document.querySelector(Es)),
        (this.checkoutButtons = document.querySelector(Ls)),
        (this.itemsHolder = document.querySelector(Hs)),
        (this.priceHolder = document.querySelector(Fs)),
        (this.items = document.querySelectorAll(Is)),
        (this.cartTotal = document.querySelector(Ss)),
        (this.freeShipping = document.querySelectorAll(qs)),
        (this.cartErrorHolder = document.querySelector(vs)),
        (this.cartCloseErrorMessage = document.querySelector(ds)),
        (this.headerWrapper = document.querySelector(Ps)),
        (this.navDrawer = document.querySelector(Bs)),
        (this.upsellProductsHolder = document.querySelector(Rs)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener("theme:cart-drawer:open", this.animateItems),
        document.addEventListener(
          "theme:cart-drawer:close",
          this.onCartDrawerClose
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(Ys)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.formSubmitHandler = We(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.animateItems(),
          this.recentlyViewedProducts(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.dispatchEvent(
            new CustomEvent("theme:cart:load", { bubbles: !0 })
          ));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:unload", { bubbles: !0 })
        ),
        document.documentElement.hasAttribute(ei) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    onCartDrawerClose() {
      var t;
      this.resetAnimatedItems(),
        (null === (t = this.cartDrawer) || void 0 === t
          ? void 0
          : t.classList.contains(Qe)) && this.cart.classList.remove(es),
        this.cartEmpty.classList.remove(es),
        this.cartErrorHolder.classList.remove(ts),
        this.cart.querySelectorAll(ls).forEach((t) => {
          const e = () => {
            t.classList.remove(Je), t.removeEventListener("animationend", e);
          };
          t.classList.add(Je), t.addEventListener("animationend", e);
        });
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(Is)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(gs).forEach((t) => {
        const e = t.closest(Is);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(Ve) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(ts);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      i.checkValidity()
        ? ((e = new FormData(i)),
          (null !== i && i.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, s)))
        : i.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(bs).checked,
        e = document.querySelector(zs);
      if (t)
        e.classList.remove(ts), this.cartCheckoutButton.removeAttribute(Xs);
      else {
        if (document.querySelector(zs).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(Xs, !0),
          e.classList.add(ts);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(As);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(Ze);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(os);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(Ye);
      const s = null == e ? void 0 : e.closest($s);
      e && (e.classList.add(Ye), (e.disabled = !0)),
        s && s.classList.add(Ze),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(Ye), (e.disabled = !1)))
              );
            this.cart
              ? (e &&
                  (e.classList.remove(Ye),
                  e.classList.add(Ue),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(Ye);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(Ye) : e.classList.add(Ge)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${Qs}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(Gs))
          ? parseInt(i.getAttribute(Gs))
          : 0,
        n = (null == i ? void 0 : i.hasAttribute(Ks))
          ? i.getAttribute(Ks)
          : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(Ns),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(Ye);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${gs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(Ve), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(Xs, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${gs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(Ve), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(Xs);
          }),
        this.cart.classList.remove(Ye);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(ks).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(ts, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $e({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      var s;
      if (null !== e) {
        const s = e.closest(Ds) || e.closest($s) || e.closest(_s);
        let i = null == s ? void 0 : s.querySelector(Cs);
        const o = e.closest($s);
        if ((o && o.querySelector(Cs) && (i = o.querySelector(Cs)), i)) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(Ze),
            this.formErrorsEvents(i);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: { response: t, button: e },
            bubbles: !0,
          })
        );
      }
      const i = null == e ? void 0 : e.closest($s);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: i,
            },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(Ye);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(hs);
      e.push(o),
        (s = o.closest($s)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(Ye), i || t.classList.add(Ue);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(Ue);
            (null === (e = t.closest(Ts)) || void 0 === e
              ? void 0
              : e.classList.contains(ss)) ||
              (null === (s = t.closest(Ts)) || void 0 === s
                ? void 0
                : s.classList.contains(is)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(Ze);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle(je, !t),
        t ||
          setTimeout(() => {
            _(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(ps),
            });
          }, 100);
    }
    build(t) {
      var e;
      const i = t.querySelector(ns),
        o = t.querySelector(rs),
        n = Boolean(null === i && null === o),
        r = t.querySelector(as),
        a = t.querySelector(Ss);
      this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML),
        n
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = i.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = o.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          i && i.querySelectorAll(Is).length
            ? i.querySelectorAll(Is).length
            : 0),
        (this.subtotal =
          a && a.hasAttribute(js) ? parseInt(a.getAttribute(js)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        (null === (e = this.cartDrawer) || void 0 === e
          ? void 0
          : e.classList.contains(Qe)) && this.cart.classList.add(es),
        this.cart.classList.remove(Ye),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(ls).forEach((t) => {
            t.classList.remove(ze);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(Ns)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute(Js) && "true" === e.getAttribute(Js) && t >= 0;
          e.classList.toggle(Ke, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(qs)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        i = this.circumference - ((e / 100) * this.circumference) / 2,
        o = s.formatMoney(
          this.freeShippingLimit - this.subtotal,
          theme.moneyFormat
        );
      this.freeShipping.forEach((t) => {
        const s = t.querySelector(Ms),
          n = t.querySelector(xs),
          r = t.querySelector(Os);
        r && (r.innerHTML = o.replace(".00", "")),
          s && (s.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${i}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(cs);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest($s).getAttribute(ti);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${ti}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll($s),
        e = this.upsellProductsHolder.closest(Ws);
      if (
        e &&
        (e.classList.toggle(Xe, !t.length),
        t.length && !e.hasAttribute(Zs) && e.hasAttribute(si))
      ) {
        e.setAttribute(Zs, !0);
        const t = e.querySelector(Us);
        t && (t.style.height = "auto");
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(ls).forEach((t) => {
        t.classList.remove(ze), t.classList.remove(Je);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          null == e ||
            e.querySelectorAll(ls).forEach((t) => {
              t.classList.add(ze);
            });
      });
    }
    recentlyViewedProducts() {
      this.cart.querySelector(`#${Vs}`) &&
        Shopify.Products.showRecentlyViewed({
          howManyToShow: 3,
          wrapperId: Vs,
          section: this,
          target: "api-upsell-product",
        });
    }
    constructor() {
      super();
    }
  };
  customElements.get("cart-items") || customElements.define("cart-items", ii);
  const oi = "data-cart-count",
    ni = "data-limit";
  let ri = class extends HTMLElement {
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(oi, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(ni)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
  };
  function ai(t) {
    return new Promise((e) => {
      null == t ||
        t.addEventListener("animationend", function s(i) {
          i.target == t && (t.removeEventListener("animationend", s), e());
        });
    });
  }
  customElements.get("cart-count") || customElements.define("cart-count", ri);
  const li = "is-open",
    ci = "is-closing",
    hi = "drawer--duplicate",
    di = "drawer-editor-error",
    ui = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    pi = "data-drawer-underlay";
  let mi = class extends HTMLElement {
    connectedCallback() {
      const t = this.closest(ui.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(di),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${di}`) ||
              this.querySelector(ui.cartDrawerInner).append(t),
            this.classList.add(hi);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(ui.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(ui.shopifySection) ||
        t.target.closest(ui.shopifySection) ||
        t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(hi)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: { target: this },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.classList.add(li),
        this.observeAdditionalCheckoutButtons(),
        ai(this.cartDrawerInner).then(() => {
          _(this, { elementToFocus: this.querySelector(ui.cartDrawerClose) });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(li) &&
        (this.classList.add(ci),
        this.classList.remove(li),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })
        ),
        N(),
        R(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        ai(this.cartDrawerInner).then(() => {
          this.classList.remove(ci);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(pi) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(ui.additionalCheckoutButtons);
      if (t) {
        const e = new MutationObserver(() => {
          _(this, { elementToFocus: this.querySelector(ui.cartDrawerClose) }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(ui.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(ui.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(ui.shopifySection)),
        this.closeCartEvents();
    }
  };
  customElements.get("cart-drawer") || customElements.define("cart-drawer", mi);
  const vi = "[data-collapsible]",
    gi = "[data-collapsible-trigger]",
    fi = "[data-collapsible-body]",
    yi = "[data-collapsible-content]",
    bi = "open",
    wi = "single";
  let Ei = class extends HTMLElement {
    connectedCallback() {
      this.collapsibles.forEach((t) => {
        const e = t.querySelector(gi),
          s = t.querySelector(fi);
        e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
          s.addEventListener("transitionend", (e) => {
            e.target === s &&
              ("true" == t.getAttribute(bi) && this.setBodyHeight(s, "auto"),
              "false" == t.getAttribute(bi) &&
                (t.removeAttribute(bi), this.setBodyHeight(s, "")));
          });
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(fi),
        s = t.querySelector(yi);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(fi),
        s = t.querySelector(yi);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = (
        t.target.matches(gi) ? t.target : t.target.closest(gi)
      ).closest(vi);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(bi) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(bi) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(vi)),
        (this.single = this.hasAttribute(wi));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", Ei);
  const Si = "details",
    Li = "[data-popdown]",
    ki = "[data-popdown-close]",
    Ai = 'input:not([type="hidden"])',
    Ci = "data-popdown-underlay",
    Ti = "is-open";
  let qi = class extends HTMLElement {
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(Ti)
          ? "transform" === t.propertyName &&
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(Ai),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(Ci)) || this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          this.classList.add(Ti);
        });
    }
    close() {
      this.classList.remove(Ti),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(Li)),
        (this.popdownContainer = this.querySelector(Si)),
        (this.popdownClose = this.querySelector(ki)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.a11y = W);
    }
  };
  customElements.define("header-search-popdown", qi);
  const xi = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends X {
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }


      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        y() || this.scrollIntoView({ behavior: "smooth" });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(xi)),
          this.setupEventListeners();
      }
    }
  );
  const Mi = "[data-template-no-shipping]",
    Pi = ".get-rates",
    Ii = "#address_container",
    Hi = "#address_country",
    Oi = "#address_province",
    Bi = "#address_zip",
    Di = "#wrapper-response",
    Fi = "#shipping-calculator-response-template",
    $i = "data-template-no-shipping",
    _i = "data-default",
    Ni = "is-hidden",
    Ri = "error",
    Wi = "center",
    zi = "success",
    Ui = "disabled",
    Vi = "get-rates--trigger",
    ji = "Error : country is not supported.",
    Xi = "We do not ship to this destination.",
    Ji = "Error : ";
  let Yi = class extends HTMLElement {
    connectedCallback() {
      const t = document.querySelector("html");
      let s = "en";
      if (
        (t.hasAttribute("lang") &&
          "" !== t.getAttribute("lang") &&
          (s = t.getAttribute("lang")),
        this.fieldsContainer &&
          e.AddressForm(this.fieldsContainer, s, { shippingCountriesOnly: !0 }),
        this.selectCountry &&
          this.selectCountry.hasAttribute(_i) &&
          this.selectProvince &&
          this.selectProvince.hasAttribute(_i) &&
          this.selectCountry.addEventListener(
            "change",
            this.onCountryChangeEvent
          ),
        this.getRatesButton &&
          (this.getRatesButton.addEventListener(
            "click",
            this.onButtonClickEvent
          ),
          theme.settings.customerLoggedIn &&
            this.getRatesButton.classList.contains(Vi)))
      ) {
        const t = document.querySelector(Bi);
        t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
      }
    }
    disconnectedCallback() {
      this.selectCountry &&
        this.selectCountry.hasAttribute(_i) &&
        this.selectProvince &&
        this.selectProvince.hasAttribute(_i) &&
        this.selectCountry.removeEventListener(
          "change",
          this.onCountryChangeEvent
        ),
        this.getRatesButton &&
          this.getRatesButton.removeEventListener(
            "click",
            this.onButtonClickEvent
          );
    }
    onCountryChange() {
      this.selectCountry.removeAttribute(_i),
        this.selectProvince.removeAttribute(_i);
    }
    onButtonClick() {
      for (this.disableButtons(); this.wrapper.firstChild; )
        this.wrapper.removeChild(this.wrapper.firstChild);
      this.wrapper.classList.add(Ni);
      const t = {};
      let e = this.selectCountry.value,
        s = this.selectProvince.value;
      const i = this.selectCountry.getAttribute(_i);
      "" === e && i && "" !== i && (e = i);
      const o = this.selectProvince.getAttribute(_i);
      "" === s && o && "" !== o && (s = o),
        (t.zip = document.querySelector(Bi).value || ""),
        (t.country = e || ""),
        (t.province = s || ""),
        this.getCartShippingRatesForDestination(t);
    }
    formatRate(t) {
      return "0.00" === t
        ? window.theme.strings.free
        : s.formatMoney(t, theme.moneyFormat);
    }
    render(t) {
      if (this.template && this.wrapper) {
        this.wrapper.innerHTML = "";
        let e = "",
          s = "",
          i = `${Ri} ${Wi}`,
          o = this.template.innerHTML;
        const n = /[^[\]]+(?=])/g;
        if (t.rates && t.rates.length) {
          let s = n.exec(o)[0];
          t.rates.forEach((t) => {
            let i = s;
            (i = i.replace(/\|\|rateName\|\|/, t.name)),
              (i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))),
              (e += i);
          });
        }
        if (t.success) {
          i = `${zi} ${Wi}`;
          const e = document.createElement("div");
          e.innerHTML = this.template.innerHTML;
          const o = e.querySelector(Mi);
          t.rates.length < 1 && o && (s = o.getAttribute($i));
        } else s = t.errorFeedback;
        (o = o.replace(n, "").replace("[]", "")),
          (o = o.replace(/\|\|ratesList\|\|/g, e)),
          (o = o.replace(/\|\|successClass\|\|/g, i)),
          (o = o.replace(/\|\|ratesText\|\|/g, s)),
          (this.wrapper.innerHTML += o),
          this.wrapper.classList.remove(Ni);
      }
    }
    enableButtons() {
      this.getRatesButton.removeAttribute("disabled"),
        this.getRatesButton.classList.remove(Ui),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButton);
    }
    disableButtons() {
      this.getRatesButton.setAttribute("disabled", "disabled"),
        this.getRatesButton.classList.add(Ui),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButtonDisabled);
    }
    getCartShippingRatesForDestination(t) {
      const e = encodeURI(Fe({ shipping_address: t })),
        s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
      fetch(s)
        .then(this.handleErrors)
        .then((t) => t.text())
        .then((e) => {
          const s = JSON.parse(e).shipping_rates;
          this.onCartShippingRatesUpdate(s, t);
        })
        .catch((t) => {
          this.onError(t.json);
        });
    }
    fullMessagesFromErrors(t) {
      const e = [];
      for (const s in t) for (const i of t[s]) e.push(i);
      return e;
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $e({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    onError(t) {
      this.enableButtons();
      let e = "";
      (e = t.message
        ? t.message + "(" + t.status + "): " + t.description
        : Ji + this.fullMessagesFromErrors(t).join("; ")),
        e === ji && (e = Xi),
        this.render({ rates: [], errorFeedback: e, success: !1 });
    }
    onCartShippingRatesUpdate(t, e) {
      this.enableButtons();
      let s = "";
      e.zip && (s += e.zip + ", "),
        e.province && (s += e.province + ", "),
        (s += e.country),
        this.render({ rates: t, address: s, success: !0 });
    }
    constructor() {
      super(),
        (this.getRatesButton = this.querySelector(Pi)),
        (this.fieldsContainer = this.querySelector(Ii)),
        (this.selectCountry = this.querySelector(Hi)),
        (this.selectProvince = this.querySelector(Oi)),
        (this.template = this.querySelector(Fi)),
        (this.wrapper = this.querySelector(Di)),
        (this.onCountryChangeEvent = () => this.onCountryChange()),
        (this.onButtonClickEvent = () => this.onButtonClick());
    }
  };
  customElements.get("shipping-calculator") ||
    customElements.define("shipping-calculator", Yi);
  const Qi = "[data-actions]",
    Gi = "[data-content]",
    Ki = "[data-button]",
    Zi = "data-height",
    to = "is-open",
    eo = "is-enabled";
  let so = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(to);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        eo,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(Zi)),
        (this.content = this.querySelector(Gi)),
        (this.trigger = this.querySelector(Ki)),
        (this.actions = this.querySelector(Qi)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", so);
  const io = ".template-addresses",
    oo = "#AddressNewForm",
    no = ".address-new-toggle",
    ro = ".address-edit-toggle",
    ao = ".address-delete",
    lo = "data-form-id",
    co = "data-confirm-message",
    ho = "#EditAddress",
    uo = "AddressCountryNew",
    po = "AddressProvinceNew",
    mo = "AddressProvinceContainerNew",
    vo = ".address-country-option",
    go = "AddressCountry",
    fo = "AddressProvince",
    yo = "AddressProvinceContainer",
    bo = "hidden";
  const wo = document.querySelector(io);
  wo &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const s = t.querySelectorAll(no);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(bo);
              });
            });
          const i = t.querySelectorAll(ro);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(lo);
                t.querySelector(`${ho}_${e}`).classList.toggle(bo);
              });
            });
          const o = t.querySelectorAll(ao);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(lo),
                  e = this.getAttribute(co);
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(uo, po, { hideElement: mo }),
          this.section.querySelectorAll(vo).forEach((t) => {
            const e = t.getAttribute(lo),
              s = `${go}_${e}`,
              i = `${fo}_${e}`,
              o = `${yo}_${e}`;
            new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
          });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(oo)),
          this.init();
      }
    })(wo);
  const Eo = ".customer-logged-in",
    So = ".account",
    Lo = ".account-sidebar--mobile";
  const ko = document.querySelector(Eo);
  ko &&
    new (class {
      init() {
        this.section.querySelector(So) && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(Lo) &&
          this.section.querySelector(Lo).addEventListener("click", function () {
            const t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(ko);
  const Ao = "[data-account-form]",
    Co = "[data-show-reset]",
    To = "[data-hide-reset]",
    qo = "[data-recover-password]",
    xo = "[data-recover-success]",
    Mo = "[data-login-form]",
    Po = "#recover",
    Io = "is-hidden";
  const Ho = document.querySelector(Ao);
  Ho &&
    new (class {
      init() {
        window.location.hash == Po || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(Io),
          this.recover.classList.remove(Io),
          (window.location.hash = Po),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(Io),
          this.login.classList.remove(Io),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(Co)),
          (this.hideButton = t.querySelector(To)),
          (this.recover = t.querySelector(qo)),
          (this.recoverSuccess = t.querySelector(xo)),
          (this.login = t.querySelector(Mo)),
          this.init();
      }
    })(Ho),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const Oo = window.Shopify.theme.sections.registered,
    Bo = window.Shopify.theme.sections.instances,
    Do = "data-section-id",
    Fo = "data-section-type";
  let $o = class {
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = { id: this.id, type: this.type, container: this.container };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(Do))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              Do +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(Do)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
  };
  function _o(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== Oo[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, s] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof s
                ? t.push(s)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    })(t, e);
    return (Oo[t] = s), Oo;
  }
  function No(t, e) {
    (t = zo(t)),
      void 0 === e && (e = document.querySelectorAll("[" + Fo + "]")),
      (e = Uo(e)),
      t.forEach(function (t) {
        const s = Oo[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(Ro(e).length > 0) &&
              null !== e.getAttribute(Fo) &&
              (e.getAttribute(Fo) !== t || (Bo.push(new $o(e, s)), !1))
            );
          }));
      });
  }
  function Ro(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      Uo(t).forEach(function (t) {
        e = e.concat(
          Bo.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      zo(t).forEach(function (t) {
        e = e.concat(
          Bo.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function Wo(t) {
    for (var e, s = 0; s < Bo.length; s++)
      if (Bo[s].id === t) {
        e = Bo[s];
        break;
      }
    return e;
  }
  function zo(t) {
    return (
      "*" === t
        ? (t = Object.keys(Oo))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === $o
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === $o &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function Uo(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Do + '="' + e + '"]');
      null !== s && No(s.getAttribute(Fo), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Do + '="' + e + '"]');
      "object" == typeof Ro(s)[0] &&
        Ro(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Do + '="' + e + '"]');
      "object" == typeof Ro(s)[0] &&
        Ro(s).forEach(function (t) {
          var e = Bo.map(function (t) {
            return t.id;
          }).indexOf(t.id);
          Bo.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = Wo(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = Wo(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = Wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = Wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Vo = "data-tooltip",
    jo = "data-tooltip-stop-mouseenter",
    Xo = "tooltip-default",
    Jo = "is-visible",
    Yo = "is-hiding";
  let Qo = {},
    Go = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        const e = document.querySelector(`.${this.class}`);
        if (this.label && e && ((t && !this.tooltip.hasAttribute(jo)) || !t)) {
          const t = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).innerHTML = this.label;
          const i = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            n = o.top,
            r = o.width,
            a = n + o.height + window.scrollY;
          let l = o.left - i / 2 + r / 2;
          const c = 24,
            h = l + i - g() + c;
          h > 0 && (l -= h),
            l < 0 && (l = 0),
            (t.style.left = `${o.left + r / 2}px`),
            e.style.setProperty("--tooltip-top", `${a}px`),
            (s.style.transform = `translateX(${l}px)`),
            e.classList.remove(Yo),
            e.classList.add(Jo),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(Jo);
        i &&
          ((e && !this.tooltip.hasAttribute(jo)) || !e) &&
          (o &&
            (s || t.detail.hideTransition) &&
            (i.classList.add(Yo),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(Yo);
            }, this.transitionSpeed))),
          i.classList.remove(Jo),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(Vo) &&
            ((this.label = this.tooltip.getAttribute(Vo)),
            (this.class = e.class || Xo),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => We(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    };
  const Ko = {
    onLoad() {
      Qo[this.id] = [];
      this.container.querySelectorAll(`[${Vo}]`).forEach((t) => {
        Qo[this.id].push(new Go(t));
      });
    },
    onUnload: function () {
      Qo[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var Zo = {};
  const tn = {
    onLoad() {
      Zo[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const e = t.querySelector("[data-parallax-img]");
          Zo[this.id].push(new i(e, { center: !0, round: !0, frame: t }));
        }),
        window.addEventListener("load", () => {
          Zo[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      Zo[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  _o("article", [Ko, tn]);
  const en = "[data-aos]",
    sn = ".collection-item__image",
    on = "[data-column-image]",
    nn = ".flickity-button.next",
    rn = ".flickity-button.previous",
    an = "a:not(.btn)",
    ln = ".product-item__image",
    cn = "[data-slide]",
    hn = "data-slide",
    dn = "[data-slider]",
    un = "[data-slider-thumb]",
    pn = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    mn = "aos-animate",
    vn = "desktop",
    gn = "is-focused",
    fn = "flickity-enabled",
    yn = "is-initialized",
    bn = "is-loading",
    wn = "is-selected",
    En = "mobile",
    Sn = "single-slide",
    Ln = "js-slider--initialized",
    kn = {};
  let An = class {
    init() {
      this.slideshow.classList.add(bn);
      let t = cn;
      const e = y(),
        s = `${cn}:not(.${En})`,
        i = `${cn}:not(.${vn})`;
      (this.slideshow.querySelectorAll(i).length ||
        this.slideshow.querySelectorAll(s).length) &&
        (t = e ? s : i),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(Sn),
          this.slideshow.classList.remove(bn)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(yn),
                  this.slideshow.classList.remove(bn),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(en);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(mn),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(mn);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new n(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new o(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(bn);
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${wn}`);
      if (!e) return;
      const s = e.hasAttribute(pn.slideTextColor)
          ? e.getAttribute(pn.slideTextColor)
          : "",
        i = e.querySelector(an),
        o = this.slideshow.querySelectorAll(`${cn} a, ${cn} button`);
      if (
        (document.body.classList.contains(gn) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(cn);
            if (e) {
              const s = e.classList.contains(wn) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(pn.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(pn.slideIndex)),
          s = this.container.querySelector(`${un}.${wn}`);
        s && s.classList.remove(wn), this.sliderThumbs[t].classList.add(wn);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(pn.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(sn) ||
          this.slideshow.querySelector(ln) ||
          this.slideshow.querySelector(on);
        if (!t) return;
        (this.slideshow.querySelector(rn).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(nn).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${hn}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(pn.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(Ln) && (s = 0),
        this.slideshow.classList.add(wn),
        this.flkty &&
          this.slideshow.classList.contains(fn) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(wn),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(dn)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(cn)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(un)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              pn.slidesLargeDesktop
            )),
            this.slideshow.hasAttribute(pn.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(pn.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const Cn = {
    onLoad() {
      kn[this.id] = [];
      this.container.querySelectorAll(dn).forEach((t) => {
        kn[this.id].push(new An(this.container, t));
      });
    },
    onUnload() {
      kn[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      kn[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      kn[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  _o("blog-section", [Cn]), _o("hero", tn), _o("double", Cn);
  const Tn = (t) => {
    let { stickyHeaderHeight: e } = c();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  let qn = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
  };
  const xn = "[data-newsletter-form]",
    Mn = "[data-newsletter-heading]",
    Pn = "[data-newsletter]",
    In = "has-success",
    Hn = "has-error",
    On = "hidden",
    Bn = "data-cookie-name",
    Dn = {};
  const Fn = {
    onLoad() {
      Dn[this.id] = [];
      this.container.querySelectorAll(xn).forEach((t) => {
        Dn[this.id].push(
          new (class {
            init() {
              this.newsletter.addEventListener("submit", this.newsletterSubmit),
                this.showMessage();
            }
            newsletterSubmitEvent(t) {
              this.stopSubmit &&
                (t.preventDefault(),
                t.stopImmediatePropagation(),
                this.removeStorage(),
                this.writeStorage(),
                (this.stopSubmit = !1),
                this.newsletter.submit());
            }
            checkForChallengePage() {
              this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "newsletter_form_id",
                  this.newsletter.id
                );
            }
            readStorage() {
              this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
              this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
              if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const t = document.getElementById(this.formID),
                  e = t.parentElement.querySelector(Mn),
                  s =
                    -1 !==
                    window.location.search.indexOf("?customer_posted=true"),
                  i =
                    -1 !== window.location.search.indexOf("accepts_marketing");
                s
                  ? (t.classList.remove(Hn),
                    t.classList.add(In),
                    e && (e.classList.add(On), t.classList.remove(On)),
                    this.popup && this.cookie.write())
                  : i &&
                    (t.classList.remove(In),
                    t.classList.add(Hn),
                    e && (e.classList.add(On), t.classList.remove(On))),
                  (s || i) &&
                    window.addEventListener("load", () => {
                      this.scrollToForm(t);
                    });
              }
            }
            scrollToForm(t) {
              const e = t.getBoundingClientRect();
              (e.top >= 0 &&
                e.left >= 0 &&
                e.bottom <= f() &&
                e.right <= g()) ||
                setTimeout(() => {
                  Tn(t.getBoundingClientRect().top);
                }, 500);
            }
            unload() {
              this.newsletter.removeEventListener(
                "submit",
                this.newsletterSubmit
              );
            }
            constructor(t) {
              (this.sessionStorage = window.sessionStorage),
                (this.newsletter = t),
                (this.popup = this.newsletter.closest(Pn)),
                this.popup &&
                  (this.cookie = new qn(
                    this.popup.getAttribute(Bn),
                    "user_has_closed",
                    null
                  )),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                this.isChallengePage || this.init();
            }
          })(t)
        );
      });
    },
    onUnload() {
      Dn[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  _o("footer", [tn, Fn]);
  const $n = "[data-section-type]",
    _n = "[data-collection-sidebar]",
    Nn = "[data-collection-sidebar-slide-out]",
    Rn = "[data-collection-sidebar-close]",
    Wn = "[data-collection-filters-form]",
    zn = "input",
    Un = "select",
    Vn = "label",
    jn = "textarea",
    Xn = "[data-field-price-min]",
    Jn = "[data-field-price-max]",
    Yn = "data-field-price-min",
    Qn = "data-field-price-max",
    Gn = "[data-se-min-value]",
    Kn = "[data-se-max-value]",
    Zn = "data-se-min-value",
    tr = "data-se-max-value",
    er = "data-se-min",
    sr = "data-se-max",
    ir = "[data-show-more]",
    or = "[data-link-hidden]",
    nr = "[data-collection-nav]",
    rr = "[data-products-grid]",
    ar = "[data-active-filters]",
    lr = "data-active-filters-count",
    cr = "[data-filter-update-url]",
    hr = "[data-sort-enabled]",
    dr = "[data-sort-link]",
    ur = "data-value",
    pr = "[data-popout-toggle]",
    mr = "[data-sort-button-text]",
    vr = "[data-results-count]",
    gr = "hidden",
    fr = "is-focused",
    yr = "is-loading",
    br = "is-active";
  let wr = class extends HTMLElement {
    connectedCallback() {
      this.sort &&
        this.sortLinks.length &&
        this.sortLinks.forEach((t) => {
          t.addEventListener("click", this.onSortButtonClickEvent);
        }),
        this.collectionSidebar &&
          this.form &&
          (this.collectionSidebar.addEventListener(
            "input",
            this.updatePriceEvent
          ),
          this.collectionSidebar.addEventListener(
            "theme:range:update",
            this.updateRangeEvent
          )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.addEventListener("click", this.showMoreEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.addEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.addEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.addEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    collectionSidebarClose(t) {
      t.preventDefault(),
        this.container.dispatchEvent(
          new CustomEvent("theme:filter:close", { bubbles: !1 })
        );
    }
    onSortButtonClick(t) {
      t.preventDefault(),
        this.sortButton && this.sortButton.dispatchEvent(new Event("click")),
        this.sortActions(t, t.currentTarget);
    }
    sortActions(t, e, s = !0) {
      const i = this.sort.querySelector(mr),
        o = this.sort.querySelector(`.${br}`);
      if (i) {
        const t = e ? e.textContent.trim() : "";
        i.textContent = t;
      }
      o && o.classList.remove(br),
        this.sort.classList.toggle(br, e),
        e && (e.parentElement.classList.add(br), s && this.submitForm(t));
    }
    onSortCheck(t) {
      let e = null;
      if (window.location.search.includes("sort_by")) {
        const t = new window.URL(window.location.href).searchParams;
        for (const [s, i] of t.entries()) {
          const t = this.sort.querySelector(`[${ur}="${i}"]`);
          if (s.includes("sort_by") && t) {
            e = t;
            break;
          }
        }
      }
      this.sortActions(t, e, !1);
    }
    showMore(t) {
      t.preventDefault();
      const e = t.target.matches(ir) ? t.target : t.target.closest(ir);
      e.parentElement.classList.add(gr),
        e.parentElement.previousElementSibling
          .querySelectorAll(or)
          .forEach((t, e) => {
            t.classList.remove(gr);
            const s = t.querySelector(zn);
            0 === e &&
              document.body.classList.contains(fr) &&
              s &&
              (this.collectionSidebarSlideOut || b()
                ? (this.a11y.removeTrapFocus(),
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: s,
                  }))
                : s.focus());
          });
    }
    updatePrice(t) {
      const e = t.type,
        s = t.target;
      if (
        (e === zn || e === Un || e === Vn || e === jn) &&
        this.form &&
        "function" == typeof this.form.submit
      ) {
        const e = this.form.querySelector(Xn),
          i = this.form.querySelector(Jn);
        e &&
          i &&
          (s.hasAttribute(Yn) && !i.value
            ? (i.value = i.placeholder)
            : s.hasAttribute(Qn) && !e.value && (e.value = e.placeholder)),
          this.submitForm(t);
      }
    }
    updateRange(t) {
      if (this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(Gn),
          s = this.form.querySelector(Kn),
          i = this.form.querySelector(Xn),
          o = this.form.querySelector(Jn);
        if (e && s && i && o && e.hasAttribute(Zn) && s.hasAttribute(tr)) {
          const n = parseInt(i.placeholder),
            r = parseInt(o.placeholder),
            a = parseInt(e.getAttribute(Zn)),
            l = parseInt(s.getAttribute(tr));
          (n === a && r === l) ||
            ((i.value = a), (o.value = l), this.submitForm(t));
        }
      }
    }
    filterUpdateFromUrl(t) {
      t.preventDefault(),
        this.submitForm(t, t.currentTarget.getAttribute("href"));
    }
    submitForm(t, e = "") {
      if (!t || (t && "popstate" !== t.type))
        if ("" === e) {
          let t = new window.URL(window.location.href).searchParams;
          const e = t,
            s = Object.fromEntries(e),
            i = t.toString();
          if (
            i.includes("filter.") ||
            i.includes("page=") ||
            i.includes("sort_by=")
          )
            for (const e in s)
              (e.includes("filter.") || "page" === e || "sort_by" === e) &&
                t.delete(e);
          if (this.form) {
            const e = new FormData(this.form),
              s = new URLSearchParams(e),
              i = this.form.querySelector(Gn),
              o = this.form.querySelector(Kn),
              n = i && i.hasAttribute(er) ? i.getAttribute(er) : "",
              r = o && o.hasAttribute(sr) ? o.getAttribute(sr) : "";
            let a = 0;
            for (let [e, i] of s.entries())
              ((e.includes("filter.") && i) || (e.includes("sort_by") && i)) &&
                (t.append(e, i),
                ((i === n && "filter.v.price.gte" === e) ||
                  (i === r && "filter.v.price.lte" === e)) &&
                  (a += 1));
            2 === a &&
              (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
          }
          const o = t.toString(),
            n = o ? `?${o}` : location.pathname;
          window.history.pushState(null, "", n);
        } else window.history.pushState(null, "", e);
      else this.sort && this.onSortCheck(t);
      this.productsContainer &&
        (this.productsContainer.classList.add(yr),
        fetch(`${window.location.pathname}${window.location.search}`)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html"),
              s = this.container.querySelector(vr);
            if (s) {
              const t = e.querySelector(vr);
              s.innerHTML = t.innerHTML;
            }
            if (
              ((this.productsContainer.innerHTML =
                e.querySelector(rr).innerHTML),
              this.collectionSidebar)
            ) {
              this.collectionSidebar.innerHTML = e.querySelector(_n).innerHTML;
              const t = this.collectionSidebar.querySelector(`[${lr}]`),
                s = this.container.querySelectorAll(ar);
              if (t && s.length) {
                const e = parseInt(t.getAttribute(lr));
                s.forEach((t) => {
                  (t.textContent = e), t.classList.toggle(gr, e < 1);
                });
              }
            }
            this.collectionNav &&
              Tn(
                this.productsContainer.getBoundingClientRect().top -
                  this.collectionNav.offsetHeight
              ),
              setTimeout(() => {
                this.productsContainer.classList.remove(yr);
              }, 500);
          })
          .catch((t) => {
            console.log(t);
          }));
    }
    disconnectedCallback() {
      this.collectionSidebar &&
        this.form &&
        (this.collectionSidebar.removeEventListener(
          "input",
          this.updatePriceEvent
        ),
        this.collectionSidebar.removeEventListener(
          "theme:range:update",
          this.updateRangeEvent
        )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.removeEventListener("click", this.showMoreEvent);
          }),
        this.sort &&
          this.sortLinks.length &&
          this.sortLinks.forEach((t) => {
            t.removeEventListener("click", this.onSortButtonClickEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.removeEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.removeEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.removeEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    constructor() {
      super(),
        (this.container = this.closest($n)),
        (this.collectionSidebar = this.container.querySelector(_n)),
        (this.collectionSidebarSlideOut = this.container.querySelector(Nn)),
        (this.form = this.querySelector(Wn)),
        (this.productsContainer = this.container.querySelector(rr)),
        (this.collectionNav = this.container.querySelector(nr)),
        (this.sort = this.container.querySelector(hr)),
        (this.sortButton = this.container.querySelector(pr)),
        (this.sortLinks = this.container.querySelectorAll(dr)),
        (this.filterUrlButtons = this.container.querySelectorAll(cr)),
        (this.collectionSidebarCloseButtons =
          this.container.querySelectorAll(Rn)),
        (this.showMoreOptions = this.querySelectorAll(ir)),
        (this.a11y = W),
        (this.updatePriceEvent = v((t) => this.updatePrice(t), 500)),
        (this.updateRangeEvent = (t) => this.updateRange(t)),
        (this.showMoreEvent = (t) => this.showMore(t)),
        (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
        (this.submitFormEvent = (t) => this.submitForm(t)),
        (this.collectionSidebarCloseEvent = (t) =>
          this.collectionSidebarClose(t)),
        (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t));
    }
  };
  const Er = "[data-collection-sidebar]",
    Sr = "[data-range-left]",
    Lr = "[data-range-right]",
    kr = "[data-range-line]",
    Ar = "[data-range-holder]",
    Cr = "data-se-min",
    Tr = "data-se-max",
    qr = "data-se-min-value",
    xr = "data-se-max-value",
    Mr = "data-se-step",
    Pr = "data-range-filter-update",
    Ir = "[data-field-price-min]",
    Hr = "[data-field-price-max]",
    Or = "is-initialized";
  let Br = class extends HTMLElement {
    connectedCallback() {
      let t = this.min;
      this.hasAttribute(qr) && (t = parseFloat(this.getAttribute(qr)));
      let e = this.max;
      this.hasAttribute(xr) && (e = parseFloat(this.getAttribute(xr))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.getAttribute(Mr) &&
          (this.step = Math.abs(parseFloat(this.getAttribute(Mr)))),
        this.reset(),
        (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.classList.add(Or);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(qr, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(xr, t);
    }
    onStart(t) {
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : t.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.getAttribute("on-change"))
      ) {
        new Function("min, max", this.getAttribute("on-change"))(
          this.getAttribute(qr),
          this.getAttribute(xr)
        );
      }
      this.onChange(this.getAttribute(qr), this.getAttribute(xr));
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(this.getAttribute(qr), this.getAttribute(xr));
    }
    onChange(t, e) {
      const s = this.closest(Ar);
      if (s) {
        const i = s.querySelector(Ir),
          o = s.querySelector(Hr);
        i && o && ((i.value = t), (o.value = e));
      }
    }
    onChanged(t, e) {
      this.hasAttribute(Pr) &&
        this.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        s = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(s / this.step)),
          (s = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.setAttribute(qr, e),
        this.selectedTouch === this.touchRight && this.setAttribute(xr, s);
    }
    onSidebarTransitionEnd(t) {
      t.target == this.sidebar &&
        "min-width" == t.propertyName &&
        (this.sidebar.removeEventListener(
          "transitionend",
          this.sidebarTransitionEvent
        ),
        this.connectedCallback());
    }
    disconnectedCallback() {
      this.sidebar.removeEventListener(
        "transitionend",
        this.sidebarTransitionEvent
      ),
        this.resizeEvent &&
          document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.sidebar = this.closest(Er)),
        (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
        (this.resizeEvent = () => {
          this.connectedCallback(),
            this.sidebar.addEventListener(
              "transitionend",
              this.sidebarTransitionEvent
            );
        }),
        (this.onMoveEvent = (t) => this.onMove(t)),
        (this.onStopEvent = (t) => this.onStop(t)),
        (this.onStartEvent = (t) => this.onStart(t)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.querySelector(Sr)),
        (this.touchRight = this.querySelector(Lr)),
        (this.lineSpan = this.querySelector(kr)),
        (this.min = parseFloat(this.getAttribute(Cr))),
        (this.max = parseFloat(this.getAttribute(Tr))),
        (this.step = 0),
        (this.normalizeFact = 26),
        document.addEventListener("theme:resize:width", this.resizeEvent);
    }
  };
  const Dr = "[data-collection-sidebar]",
    Fr = "[data-collection-sidebar-slide-out]",
    $r = "[data-collection-sidebar-close]",
    _r = "[data-aria-toggle]",
    Nr = "drawer--animated",
    Rr = "expanded",
    Wr = "no-mobile-animation",
    zr = "is-focused";
  let Ur = {};
  _o("collection", [
    Cn,
    tn,
    {
      onLoad() {
        Ur[this.id] = new (class {
          init() {
            null !== this.groupTagsButton &&
              (document.addEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.addEventListener(
                "click",
                this.groupTagsButtonClickEvent
              ),
              this.collectionSidebar &&
                setTimeout(() => {
                  this.collectionSidebar.classList.remove(Wr);
                }, 1e3),
              new MutationObserver((t) => {
                for (const e of t)
                  "attributes" === e.type &&
                    "true" == e.target.getAttribute("aria-expanded") &&
                    this.showSidebarCallback();
              }).observe(this.groupTagsButton, {
                attributes: !0,
                childList: !1,
                subtree: !1,
              })),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(Rr) ||
                      this.collectionSidebar.classList.remove(Nr);
                  }
                ),
                this.toggleSidebarSlider(),
                this.container.addEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                ));
          }
          showSidebarCallback() {
            const t = this.container.querySelector(Fr),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              s = b();
            this.collectionSidebar.classList.add(Nr),
              null === t &&
                !s &&
                e &&
                (this.a11y.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                )),
              (s || null !== t) &&
                (t &&
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector($r),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
          }
          hideSidebar() {
            const t = this.container.querySelector(Fr),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(Rr),
              t && this.a11y.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }
          toggleSidebarSlider() {
            b()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(Rr) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains(zr) &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebar &&
                this.container.removeEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.collectionSidebar = this.container.querySelector(Dr)),
              (this.groupTagsButton = this.container.querySelector(_r)),
              (this.a11y = W),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              this.init();
          }
        })(this);
      },
      onUnload() {
        Ur[this.id].onUnload();
      },
    },
    Ko,
  ]),
    customElements.get("collection-filters-form") ||
      customElements.define("collection-filters-form", wr),
    customElements.get("range-slider") ||
      customElements.define("range-slider", Br);
  const Vr = "[data-ticker-scale]",
    jr = "[data-ticker-text]",
    Xr = "data-clone",
    Jr = "autoplay",
    Yr = "speed",
    Qr = "ticker--animated",
    Gr = "ticker--unloaded",
    Kr = "ticker__comparitor",
    Zr = 1.63,
    ta = 100;
  let ea = class extends HTMLElement {
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener(
          "theme:ticker:refresh",
          v(() => this.checkWidthEvent(), 50)
        ),
        screen.orientation.addEventListener("change", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      this.text = this.querySelector(jr);
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
        e = this.clientWidth - t < this.comparitor.clientWidth;
      if (e || this.autoplay) {
        var s;
        this.text.classList.remove(Qr);
        const i = this.scale.querySelectorAll(`[${Xr}]`),
          o = this.autoplay
            ? parseInt((window.innerWidth - t) / this.text.clientWidth)
            : 2;
        if (
          (null == i ||
            i.forEach((t) => {
              t.remove();
            }),
          this.autoplay || e)
        )
          for (let t = 0; t <= o; t++) {
            const t = this.text.cloneNode(!0);
            t.setAttribute(Xr, ""), this.scale.appendChild(t);
          }
        const n = ((this.text.clientWidth / ta) * Number(this.speed)).toFixed(
          2
        );
        this.scale.style.removeProperty("--animation-time"),
          this.scale.style.setProperty("--animation-time", `${n}s`),
          null === (s = this.scale.querySelectorAll(jr)) ||
            void 0 === s ||
            s.forEach((t) => {
              t.classList.add(Qr);
            });
      } else {
        this.text.classList.add(Qr);
        this.scale.querySelectorAll(`[${Xr}]`).forEach((t) => {
          t.parentNode.removeChild(t);
        }),
          this.text.classList.remove(Qr);
      }
    }
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(Jr)),
        (this.scale = this.querySelector(Vr)),
        (this.text = this.querySelector(jr)),
        (this.speed = this.hasAttribute(Yr) ? this.getAttribute(Yr) : Zr),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(Kr),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(Gr),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
  };
  const sa = {
      marquee: ".announcement__bar-holder--marquee",
      slide: "[data-slide]",
      slider: "[data-slider]",
      ticker: "ticker-bar",
      tickerSlide: ".announcement__slide",
    },
    ia = "hidden";
  let oa = class extends HTMLElement {
    connectedCallback() {
      this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        this.addEventListener("theme:countdown:hide", (t) => {
          if (window.Shopify.designMode) return;
          const e = t.target.closest(sa.marquee);
          if (1 === this.slidesCount) {
            this.querySelector(sa.ticker).style.display = "none";
          }
          if (e) {
            const e = t.target.closest(sa.tickerSlide);
            this.removeTickerText(e);
          } else {
            const e = t.target.closest(sa.slide);
            this.removeSlide(e);
          }
        }),
        this.addEventListener("theme:countdown:expire", () => {
          var t;
          null === (t = this.querySelectorAll(sa.ticker)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          var t;
          null === (t = this.querySelectorAll(sa.tickerBar)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        });
    }
    initSlider() {
      const t = y(),
        e = !t;
      var s, i;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new An(this, this.querySelector(sa.slider))),
        null === (i = this.slider.flkty) || void 0 === i || i.reposition());
    }
    removeSlide(t) {
      var e, s;
      null === (e = this.slider.flkty) || void 0 === e || e.remove(t),
        0 ===
          (null === (s = this.slider.flkty) || void 0 === s
            ? void 0
            : s.cells.length) && this.section.classList.add(ia);
    }
    removeTickerText(t) {
      const e = t.closest(sa.ticker);
      t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
    constructor() {
      super(),
        (this.slider = this.querySelector(sa.slider)),
        (this.enableSlider = y()),
        (this.slidesCount = this.querySelectorAll(sa.tickerSlide).length),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
  };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", oa),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", ea);
  const na = "body",
    ra = "[data-drawer]",
    aa = "[data-drawer-inner]",
    la = "[data-drawer-underlay]",
    ca = "[data-stagger-animation]",
    ha = "[data-header-wrapper]",
    da = "data-drawer-toggle",
    ua = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    pa = "drawer--animated",
    ma = "is-open",
    va = "is-closing",
    ga = "is-focused";
  let fa = {};
  const ya = {
      onLoad() {
        fa[this.id] = [];
        this.container.querySelectorAll(ra).forEach((t) => {
          fa[this.id].push(
            new (class {
              connectToggle() {
                this.buttons.forEach((t) => {
                  t.addEventListener("click", () => {
                    this.drawer.dispatchEvent(
                      new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
                    );
                  });
                });
              }
              connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                  this.drawer.classList.contains(ma)
                    ? this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:close", { bubbles: !0 })
                      )
                    : this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:open", { bubbles: !0 })
                      );
                }),
                  document.addEventListener(
                    "theme:cart-drawer:open",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              closers() {
                this.wrapper.addEventListener("keyup", (t) => {
                  "Escape" === t.code && this.hideDrawer();
                }),
                  this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                  });
              }
              showDrawer() {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !0);
                  }),
                  this.drawer.classList.add(ma, pa),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                  ),
                  this.drawerInner &&
                    this.drawerInner.querySelector(this.btnSelector) &&
                    (N(),
                    ai(this.drawerInner).then(() => {
                      this.drawer.querySelector(ua).focus(),
                        (this.isAnimating = !1),
                        _(this.drawerInner, {
                          elementToFocus: this.drawerInner.querySelector(
                            this.btnSelector
                          ),
                        });
                    })));
              }
              hideDrawer() {
                this.drawer.classList.contains(ma) &&
                  !this.isAnimating &&
                  ((this.isAnimating = !0),
                  this.drawer.classList.add(va),
                  this.drawer.classList.remove(ma),
                  N(),
                  this.body.classList.contains(ga) &&
                    this.buttons.length &&
                    this.buttons[0].focus(),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !1);
                  }),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  ),
                  ai(this.drawerInner).then(() => {
                    this.drawer.classList.remove(va, pa),
                      (this.isAnimating = !1),
                      document.dispatchEvent(
                        new CustomEvent("theme:sliderule:close", {
                          bubbles: !1,
                        })
                      );
                  }));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:cart-drawer:open",
                  this.hideDrawer
                ),
                  document.removeEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.removeEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              constructor(t) {
                (this.isAnimating = !1),
                  (this.drawer = t),
                  (this.drawerWrapper = this.drawer.closest(ra)),
                  (this.drawerInner = this.drawer.querySelector(aa)),
                  (this.underlay = this.drawer.querySelector(la)),
                  (this.wrapper = this.drawer.closest(ha)),
                  (this.key = this.drawer.dataset.drawer),
                  (this.btnSelector = `[${da}='${this.key}']`),
                  (this.buttons = document.querySelectorAll(this.btnSelector)),
                  (this.staggers = this.drawer.querySelectorAll(ca)),
                  (this.body = document.querySelector(na)),
                  (this.showDrawer = this.showDrawer.bind(this)),
                  (this.hideDrawer = this.hideDrawer.bind(this)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers();
              }
            })(t)
          );
        });
      },
      onUnload() {
        fa[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    ba = ".page-header",
    wa = "js__header__stuck",
    Ea = "has-header-sticky",
    Sa = "shopify-section-group-header-group",
    La = "data-header-sticky",
    ka = "data-scroll-locked";
  let Aa = {};
  const Ca = {
      onLoad() {
        Aa = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains(Sa) &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(ba)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(wa), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute(ka) ||
              (this.cls.remove(wa), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute(La)),
              document.body.classList.toggle(Ea, this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(ba)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof Aa.unload && Aa.unload();
      },
    },
    Ta = "data-hover-disclosure-toggle",
    qa = "[data-hover-disclosure]",
    xa = "[data-top-link]",
    Ma = "[data-header-wrapper]",
    Pa = "[data-stagger]",
    Ia = "[data-stagger-first]",
    Ha = "[data-stagger-second]",
    Oa = "is-visible",
    Ba = "meganav--visible",
    Da = "meganav--is-transitioning";
  let Fa = {},
    $a = {};
  const _a = {
      onLoad() {
        (Fa[this.id] = []),
          ($a = this.container.querySelectorAll(qa)),
          $a.forEach((t) => {
            Fa[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(Da),
                    this.grandparent
                      ? this.wrapper.classList.add(Ba)
                      : this.wrapper.classList.remove(Ba),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(Oa),
                    this.disclosure.classList.add(Oa),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(Da);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(Oa),
                    this.trigger.classList.remove(Oa),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(Ba, Da);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(Pa).forEach((t, e) => {
                    t.style.transitionDelay = 50 * e + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(Ia).forEach((t, e) => {
                      const s = 100 * e;
                      (t.style.transitionDelay = `${s}ms`),
                        t.parentElement.querySelectorAll(Ha).forEach((t, e) => {
                          const i = 20 * (e + 1);
                          t.style.transitionDelay = `${s + i}ms`;
                        });
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(Oa) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest(Ma)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[${Ta}='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector(xa)),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        Fa[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Fa[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    Na = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    Ra = "is-visible",
    Wa = "is-hiding",
    za = "is-hidden",
    Ua = "is-focused",
    Va = "is-scrolling";
  let ja = {};
  const Xa = {
      onLoad() {
        ja[this.id] = [];
        this.container.querySelectorAll(Na.slideruleWrappper).forEach((t) => {
          ja[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener("click", () => {
                  (this.cachedButton = this.trigger), this.showSliderule();
                }),
                  this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.hideSliderule();
                    });
                  });
              }
              keyboardEvents() {
                this.sliderule.addEventListener("keyup", (t) => {
                  t.stopPropagation(),
                    "Escape" === t.code && this.hideSliderule();
                });
              }
              trapFocusSliderule(t = !0) {
                const e = t
                  ? this.sliderule.querySelector(this.exitSelector)
                  : this.cachedButton;
                this.accessibility.removeTrapFocus(),
                  e &&
                    this.drawerContent &&
                    this.accessibility.trapFocus(this.drawerContent, {
                      elementToFocus: document.body.classList.contains(Ua)
                        ? e
                        : null,
                    });
              }
              hideSliderule(t = !1) {
                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(Na.sliderulePane, e),
                  this.pane.classList.add(Wa),
                  this.sliderule.classList.add(Wa);
                const s = t
                    ? `[${Na.dataAnimates}].${za}`
                    : `[${Na.dataAnimates}="${e}"]`,
                  i = this.pane.querySelectorAll(s);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(za);
                  });
                const o = t
                  ? this.pane.querySelectorAll(`.${Ra}, .${Wa}`)
                  : this.children;
                o.forEach((s, i) => {
                  const n = o.length - 1 == i;
                  s.classList.remove(Ra),
                    t &&
                      (s.classList.remove(Wa), this.pane.classList.remove(Wa));
                  const r = () => {
                    parseInt(this.pane.getAttribute(Na.sliderulePane)) === e &&
                      this.sliderule.classList.remove(Ra),
                      this.sliderule.classList.remove(Wa),
                      this.pane.classList.remove(Wa),
                      n &&
                        (this.accessibility.removeTrapFocus(),
                        t || this.trapFocusSliderule(!1)),
                      s.removeEventListener("animationend", r);
                  };
                  window.theme.settings.enableAnimations
                    ? s.addEventListener("animationend", r)
                    : r();
                });
              }
              showSliderule() {
                let t = null;
                const e = this.sliderule.closest(`.${Ra}`);
                let s = this.pane;
                e && (s = e),
                  s.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                  s.classList.add(Va);
                const i = () => {
                  s.scrollTop <= 0
                    ? (s.classList.remove(Va), t && cancelAnimationFrame(t))
                    : (t = requestAnimationFrame(i));
                };
                (t = requestAnimationFrame(i)),
                  this.sliderule.classList.add(Ra);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                  n = o + 1;
                this.pane.setAttribute(Na.sliderulePane, n);
                const r = this.pane.querySelectorAll(
                  `[${Na.dataAnimates}="${o}"]`
                );
                r.length &&
                  r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(Wa);
                    const i = () => {
                      t.classList.remove(Wa),
                        parseInt(this.pane.getAttribute(Na.sliderulePane)) !==
                          o && t.classList.add(za),
                        s && this.trapFocusSliderule(),
                        t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations
                      ? t.addEventListener("animationend", i)
                      : i();
                  });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(Na.sliderulePane) &&
                  parseInt(this.pane.getAttribute(Na.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(Na.sliderulePane)) > 0 &&
                    this.pane.setAttribute(Na.sliderulePane, 0));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:sliderule:close",
                  this.closeSliderule
                );
              }
              constructor(t) {
                (this.sliderule = t), (this.key = this.sliderule.id);
                const e = `[${Na.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${Na.slideruleClose}='${this.key}']`),
                  (this.trigger = document.querySelector(e)),
                  (this.exit = document.querySelectorAll(this.exitSelector)),
                  (this.pane = document.querySelector(`[${Na.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    Na.children
                  )),
                  (this.drawerContent = document.querySelector(
                    Na.drawerContent
                  )),
                  (this.cachedButton = null),
                  (this.accessibility = W),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  (this.closeSliderule = this.closeSliderule.bind(this)),
                  this.clickEvents(),
                  this.keyboardEvents(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
              }
            })(t)
          );
        });
      },
      onUnload() {
        ja[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Ja = "[data-takes-space-wrapper]",
    Ya = "[data-child-takes-space]",
    Qa = "[data-header-desktop]",
    Ga = '.navlink[href="#"]',
    Ka = "cart-drawer",
    Za = "[data-cart-toggle]",
    tl =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    el = "js__header__clone",
    sl = "has-first-section-overlay-header",
    il = "js__show__mobile",
    ol = "has-header-transparent",
    nl = "data-header-transparent";
  let rl = {};
  _o("header", [
    {
      onLoad() {
        rl = new (class {
          initTicker(t = !1) {
            this.tickerFrames.forEach((e) => {
              new ea(e, t);
            }),
              (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
              document.addEventListener(
                "theme:resize:width",
                this.tickerResizeEvent
              );
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
              this.wrapper.classList.add(il);
              const { headerHeight: t } = c();
              document.documentElement.style.setProperty(
                "--header-height",
                `${t}px`
              );
            } else this.wrapper.classList.remove(il);
          }
          getMinWidth() {
            const t = this.wrapper.cloneNode(!0);
            t.classList.add(el), document.body.appendChild(t);
            const e = t.querySelectorAll(Ja);
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll(Ya);
                let o = 0;
                (o =
                  3 === e.length
                    ? (function (t) {
                        let e = [];
                        return (
                          t.forEach((t) => {
                            t.firstElementChild &&
                              e.push(t.firstElementChild.clientWidth);
                          }),
                          e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                          e.reduce((t, e) => t + e)
                        );
                      })(e)
                    : (function (t) {
                        let e = 0;
                        return (
                          t.forEach((t) => {
                            e += t.clientWidth;
                          }),
                          e
                        );
                      })(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            var t;
            "drawer" === theme.settings.cartType &&
              (null === (t = this.wrapper.querySelectorAll(Za)) ||
                void 0 === t ||
                t.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    const s = document.querySelector(Ka);
                    s &&
                      (e.preventDefault(),
                      s.dispatchEvent(
                        new CustomEvent("theme:cart-drawer:show")
                      ),
                      (window.accessibility.lastElement = t));
                  });
                }));
          }
          toggleButtonClick(t) {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:toggle", { bubbles: !0 })
              );
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(Qa)),
              (this.deadLinks = document.querySelectorAll(Ga)),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            const e = document.querySelector(tl);
            document.body.classList.toggle(ol, this.wrapper.hasAttribute(nl)),
              document.body.classList.toggle(sl, e);
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof rl.unload && rl.unload();
      },
    },
    ya,
    Xa,
    Ca,
    _a,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", ea);
  const al = "[data-block-scroll]",
    ll = "flickity-enabled",
    cl = {};
  const hl = {
      onLoad() {
        cl[this.id] = new (class {
          onBlockSelect(t) {
            const e = this.container.querySelector(al);
            if (e && !e.classList.contains(ll)) {
              const s = t.srcElement;
              s &&
                e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        cl[this.id].onBlockSelect(t);
      },
    },
    dl = "[data-slider-mobile]",
    ul = "[data-slide]",
    pl = "[data-slider-thumb]",
    ml = "[data-slider-container]",
    vl = "[data-popup-container]",
    gl = "[data-popup-close]",
    fl = "is-animating",
    yl = "is-open",
    bl = "data-slider-thumb",
    wl = {};
  function El() {
    this.entries = [];
  }
  function Sl(t, e) {
    Ll(t);
    var s = (function (t, e) {
      Ll(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      return (
        Ll(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, s) {
            return t.options[s] === e;
          });
        })[0] || null
      );
    })(t, s);
  }
  function Ll(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  _o("look", [
    {
      onLoad() {
        wl[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(fl),
                  t.target.classList.contains(yl)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(fl);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(yl),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    );
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                  s.preventDefault();
                  const i =
                      t.hasAttribute(bl) && "" !== t.getAttribute(bl)
                        ? parseInt(t.getAttribute(bl))
                        : e,
                    o = this.slides[i];
                  if (b()) {
                    const t = parseInt(
                      window.getComputedStyle(this.slider).paddingLeft
                    );
                    this.slider.scrollTo({
                      top: 0,
                      left: o.offsetLeft - t,
                      behavior: "auto",
                    }),
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                      ),
                      this.popupContainer.classList.add(fl, yl);
                  } else {
                    let { stickyHeaderHeight: t } = c();
                    const e = o.getBoundingClientRect().top,
                      s = o.offsetHeight / 2,
                      i = window.innerHeight,
                      n = i / 2,
                      r = this.container.querySelector(ml);
                    let a = e + s - n + window.scrollY;
                    if (r) {
                      const e = r.getBoundingClientRect().top + window.scrollY,
                        s = e + r.offsetHeight;
                      a < e ? (a = e - t) : a + i > s && (a = s - i);
                    }
                    window.scrollTo({ top: a, left: 0, behavior: "smooth" });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(yl);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(dl)),
              (this.slides = this.container.querySelectorAll(ul)),
              (this.thumbs = this.container.querySelectorAll(pl)),
              (this.popupContainer = this.container.querySelector(vl)),
              (this.popupClose = this.container.querySelectorAll(gl)),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    hl,
  ]),
    (El.prototype.add = function (t, e, s) {
      this.entries.push({ element: t, event: e, fn: s }),
        t.addEventListener(e, s);
    }),
    (El.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var kl = '[name="id"]',
    Al = '[name="selling_plan"]',
    Cl = '[name^="options"]',
    Tl = '[name="quantity"]',
    ql = '[name^="properties"]';
  const xl = "data-scrollbar",
    Ml = "data-scrollbar-slider",
    Pl = "data-scrollbar-slide-fullwidth",
    Il = "[data-scrollbar-arrow-prev]",
    Hl = "[data-scrollbar-arrow-next]",
    Ol = "is-hidden",
    Bl = 200;
  let Dl = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(Pl)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(Ol), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(Pl)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(Ol), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        var t;
        null === (t = this.arrowNext) ||
          void 0 === t ||
          t.classList.toggle(
            Ol,
            Math.round(
              this.scrollbar.scrollLeft +
                this.scrollbar.getBoundingClientRect().width +
                1
            ) >= this.scrollbar.scrollWidth
          );
      }, Bl);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(Ol, this.scrollbar.scrollLeft <= 0);
      }, Bl);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(Hl)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(Il)),
        this.scrollbar.hasAttribute(xl) && (this.init(), this.listen()),
        this.scrollbar.hasAttribute(Ml) && this.scrollToVisibleElement();
    }
  };
  const Fl = "[data-grid-swatch-form]",
  $l = "[data-grid-item]",
  _l = "[data-product-information]",
  Nl = "[data-product-image]",
  Rl = "[data-swatch-button]",
  Wl = "[data-swatch-link]",
  zl = "[data-swatch-text]",
  Ul = "[data-swatch-template]",
  Vl = "is-visible",
  jl = "no-events",
  Xl = "swatch",
  Jl = "data-swatch-handle",
  Yl = "data-swatch-label",
  Ql = "data-scrollbar",
  Gl = "data-swatch-count",
  Kl = "data-tooltip",
  Zl = "data-swatch-variant-name",
  tc = "data-variant-title",
  ec = "data-swatch-values";

window.__productJsonCache = window.__productJsonCache || new Map();

function fetchProductJsonCached(handle) {
  if (!handle) return Promise.reject(new Error("Missing product handle"));

  const cache = window.__productJsonCache;
  if (cache.has(handle)) return cache.get(handle);

  const url = `${window.theme.routes.root}products/${handle}.js`;

  const p = fetch(url, { credentials: "same-origin" })
    .then((r) => {
      if (!r.ok) throw new Error(`Product JSON failed (${r.status}) for ${handle}`);
      return r.json();
    })
    .catch((err) => {
      // IMPORTANT: don't keep broken promises in cache
      cache.delete(handle);
      throw err;
    });

  cache.set(handle, p);
  return p;
}

// 1x1 transparent SVG placeholder (prevents broken image icon)
const SWATCH_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E";

// Shared observer that swaps data-src/srcset -> src/srcset
window.__swatchImgObserver =
  window.__swatchImgObserver ||
  new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const img = entry.target;
        const src = img.dataset.src;
        const srcset = img.dataset.srcset;

        if (src) img.src = src;
        if (srcset) img.srcset = srcset;

        img.removeAttribute("data-src");
        img.removeAttribute("data-srcset");

        obs.unobserve(img);
      });
    },
    {
      root: null,
      rootMargin: "300px 0px", // start loading slightly before visible
      threshold: 0.01,
    }
  );


let sc = class extends HTMLElement {
    connectedCallback() {
      this.hasAttribute(Kl) && new Go(this);
    }
    constructor() {
      super();
    }
  },
  ic = class extends HTMLElement {
  connectedCallback() {
  this.handle = this.getAttribute(Jl);
  this.productItem = this.closest($l);
  this.productInfo = this.closest(_l);
  this.productImage = this.productItem?.querySelector(Nl);
  this.template = document.querySelector(Ul)?.innerHTML || "";
  this.swatchesJSON = this.getSwatchesJSON();
  this.swatchesStyle = theme.settings.collectionSwatchStyle;

  const label = (this.getAttribute(Yl) || "").trim().toLowerCase();
  if (!this.handle || !label || !this.template) return;

  fetchProductJsonCached(this.handle)
    .then((product) => {
      this.product = product;

      this.colorOption =
        (product.options || []).find((opt) => (opt.name || "").toLowerCase() === label) || null;

      if (!this.colorOption) return;

      this.swatches = this.colorOption.values || [];
      if (!this.swatches.length) return;

      this.init();
    })
    .catch((err) => console.error(err));
}

    init() {
      this.innerHTML = "";
      this.count = 0;
      this.limitedCount = 0;

      const normalizeImgUrl = (url) => {
        if (!url || typeof url !== "string") return "";
        url = url.trim();
        if (url.startsWith("//")) url = window.location.protocol + url;
        return url;
      };

      const sized = (url, size) => {
        url = normalizeImgUrl(url);
        if (!url) return "";
        return url.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, `_${size}x.$1$2`);
      };

      this.swatches.forEach((t) => {
        let chosenVariant = null;
        let available = !1;
        let variantImgUrl = "";

        for (const v of this.product.variants) {
          if (v.options && v.options.includes(t)) {
            chosenVariant = v;
            break;
          }
        }

        for (const v of this.product.variants) {
          const matches = v.options && v.options.includes(t);
          const hasMedia =
            v.featured_media &&
            v.featured_media.preview_image &&
            v.featured_media.preview_image.src;

          if (matches && hasMedia) {
            chosenVariant = v;
            variantImgUrl = v.featured_media.preview_image.src;
            break;
          }
        }

        if (
          !variantImgUrl &&
          chosenVariant &&
          chosenVariant.featured_image &&
          chosenVariant.featured_image.src
        ) {
          variantImgUrl = chosenVariant.featured_image.src;
        }

        for (const v of this.product.variants) {
          if (v.options && v.options.includes(t) && v.available) {
            available = !0;
            break;
          }
        }

        if (!available) return;

        if (!chosenVariant) return;

        if (!chosenVariant) return;

        const r = document.createElement("div");
        r.innerHTML = this.template;

        const a = r.querySelector(Rl),
          l = r.querySelector(Wl),
          c = r.querySelector(zl),
          h = this.swatchesJSON[t],
          d = chosenVariant.title.replaceAll('"', "'");

        a.style = `--animation-delay: ${(100 * this.count) / 1250}s`;
        a.classList.add(`${Xl}-${h}`);
        a.dataset.swatchVariant = chosenVariant.id;
        a.dataset.swatchVariantName = d;
        a.dataset.swatchImage = normalizeImgUrl(variantImgUrl) || "";
        a.dataset.variant = chosenVariant.id;
        a.style.setProperty("--swatch", `var(--${h})`);

        const imgEl = r.querySelector('img[data-swatch-image]');
const imgUrl = a.dataset.swatchImage;

if (imgEl && imgUrl) {
  imgEl.loading = "lazy";
  imgEl.decoding = "async";
  imgEl.fetchPriority = "low";

  const src64 = sized(imgUrl, 64);
  const src128 = sized(imgUrl, 128);

  imgEl.setAttribute("src", src64);
  imgEl.setAttribute("srcset", `${src64} 1x, ${src128} 2x`);
  imgEl.setAttribute("sizes", "32px");
  imgEl.setAttribute("alt", t);

  imgEl.width = 32;
  imgEl.height = 32;
  imgEl.style.display = "";
} else if (imgEl) {
  imgEl.removeAttribute("src");
  imgEl.removeAttribute("srcset");
  imgEl.style.display = "none";
}


        var o, n;
        l.href =
          ((o = this.product.url),
          (n = chosenVariant.id),
          /variant=/.test(o)
            ? o.replace(/(variant=)[^&]+/, "$1" + n)
            : /\?/.test(o)
            ? o.concat("&variant=").concat(n)
            : o.concat("?variant=").concat(n));

        l.dataset.swatch = t;
        l.disabled = !available;
        c.innerText = t;

        const node = r.firstElementChild;
if (!node) return;

if ("limited" != this.swatchesStyle) {
  this.appendChild(node);
} else if (this.count <= 4) {
  this.appendChild(node);
  this.limitedCount++;
}

this.count++;
      });

      this.swatchCount = this.productInfo.querySelector(`[${Gl}]`);
      this.swatchElements = this.querySelectorAll(Wl);
      this.swatchForm = this.productInfo.querySelector(Fl);
      this.hideSwatchesTimer = 0;

      if (this.swatchCount && this.swatchCount.hasAttribute(Gl)) {
        if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
          this.swatchCount.innerText = `${this.count} ${
            this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
          }`;

          if ("text" == this.swatchesStyle) return;

          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer);
            this.productInfo.classList.add(jl);
            this.swatchForm.classList.add(Vl);
          });

          this.productInfo.addEventListener("mouseleave", () => {
            this.hideSwatchesTimer = setTimeout(() => {
              this.productInfo.classList.remove(jl);
              this.swatchForm.classList.remove(Vl);
            }, 100);
          });
        }

        if (
          (("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) ||
            this.swatchForm.classList.add(Vl),
          "limited" == this.swatchesStyle)
        ) {
          const remaining = this.count - this.limitedCount;
          this.swatchForm.classList.add(Vl);
          remaining > 0 && (this.innerHTML += `<div class="swatch-limited">+${remaining}</div>`);
        }
      }

      ("text-slider" != this.swatchesStyle && "slider" != this.swatchesStyle) ||
        (this.hasAttribute(Ql) && new Dl(this));

      this.bindSwatchButtonEvents();
    }

    bindSwatchButtonEvents() {
      var t;
      null === (t = this.querySelectorAll(Rl)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("mouseenter", this.showVariantImageEvent),
            t.hasAttribute(Kl) && new Go(t);
        }),
        this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent);
    }

    showVariantImage(t) {
      var e;
      const s =
          null === (e = t.target.getAttribute(Zl)) || void 0 === e
            ? void 0
            : e.replaceAll('"', "'"),
        i = this.productImage.querySelectorAll(`[${tc}]`),
        o = this.productImage.querySelector(`[${tc}="${s}"]`);

      null == i ||
        i.forEach((t) => {
          t.classList.remove(Vl);
        }),
        null == o || o.classList.add(Vl);
    }

    hideVariantImages() {
      var t;
      null === (t = this.productImage.querySelectorAll(`[${tc}].${Vl}`)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.classList.remove(Vl);
        });
    }

    getSwatchesJSON() {
      if (!this.hasAttribute(ec)) return {};
      const t = this.getAttribute(ec).split(","),
        e = {};
      return (
        null == t ||
          t.forEach((t) => {
            const [s, i] = t.split(":");
            e[s.trim()] = i.trim();
          }),
        e
      );
    }

    constructor() {
      super();
      this.productItemMouseLeaveEvent = () => this.hideVariantImages();
      this.showVariantImageEvent = (t) => this.showVariantImage(t);
    }
  };

  const oc = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    nc = "is-visible",
    rc = "is-fade",
    ac = "no-events",
    lc = "is-active",
    cc = "data-sibling-cutline",
    hc = "data-sibling-image",
    dc = "data-sibling-link",
    uc = "data-sibling-price",
    pc = "data-product-link";
  let mc = class extends HTMLElement {
    connectedCallback() {
      (this.product = this.closest(oc.productGridItem)),
        (this.siblingScrollbar = this.querySelector(oc.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(oc.siblingCount)),
        (this.siblingFieldset = this.querySelector(oc.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(oc.siblingLink)),
        (this.productInfo = this.closest(oc.productInfo)),
        (this.productLink = this.closest(oc.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        this.initScrollbar(),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" != this.swatchesStyle &&
            "slider" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
            this.siblingFieldset.classList.add(nc),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(pc)
                ? this.productLinks[0].getAttribute(pc)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(lc),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  ((this.productCutline.innerHTML = this.productCutlineValue),
                  (this.productCutline.title = this.productCutlineValue)),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                s = e.hasAttribute(dc) ? e.getAttribute(dc) : "",
                i = e.hasAttribute(uc) ? e.getAttribute(uc) : "",
                o = e.hasAttribute(cc) ? e.getAttribute(cc) : "",
                n = e.hasAttribute(hc) ? e.getAttribute(hc) : "";
              s &&
                this.productLinks.forEach((t) => {
                  t.href = s;
                }),
                i &&
                  (this.productPrice.innerHTML = `<span class="price">${i}</span>`),
                this.productCutline &&
                  (o
                    ? ((this.productCutline.innerHTML = o),
                      (this.productCutline.title = o))
                    : ((this.productCutline.innerHTML = ""),
                      (this.productCutline.title = ""))),
                n && this.showSiblingImage(n);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const dpr = window.devicePixelRatio || 1;
              const target = Math.ceil(this.productImage.offsetWidth * dpr);
              const size = Math.max(540, Math.ceil(target / 180) * 180);
              const o = r.getSizedImageUrl(t, `${size}x`);
                n = this.productImageSibling.querySelector(`[src="${o}"]`),
                a = () => {
                  this.productImageSibling.classList.add(nc),
                    this.productImageSibling
                      .querySelector(`[src="${o}"]`)
                      .classList.add(rc);
                },
                l = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(rc);
                    }),
                    requestAnimationFrame(a);
                };
              if (n) l();
              else {
                const t = document.createElement("img");
                (t.src = o),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), l();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(nc),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove(rc);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  oc.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  oc.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  oc.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  oc.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  oc.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product),
        this.querySelectorAll(oc.tooltip).forEach((t) => {
          new Go(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(ac),
        "text" != this.swatchesStyle && this.siblingFieldset.classList.add(nc);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(ac),
          this.siblingFieldset.classList.remove(nc);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new Dl(this.siblingScrollbar);
    }
    constructor() {
      super();
    }
  };
  const vc = "body",
    gc = "[data-related-section]",
    fc = "[data-tabs-holder]",
    yc = "data-tab",
    bc = "data-tab-index",
    wc = "[data-aos]",
    Ec = "data-block-id",
    Sc = "[data-tab]",
    Lc = ".tab-link",
    kc = ".tab-link__recent",
    Ac = ".tab-content",
    Cc = "[data-scrollbar]",
    Tc = "current",
    qc = "hidden",
    xc = "aos-animate",
    Mc = "aos-no-transition",
    Pc = "is-focused",
    Ic = {};
  const Hc = {
    onLoad() {
      Ic[this.id] = [];
      this.container.querySelectorAll(fc).forEach((t) => {
        Ic[this.id].push(
          new (class {
            init() {
              const t = this.container.querySelectorAll(Sc);
              this.container.addEventListener("theme:tab:check", () =>
                this.checkRecentTab()
              ),
                this.container.addEventListener("theme:tab:hide", () =>
                  this.hideRelatedTab()
                ),
                t.length &&
                  t.forEach((t) => {
                    const e = parseInt(t.getAttribute(yc)),
                      s = this.container.querySelector(`${Ac}-${e}`);
                    t.addEventListener("click", () => {
                      this.tabChange(t, s);
                    }),
                      t.addEventListener("keyup", (e) => {
                        ("Space" !== e.code && "Enter" !== e.code) ||
                          !this.body.classList.contains(Pc) ||
                          this.tabChange(t, s);
                      });
                  });
            }
            tabChange(t, e) {
              if (t.classList.contains(Tc)) return;
              const s = this.container.querySelector(`${Sc}.${Tc}`),
                i = this.container.querySelector(`${Ac}.${Tc}`);
              null == s || s.classList.remove(Tc),
                null == i || i.classList.remove(Tc),
                t.classList.add(Tc),
                e.classList.add(Tc),
                t.classList.contains(qc) && e.classList.add(qc),
                this.accessibility.a11y.removeTrapFocus(),
                this.container.dispatchEvent(
                  new CustomEvent("theme:tab:change", { bubbles: !0 })
                ),
                t.dispatchEvent(
                  new CustomEvent("theme:form:sticky", {
                    bubbles: !0,
                    detail: { element: "tab" },
                  })
                ),
                this.animateItems(e);
            }
            animateItems(t, e = !0) {
              const s = t.querySelectorAll(wc);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(xc),
                    e &&
                      (t.classList.add(Mc),
                      requestAnimationFrame(() => {
                        t.classList.remove(Mc), t.classList.add(xc);
                      }));
                });
            }
            initNativeScrollbar() {
              this.scrollbarHolder.length &&
                this.scrollbarHolder.forEach((t) => {
                  new Dl(t);
                });
            }
            checkRecentTab() {
              const t = this.container.querySelector(kc);
              if (t) {
                t.classList.remove(qc);
                const e = parseInt(t.getAttribute(yc)),
                  s = this.container.querySelector(`${Ac}[${bc}="${e}"]`);
                s && (s.classList.remove(qc), this.animateItems(s, !1)),
                  this.initNativeScrollbar();
              }
            }
            hideRelatedTab() {
              const t = this.container.querySelector(gc);
              if (!t) return;
              const e = t.closest(`${Ac}.${Tc}`);
              if (!e) return;
              const s = parseInt(e.getAttribute(bc)),
                i = this.container.querySelectorAll(Sc);
              if (i.length > s) {
                const t = i[s].nextSibling;
                t &&
                  (i[s].classList.add(qc),
                  t.dispatchEvent(new Event("click")),
                  this.initNativeScrollbar());
              }
            }
            onBlockSelect(t) {
              const e = this.container.querySelector(
                `${Lc}[${Ec}="${t.detail.blockId}"]`
              );
              e &&
                (e.dispatchEvent(new Event("click")),
                e.parentNode.scrollTo({
                  top: 0,
                  left: e.offsetLeft - e.clientWidth,
                  behavior: "smooth",
                }));
            }
            constructor(t) {
              (this.container = t),
                (this.body = document.querySelector(vc)),
                (this.accessibility = window.accessibility),
                this.container &&
                  ((this.scrollbarHolder = this.container.querySelectorAll(Cc)),
                  this.init(),
                  this.initNativeScrollbar());
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      Ic[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  function Oc() {
    const t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  const Bc = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    Dc = 3e3,
    Fc = "[data-animation]",
    $c = "[data-api-content]",
    _c = "[data-quick-add-btn]",
    Nc = "[data-add-to-cart]",
    Rc = "cart-drawer",
    Wc = "[data-cart-page]",
    zc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Uc = "[data-message-error]",
    Vc = "[data-quick-add-modal-handle]",
    jc = "[data-product-upsell-ajax]",
    Xc = "[data-quick-add-modal-close]",
    Jc = "data-grid-item",
    Yc = "[data-product-information]",
    Qc = "[data-quick-add-holder]",
    Gc = "[data-quick-add-modal]",
    Kc = "[data-quick-add-modal-template]",
    Zc = "closing",
    th = "data-product-id",
    eh = "data-quick-add-modal-handle",
    sh = "data-sibling-swapper",
    ih = "data-quick-add-holder";
  let oh = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.cart &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.accessibility.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(sh),
        s = this.modalButton.classList.contains(Bc.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(Bc.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(Gc)),
          this.currentModal.classList.add(Bc.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${Gc}[${th}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(Kc);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(Gc)),
          e.remove(),
          (this.modal = document.querySelector(
            `${Gc}[${th}="${this.productId}"]`
          )),
          (this.modal.querySelector(jc).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector($c).innerHTML),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(Bc.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(Bc.loading),
          (this.modalButton.disabled = !1),
          (window.accessibility.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Fc).forEach((t) => {
            t.classList.add(Bc.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Zc))
          return this.modal.setAttribute(Zc, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Zc),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(Bc.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(Bc.disabled) &&
            this.quickAddHolder.classList.remove(Bc.disabled),
          this.resetAnimatedItems(),
          Oc() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(Xc)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Zc)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(zc);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Bc.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${Jc}]`);
        if (!s) return;
        const i = e.querySelector(Uc),
          o = s.classList.contains(Bc.overlayText),
          n = s.querySelector(Yc),
          r = e.querySelector(Nc);
        r &&
          (r.classList.remove(Bc.added, Bc.loading), e.classList.add(Bc.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(Bc.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(Bc.hidden);
          }, Dc);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Bc.visible, Bc.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(Bc.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), I(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $e({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(Fc).forEach((t) => {
          t.classList.remove(Bc.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.container = this),
      (this.cart = document.querySelector(Rc) || document.querySelector(Wc)),
      (this.quickAddHolder = this.container.querySelector(Qc)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(ih)),
        (this.modalButton = this.quickAddHolder.querySelector(Vc)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(eh)),
        (this.cartDrawer = document.querySelector(Rc)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(_c)),
        (this.buttonATC = this.quickAddHolder.querySelector(Nc)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = W),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  _o("product-grid", [Hc]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", oh),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", sc),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", ic),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", mc);
  const nh = "complementary-products",
    rh = "quick-add-product",
    ah = "is-loaded",
    lh = "data-url";
  let ch = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(lh) &&
              "" !== this.getAttribute(lh) &&
              fetch(this.getAttribute(lh))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const s = e.querySelector(nh);
                  s &&
                    s.innerHTML.trim().length &&
                    (this.innerHTML = s.innerHTML),
                    e.querySelector(`${nh} ${rh}`) && this.classList.add(ah);
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const hh = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    dh = 'input[type="email"]',
    uh = 'input[type="checkbox"]',
    ph = "[data-form-wrapper]";
  let mh = class extends HTMLElement {
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(uh)),
        (this.fieldEmail = this.querySelector(dh)),
        (this.fields = this.querySelectorAll(hh)),
        (this.form = this.closest(ph)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
  };
  const vh = ".product__page",
    gh = "[data-form-wrapper]",
    fh = "[data-header-sticky]",
    yh = "[data-product-media-list]",
    bh = "is-sticky",
    wh = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const Eh = {};
  const Sh = {
      onLoad() {
        Eh[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          stickyFormEvents(t) {
            this.removeAnimationFrameSticky(),
              (this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition(t)
              ));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.formWrapper.removeEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t = this.container.querySelector(`${vh} ${gh}`);
            if (t)
              if (y()) {
              theme.variables.productPageSticky = true;
              t.classList.add(bh);
              } else {
              theme.variables.productPageSticky = false;
              t.classList.remove(bh);
              }
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrameSticky();
            const e = Boolean(t && t.detail),
              s = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              i = this.formWrapper.offsetHeight,
              o = window.innerHeight - i - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (
              (this.scrollDirectionDown
                ? (this.stickyScrollTop -= n)
                : (this.stickyScrollTop += n),
              this.stickyFormLoad)
            ) {
              if (document.querySelector(fh)) {
                let { headerHeight: t } = c();
                this.stickyDefaultTop = t;
              } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
              this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(
              Math.max(this.stickyScrollTop, o),
              this.stickyDefaultTop
            );
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (s && this.onChangeCounter <= 10) ||
              (s && this.stickyFormLastHeight !== i) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (s && (this.onChangeCounter += 1),
                  s &&
                    this.stickyFormLastHeight !== i &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky &&
                  this.removeAnimationFrameSticky(),
              (this.stickyFormLastHeight = i);
          }
          removeAnimationFrameSticky() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(wh)),
              (this.formWrapper = this.container.querySelector(gh)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        Eh[this.id].onUnload();
      },
    },
    Lh = "data-section-type",
    kh = "[data-share-button]",
    Ah = "[data-share-message]",
    Ch = "is-visible";
  let Th = class extends HTMLElement {
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(Lh) &&
        this.container.addEventListener("theme:variant:change", (t) => {
          t.detail.variant &&
            (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              t.detail.variant.id
            }`);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(Ch);
        const t = () => {
          this.shareMessage.classList.remove(Ch),
            this.shareMessage.removeEventListener("animationend", t);
        };
        this.shareMessage.addEventListener("animationend", t);
      });
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${Lh}]`)),
        (this.shareButton = this.querySelector(kh)),
        (this.shareMessage = this.querySelector(Ah)),
        (this.urlToShare = this.shareButton.dataset.shareUrl
          ? this.shareButton.dataset.shareUrl
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const qh = "[data-button-arrow]",
    xh = "[data-deferred-media-button]",
    Mh = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    Ph = "[data-image-id]",
    Ih = "[data-product-media-list]",
    Hh = "[data-section-type]",
    Oh = "slider__arrows",
    Bh = "is-dragging",
    Dh = "is-focused",
    Fh = "media--active",
    $h = "media--hidden",
    _h = "media--hiding",
    Nh = "data-active-media",
    Rh = "data-button-prev",
    Wh = "data-button-next",
    zh = "data-image-id",
    Uh = "data-media-id",
    Vh = "data-fader-desktop",
    jh = "data-fader-mobile";
  let Xh = class extends HTMLElement {
    connectedCallback() {
      1 !== Object.keys(this.productMediaItems).length &&
        (this.productMediaObserver(),
        this.toggleEvents(),
        this.listen(),
        this.setHeight());
    }
    disconnectedCallback() {
      this.unlisten();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.toggleEvents),
        document.addEventListener("theme:resize:width", this.setHeight),
        this.addEventListener("theme:media:select", this.selectMediaEvent);
    }
    unlisten() {
      document.removeEventListener("theme:resize:width", this.toggleEvents),
        document.removeEventListener("theme:resize:width", this.setHeight),
        this.removeEventListener("theme:media:select", this.selectMediaEvent);
    }
    toggleEvents() {
      const t = b();
      (t && this.hasAttribute(jh)) || (!t && this.hasAttribute(Vh))
        ? this.bindEventListeners()
        : this.unbindEventListeners();
    }
    bindEventListeners() {
      this.initialized ||
        (this.productMediaList.addEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
        this.productMediaList.addEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.addEventListener(
          "touchstart",
          this.handleMouseDown,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
          passive: !0,
        }),
        this.productMediaList.addEventListener(
          "touchmove",
          this.handleMouseMove,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("keyup", this.handleKeyUp),
        this.initArrows(),
        this.resetScrollPosition(),
        (this.initialized = !0));
    }
    unbindEventListeners() {
      this.initialized &&
        (this.productMediaList.removeEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.removeEventListener(
          "mouseup",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener(
          "touchstart",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "touchend",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "touchmove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
        this.removeArrows(),
        (this.initialized = !1));
    }
    handleMouseDown(t) {
      (this.isDown = !0),
        (this.startX =
          (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
        (this.startY =
          (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
    }
    handleMouseLeave() {
      this.isDown && (this.isDown = !1);
    }
    handleMouseUp(t) {
      const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
        s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
        i = e - this.startX,
        o = s - this.startY,
        n = i > 0 ? 1 : -1;
      Math.abs(i) > 10 &&
        Math.abs(i) > Math.abs(o) &&
        (n < 0 ? this.showNextImage() : this.showPreviousImage()),
        (this.isDown = !1),
        requestAnimationFrame(() => {
          this.classList.remove(Bh);
        });
    }
    handleMouseMove() {
      this.isDown && this.classList.add(Bh);
    }
    handleKeyUp(t) {
      "ArrowLeft" === t.code && this.showPreviousImage(),
        "ArrowRight" === t.code && this.showNextImage();
    }
    handleArrowsClickEvent() {
      var t;
      null === (t = this.querySelectorAll(qh)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              t.target.hasAttribute(Rh) && this.showPreviousImage(),
              t.target.hasAttribute(Wh) && this.showNextImage();
          });
        });
    }
    resetScrollPosition() {
      0 !== this.productMediaList.scrollLeft &&
        (this.productMediaList.scrollLeft = 0);
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(Oh),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.productMediaList.append(t),
          (this.buttons = this.querySelectorAll(qh)),
          (this.buttonPrev = this.querySelector(`[${Rh}]`)),
          (this.buttonNext = this.querySelector(`[${Wh}]`));
      }
      this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${Oh}`)) || void 0 === t || t.remove();
    }
    preloadImageOnArrowHover() {
      var t, e;
      null === (t = this.buttonPrev) ||
        void 0 === t ||
        t.addEventListener("mouseover", () => {
          const t = this.getPreviousMediaId();
          this.preloadImage(t);
        }),
        null === (e = this.buttonNext) ||
          void 0 === e ||
          e.addEventListener("mouseover", () => {
            const t = this.getNextMediaId();
            this.preloadImage(t);
          });
    }
    preloadImage(t) {
      var e;
      null === (e = this.querySelector(`[${Uh}="${t}"] img`)) ||
        void 0 === e ||
        e.setAttribute("loading", "eager");
    }

    showMediaOnVariantSelect(t) {
      const e = t.detail.id;
      this.setActiveMedia(e);
    } 
    getCurrentMedia() {
      return this.querySelector(`${Ph}.${Fh}`);
    }
    getNextMediaId() {
      const t = this.getCurrentMedia(),
        e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(zh))
          ? null == t
            ? void 0
            : t.nextElementSibling
          : this.querySelector(Ph);
      return null == e ? void 0 : e.getAttribute(Uh);
    }
    getPreviousMediaId() {
      const t = this.getCurrentMedia(),
        e = this.productMediaItems.length - 1,
        s =
          (null == t ? void 0 : t.previousElementSibling) ||
          this.productMediaItems[e];
      return null == s ? void 0 : s.getAttribute(Uh);
    }
    showNextImage() {
      const t = this.getNextMediaId();
      this.setAttribute('data-fader-direction', 'next');
      this.selectMedia(t);
    }
    showPreviousImage() {
      const t = this.getPreviousMediaId();
      this.setAttribute('data-fader-direction', 'prev');
      this.selectMedia(t);
    }
    selectMedia(t) {
      this.dispatchEvent(
        new CustomEvent("theme:media:select", { detail: { id: t } })
      );
    }
    setActiveMedia(t) {
      if (!t) return;
      this.setAttribute(Nh, t);
      const e = this.querySelector(`${Ph}.${Fh}`),
        s = this.querySelector(`[${Uh}="${t}"]`),
        i = null == s ? void 0 : s.querySelector(Mh),
        o = s.querySelector("deferred-media");
      var n;
      (null == e || e.classList.add(_h),
      null == e || e.classList.remove(Fh),
      null == s || s.classList.remove(_h, $h),
      null == s || s.classList.add(Fh),
      o && !0 !== o.getAttribute("loaded")) &&
        (null === (n = s.querySelector(xh)) ||
          void 0 === n ||
          n.dispatchEvent(new Event("click", { bubbles: !1 })));
      requestAnimationFrame(() => {
        this.setHeight(),
          document.body.classList.contains(Dh) && (null == i || i.focus());
      });
    }
    setHeight() {
      var t, e;
      const s =
        (null === (t = this.querySelector(`${Ph}.${Fh}`)) || void 0 === t
          ? void 0
          : t.offsetHeight) ||
        (null === (e = this.productMediaItems[0]) || void 0 === e
          ? void 0
          : e.offsetHeight);
      this.style.setProperty("--height", `${s}px`);
    }
    productMediaObserver() {
      this.productMediaItems.forEach((t) => {
        t.addEventListener("transitionend", (e) => {
          e.target == t &&
            t.classList.contains(_h) &&
            (t.classList.remove(_h), t.classList.add($h));
        }),
          t.addEventListener("transitioncancel", (e) => {
            e.target == t &&
              t.classList.contains(_h) &&
              (t.classList.remove(_h), t.classList.add($h));
          });
      });
    }
    constructor() {
      super(),
        (this.initialized = !1),
        (this.buttons = !1),
        (this.isDown = !1),
        (this.startX = 0),
        (this.startY = 0),
        (this.scrollLeft = 0),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.container = this.closest(Hh)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleKeyUp = this.handleKeyUp.bind(this)),
        (this.productMediaItems = this.querySelectorAll(Ph)),
        (this.productMediaList = this.querySelector(Ih)),
        (this.setHeight = this.setHeight.bind(this)),
        (this.toggleEvents = this.toggleEvents.bind(this)),
        (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
    }
  };
  const Jh = "data-option-position",
    Yh = '[name^="options"], [data-popout-option]',
    Qh = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    Gh = "data-value",
    Kh = "[data-popout]",
    Zh = "sold-out",
    td = "unavailable",
    ed = "sale";
  const sd = "[data-product]",
    id = "[data-product-form]",
    od = "product-notification",
    nd = "[data-variant-title]",
    rd = "[data-add-to-cart]",
    ad = "[data-add-to-cart-text]",
    ld = "cart-drawer",
    cd = "[data-cart-page]",
    hd = "[data-compare-price]",
    dd = "[data-compare-text]",
    ud = "[data-form-wrapper]",
    pd = "[data-product-select]",
    md = "[data-price-wrapper]",
    vd = "product-images",
    gd = "[data-product-media-list]",
    fd = "[data-product-json]",
    yd = "[data-product-price]",
    bd = "[data-product-unit-price]",
    wd = "[data-product-base]",
    Ed = "[data-product-unit]",
    Sd = "[data-product-preorder]",
    Ld = "[data-subscription-watch-price]",
    kd = "[data-subscription-selectors]",
    Ad = "[data-toggles-group]",
    Cd = "data-group-toggle",
    Td = "[data-plan-description]",
    qd = "[data-section-type]",
    xd = "[data-variant-sku]",
    Md = "[data-variant-final-sale-metafield]",
    Pd = "[data-variant-option-image]",
    Id = "[data-quick-add-modal]",
    Hd = "[data-price-off]",
    Od = "[data-price-off-type]",
    Bd = "[data-price-off-amount]",
    Dd = "[data-remaining-count]",
    Fd = "[data-remaining-max]",
    $d = "[data-remaining-wrapper]",
    _d = "[data-product-remaining-json]",
    Nd = "[data-option-value]",
    Rd = "[data-option-position]",
    Wd = "[data-product-form-installment]",
    zd = 'input[name="id"]',
    Ud = "hidden",
    Vd = "variant--soldout",
    jd = "variant--unavailable",
    Xd = "product__price--sale",
    Jd = "count-is-low",
    Yd = "count-is-in",
    Qd = "count-is-out",
    Gd = "count-is-unavailable",
    Kd = "data-remaining-max",
    Zd = "data-enable-history-state",
    tu = "data-fader-desktop",
    eu = "data-fader-mobile",
    su = "data-option-position",
    iu = "data-image-id",
    ou = "data-media-id",
    nu = "data-quick-add-btn",
    ru = "data-final-sale",
    au = "data-variant-image-scroll";
  let lu = class extends HTMLElement {
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(qd) || this.closest(Id)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(sd)),
        (this.productForm = this.container.querySelector(id)),
        (this.productNotification = this.container.querySelector(od)),
        (this.productImages = this.container.querySelector(vd)),
        (this.productMediaList = this.container.querySelector(gd)),
        (this.installmentForm = this.container.querySelector(Wd)),
        (this.skuWrapper = this.container.querySelector(xd)),
        (this.sellout = null),
        (this.variantImageScroll = "true" === this.container.getAttribute(au)),
        (this.priceOffWrap = this.container.querySelector(Hd)),
        (this.priceOffAmount = this.container.querySelector(Bd)),
        (this.priceOffType = this.container.querySelector(Od)),
        (this.planDescription = this.container.querySelector(Td)),
        (this.remainingWrapper = this.container.querySelector($d)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(Fd);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(Kd), 10)),
          (this.remainingCount = this.container.querySelector(Dd)),
          (this.remainingJSONWrapper = this.container.querySelector(_d)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(Zd)),
        (this.hasUnitPricing = this.container.querySelector(Ed)),
        (this.subSelectors = this.container.querySelector(kd)),
        (this.subPrices = this.container.querySelector(Ld)),
        (this.isPreOrder = this.container.querySelector(Sd));
      let t = null;
      const e = this.container.querySelector(fd);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new (class {
              init() {
                this.update();
              }
              update() {
                this.getCurrentState(),
                  this.optionElements.forEach((t) => {
                    const e = t.closest(`[${Jh}]`);
                    if (!e) return;
                    const s = t.value || t.getAttribute(Gh),
                      i = e.getAttribute(Jh),
                      o = parseInt(i, 10) - 1,
                      n = t.closest(Kh);
                    let r = [...this.selections];
                    r[o] = s;
                    const a = this.productJSON.variants.find((t) => {
                      let e = !0;
                      for (let s = 0; s < r.length; s++)
                        t.options[s] !== r[s] && (e = !1);
                      return e;
                    });
                    t.classList.remove(Zh, td),
                      t.parentNode.classList.remove(ed),
                      n && n.classList.remove(Zh, td, ed),
                      void 0 === a
                        ? (t.classList.add(td), n && n.classList.add(td))
                        : a &&
                          !1 === a.available &&
                          (t.classList.add(Zh), n && n.classList.add(Zh)),
                      a &&
                        a.compare_at_price > a.price &&
                        theme.settings.variantOnSale &&
                        t.parentNode.classList.add(ed);
                  });
              }
              getCurrentState() {
                this.selections = [];
                const t = this.container.querySelectorAll(Qh);
                t.length &&
                  t.forEach((t) => {
                    const e = t.value;
                    e && "" !== e && this.selections.push(e);
                  });
              }
              constructor(t, e) {
                (this.container = t),
                  (this.productJSON = e),
                  (this.optionElements = this.container.querySelectorAll(Yh)),
                  this.productJSON && this.optionElements.length && this.init();
              }
            })(this.container, this.productJSON)))
          : console.error("Missing product JSON"),
        (this.variantOptionImages = this.container.querySelectorAll(Pd)),
        this.variantOptionImages.length > 1 && this.optionImagesWidth();
    }
    cartAddEvents() {
      this.buttonATC = this.querySelector(rd);
      const t = document.querySelector(ld) || document.querySelector(cd);
      this.buttonATC &&
        t &&
        this.buttonATC.addEventListener("click", (t) => {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                detail: { button: this.buttonATC },
                bubbles: !1,
              })
            ),
            this.closest(Id) ||
              (window.accessibility.lastElement = this.buttonATC);
        });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new (class {
        destroy() {
          this._listeners.removeAll();
        }
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        }
        variant() {
          const t = this.options();
          return t.length ? Sl(this.product, t) : this.product.variants[0];
        }
        plan(t) {
          let e = { allocation: null, group: null, detail: null };
          const s = this.element.querySelector(`${Al}:checked`);
          if (!s) return null;
          const i = s.value,
            o = i && "" !== i ? i : null;
          return (
            o &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === o.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === o.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        }
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        }
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        }
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        }
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        }
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        }
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        }
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        }
        _serializeInputValues(t, e) {
          return t.reduce(function (t, s) {
            return (
              (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
                t.push(e({ name: s.name, value: s.value })),
              t
            );
          }, []);
        }
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        }
        constructor(t, e, s) {
          (this.element = t),
            (this.product = this._validateProductObject(e)),
            (this.variantElement = this.element.querySelector(kl)),
            (s = s || {}),
            (this._listeners = new El()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, s)
            ),
            (this.optionInputs = this._initInputs(Cl, s.onOptionChange)),
            (this.planInputs = this._initInputs(Al, s.onPlanChange)),
            (this.quantityInputs = this._initInputs(Tl, s.onQuantityChange)),
            (this.propertyInputs = this._initInputs(ql, s.onPropertyChange));
        }
      })(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      var s;
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateNotificationForm(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSku(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        null === (s = this.sellout) || void 0 === s || s.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(md),
        o = this.container.querySelectorAll(rd),
        n = this.container.querySelectorAll(ad),
        r = this.container.querySelectorAll(ud);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(zd);
        (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(Ud);
          }),
        null == o ||
          o.forEach((t) => {
            t.hasAttribute(nu) ||
              (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
          }),
        null == n ||
          n.forEach((t) => {
            let i = s;
            e
              ? e.available || (i = theme.strings.soldOut)
              : (i = theme.strings.unavailable),
              (t.textContent = i);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(Vd, jd)
                : (t.classList.add(Vd), t.classList.remove(jd));
              const s = t.querySelector(pd);
              s && (s.value = e.id);
              const i = t.querySelector(`${zd}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add(jd), t.classList.remove(Vd);
          });
    }
    updateNotificationForm(t) {
      if (!this.productNotification) return;
      const e = this.productNotification.querySelector(nd);
      null != e && (e.textContent = t.variant.title);
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(t) {
      var e;
      const s = t.variant;
      if (
        (null === (e = this.remainingWrapper) ||
          void 0 === e ||
          e.classList.remove(Yd, Qd, Gd, Jd),
        s && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[s.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(Qd),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(Yd),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(Jd),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !s && this.remainingWrapper && this.remainingWrapper.classList.add(Gd);
    }
    optionImagesWidth() {
      let t = 0;
      for (const e of this.variantOptionImages) {
        const s = e.offsetWidth;
        s > t && (t = s);
      }
      for (const e of this.variantOptionImages) e.style.width = t + "px";
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(Ad).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${Cd}="${e}"]`),
              i = this.container.querySelectorAll(`[${Cd}]`);
            if (s) {
              s.classList.remove(Ud);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(Ud);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(Ud);
    }
    isVariantFinalSale(t) {
      const e = document.querySelector(Md).textContent,
        s = JSON.parse(e);
      let i = !1;
      return (
        s.forEach((e) => {
          Number(e.variant_id) === t.id && (i = "true" === e.metafield_value);
        }),
        i
      );
    }
    updateSaleTextStandard(t) {
      const e = t.variant;
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = (e.compare_at_price - e.price) / e.compare_at_price,
          s = Math.floor(100 * t);
        (this.priceOffAmount.innerHTML = `${s}%`),
          this.priceOffWrap.classList.remove(Ud);
      }
      this.closest(Id) ||
        (this.priceOffWrap.hasAttribute(ru) || this.isVariantFinalSale(e)
          ? this.priceOffWrap.classList.remove(Ud)
          : this.priceOffWrap.classList.add(Ud));
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(Ud))
        : this.planDescription && this.planDescription.classList.add(Ud);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          i = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${i}%`)
          : (this.priceOffAmount.innerHTML = s.formatMoney(
              i,
              theme.moneyFormat
            )),
          this.priceOffWrap.classList.remove(Ud);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        i = t.plan;
      this.container.querySelectorAll(md).forEach((t) => {
        const o = t.querySelector(hd),
          n = t.querySelector(yd),
          r = t.querySelector(dd);
        let a = "",
          l = "";
        this.productState.available &&
          ((a = e.compare_at_price), (l = e.price)),
          this.productState.hasPlan && (l = i.allocation.price),
          this.productState.planSale &&
            ((a = i.allocation.compare_at_price), (l = i.allocation.price)),
          o &&
            (this.productState.onSale || this.productState.planSale
              ? (o.classList.remove(Ud),
                r.classList.remove(Ud),
                n.classList.add(Xd))
              : (o.classList.add(Ud),
                r.classList.add(Ud),
                n.classList.remove(Xd)),
            (o.innerHTML = s.formatMoney(a, theme.moneyFormat))),
          (n.innerHTML =
            0 === l
              ? window.theme.strings.free
              : s.formatMoney(l, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        i = t.plan;
      let o = null;
      if (
        (e && e.unit_price && (o = e.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (o = i.allocation.unit_price),
        o)
      ) {
        const t = this.getBaseUnit(e),
          i = s.formatMoney(o, theme.moneyFormat);
        (this.container.querySelector(bd).innerHTML = i),
          (this.container.querySelector(wd).innerHTML = t),
          De(this.container.querySelector(Ed));
      } else
        (n = this.container.querySelector(Ed)) && (n.style.display = "none");
      var n;
    }
    updateSku(t) {
      this.skuWrapper &&
        (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `[${iu}="${e.featured_media.id}"]`
        );
        if (t) {
          const e = t.getAttribute(ou),
            s = y();
          if (
            (t.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: e },
              })
            ),
            s &&
              !this.productImages.hasAttribute(tu) &&
              this.variantImageScroll)
          ) {
            const e = t.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              Tn(e);
          }
          s ||
            this.productImages.hasAttribute(eu) ||
            this.productMediaList.scrollTo({ left: t.offsetLeft });
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(Nd);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(Rd);
            if (s) {
              const i = s.getAttribute(su),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
    constructor() {
      super();
    }
  };
  const cu = "[data-image-id]",
    hu = "product-images",
    du = "[data-section-type]",
    uu = "[data-thumb-item]",
    pu = "[data-thumb-link]",
    mu = "[data-thumbs-slider]",
    vu = "data-active-media",
    gu = "data-media-id",
    fu = "is-active";
  class yu extends HTMLElement {
    connectedCallback() {
      this.handleEvents(),
        this.preloadImagesOnHover(),
        this.activeMediaObserver();
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }
    activeMediaObserver() {
      (this.observer = new MutationObserver((t) => {
        for (const e of t)
          "attributes" === e.type &&
            e.attributeName == vu &&
            this.setActiveThumb();
      })),
        this.observer.observe(this.productImagesContainer, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
    }
    handleEvents() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault();
          const s = t.closest(uu),
            i = t.getAttribute(gu);
          s.classList.contains(fu) ||
            this.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: i },
              })
            );
        }),
          t.addEventListener("keyup", (e) => {
            if ("Enter" === e.code) {
              var s;
              const e = t.getAttribute(gu),
                i =
                  null ===
                    (s = this.productImagesContainer.querySelector(
                      `[${gu}="${e}"]`
                    )) || void 0 === s
                    ? void 0
                    : s.querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
              i &&
                (i.dispatchEvent(new Event("focus")),
                i.dispatchEvent(new Event("select")));
            }
          });
      });
    }
    preloadImagesOnHover() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("mouseover", () => {
          const e = t.getAttribute(gu),
            s = this.productImagesContainer.querySelector(`[${gu}="${e}"] img`);
          null == s || s.setAttribute("loading", "eager");
        });
      });
    }
    setActiveThumb() {
      var t;
      const e = this.productImagesContainer.getAttribute(vu),
        s = this.querySelector(`[${gu}="${e}"]`);
      null === (t = this.querySelector(`${uu}.${fu}`)) ||
        void 0 === t ||
        t.classList.remove(fu),
        null == s || s.parentNode.classList.add(fu),
        requestAnimationFrame(() => {
          this.scrollToThumb();
        });
    }
    scrollToThumb() {
      const t = this.thumbSlider;
      if (t) {
        const e = t.querySelector(`.${fu}`);
        if (!e) return;
        const s = t.scrollTop,
          i = t.scrollLeft,
          o = t.offsetWidth,
          n = t.offsetHeight,
          r = s + n,
          a = i + o,
          l = e.offsetTop,
          c = e.offsetLeft,
          h = e.offsetWidth,
          d = e.offsetHeight,
          u = s > l,
          p = i > c,
          m = c + h > a,
          v = l + d > r || u,
          g = m || p,
          f = b();
        if (v || g) {
          let e = l - n + d,
            s = c - o + h;
          u && (e = l),
            m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)),
            p &&
              ((s = c),
              f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))),
            t.scrollTo({ top: e, left: s, behavior: "smooth" });
        }
      }
    }
    constructor() {
      super(),
        (this.container = this.closest(du)),
        (this.productImages = this.container.querySelectorAll(cu)),
        (this.productImagesContainer = this.container.querySelector(hu)),
        (this.productThumbs = this.container.querySelectorAll(uu)),
        (this.thumbSlider = this.querySelector(mu)),
        (this.thumbLinks = this.querySelectorAll(pu));
    }
  }
  const bu = "[data-popup-open]",
    wu = "[data-popup-close]",
    Eu = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Su = "closing";
  let Lu = class {
    popupOpen() {
      this.popup &&
        ((this.isAnimating = !0),
        this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal || "function" != typeof this.popup.show
          ? this.popup.setAttribute("open", "")
          : this.popup.show(),
        this.popup.removeAttribute("inert"),
        this.popup.focus(),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        ai(this.popup).then(() => {
          (this.isAnimating = !1),
            this.enableScrollLock && this.a11y.trapFocus(this.popup);
          const t =
            this.popup.querySelector("[autofocus]") ||
            this.popup.querySelector(Eu);
          null == t || t.focus();
        }));
    }
    popupClose() {
      if (
        !this.isAnimating &&
        this.popup &&
        !this.popup.hasAttribute("inert")
      ) {
        if (!this.popup.hasAttribute(Su))
          return (
            this.popup.setAttribute(Su, ""),
            (this.isAnimating = !0),
            void ai(this.popup).then(() => {
              (this.isAnimating = !1), this.popupClose();
            })
          );
        "function" == typeof this.popup.close
          ? this.popup.close()
          : this.popup.removeAttribute("open"),
          this.popupCloseActions();
      }
    }
    popupCloseActions() {
      this.popup.hasAttribute("inert") ||
        (this.popup.setAttribute("inert", ""),
        this.popup.removeAttribute(Su),
        !Oc() &&
          this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:onclose", { bubbles: !1 })
        ),
        this.enableScrollLock &&
          (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
    }
    popupEvents() {
      var t;
      if (!this.popup) return;
      null === (t = this.buttonPopupOpen) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            this.popupOpen(),
            (window.accessibility.lastElement = this.buttonPopupOpen);
        });
      const e = this.popup.querySelectorAll(wu);
      e.length &&
        e.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("close", () => this.popupCloseActions());
    }
    constructor(t, e, s = !0, i = !0) {
      var o;
      (this.popup = t),
        (this.holder = e),
        (this.a11y = W),
        (this.isAnimating = !1),
        (this.showModal = s),
        (this.enableScrollLock = i),
        (this.buttonPopupOpen =
          null === (o = this.holder) || void 0 === o
            ? void 0
            : o.querySelector(bu)),
        this.popupEvents();
    }
  };
  const ku = "dialog";
  let Au = class extends HTMLElement {
      connectedCallback() {
        new Lu(this.querySelector(ku), this, !0, !0);
      }
      constructor() {
        super();
      }
    },
    Cu = class extends Jt {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const Tu = "data-store-availability-container",
    qu = ".shopify-section",
    xu = "[data-pickup-drawer]",
    Mu = "[data-section-type]",
    Pu = "hidden";
  let Iu = class extends HTMLElement {
    connectedCallback() {
      (this.container = this.closest(Mu)),
        (this.drawer = null),
        this.container.addEventListener("theme:variant:change", (t) =>
          this.fetchPickupAvailability(t)
        ),
        this.fetchPickupAvailability();
    }
    fetchPickupAvailability(t) {
      if (
        (t && !t.detail.variant) ||
        (t && t.detail.variant && !t.detail.variant.available)
      )
        return void this.classList.add(Pu);
      const e =
        t && t.detail.variant ? t.detail.variant.id : this.getAttribute(Tu);
      e &&
        ((this.popupActions = null),
        fetch(
          `${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`
        )
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser()
              .parseFromString(t, "text/html")
              .querySelector(qu).innerHTML;
            (this.innerHTML = e),
              (this.drawer = this.querySelector(xu)),
              this.drawer
                ? (this.classList.remove(Pu),
                  (this.popupActions = new Lu(this.drawer, this, !0, !0)))
                : this.classList.add(Pu);
          })
          .catch((t) => {
            console.error(t);
          }));
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $e({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    constructor() {
      super();
    }
  };
  const Hu = {};
  function Ou(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return Hu[t.url]
        ? Hu[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (Hu[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return Hu[t.json]
        ? Promise.resolve(Hu[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((Hu[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return Hu[e]
        ? Hu[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (Hu[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const Bu = ".pswp",
    Du = ".pswp__custom-close",
    Fu = "iframe, video",
    $u = ".pswp__thumbs",
    _u = "is-current",
    Nu = "pswp--custom-loader",
    Ru = "pswp--custom-opening",
    Wu = "pswp__loader",
    zu = "is-focused",
    Uu = "data-pswp-option-classes",
    Vu = "aria-current",
    ju = `<div class="${Wu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  let Xu = class {
    init() {
      this.pswpElement.classList.add(Ru),
        this.initLoader(),
        Ou({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(Nu) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(Uu, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = ju), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(Uu, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(Nu) &&
        this.pswpElement.classList.remove(Nu),
        this.pswpElement.classList.remove(Ru),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.init(),
        this.thumbsActions(),
        document.body.classList.contains(zu) &&
          setTimeout(() => {
            this.a11y.trapFocus(this.pswpElement, {
              elementToFocus: this.closeBtn,
            });
          }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.children.length &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${$u} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i = t.parentElement.querySelector(`.${_u}`);
            i.classList.remove(_u),
              i.setAttribute(Vu, !1),
              t.classList.add(_u),
              t.setAttribute(Vu, !0),
              this.popup.goTo(e);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    keyupClose(t) {
      "Enter" === t.code && this.popup.close();
    }
    onClose() {
      const t = this.pswpElement.querySelector(Fu);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(Uu, "");
      const e = this.pswpElement.querySelector(`.${Wu}`);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement();
    }
    setCurrentThumb() {
      const t = this.pswpElement.querySelector(`${$u} > .${_u}`);
      if (
        (t && (t.classList.remove(_u), t.setAttribute(Vu, !1)),
        !this.popupThumbs)
      )
        return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(_u), e.setAttribute(Vu, !0), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = t.offsetLeft;
      if (e <= s + t.offsetWidth || e > s) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - e,
          behavior: "smooth",
        });
      }
    }
    constructor(t, e = "") {
      (this.items = t),
        (this.pswpElement = document.querySelectorAll(Bu)[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector($u)),
        (this.closeBtn = this.pswpElement.querySelector(Du)),
        (this.keyupCloseEvent = (t) => this.keyupClose(t)),
        (this.a11y = W);
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        this.init();
    }
  };
  const Ju = "[data-zoom-caption]",
    Yu = "[data-zoom-image]",
    Qu = "[data-pswp-thumbs-template]",
    Gu = "[data-section-type]",
    Ku = ".pswp__thumbs",
    Zu = "product-images",
    tp = "is-dragging",
    ep = "variant--soldout",
    sp = "variant--unavailable",
    ip = "pswp-zoom-gallery",
    op = "pswp-zoom-gallery--single",
    np = "data-image-src",
    rp = "data-image-width",
    ap = "data-image-height";
  let lp = class extends HTMLElement {
    connectedCallback() {
      this.images.forEach((t, e) => {
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.closest(Zu).classList.contains(tp) ||
              (this.createZoom(e), (window.accessibility.lastElement = t));
        }),
          t.addEventListener("keyup", (s) => {
            "Enter" === s.code &&
              (s.preventDefault(),
              this.createZoom(e),
              (window.accessibility.lastElement = t));
          });
      });
    }
    createZoom(t) {
      const e = this.container.querySelector(Qu),
        s = null == e ? void 0 : e.innerHTML;
      let i = [],
        o = 0;
      this.images.forEach((e) => {
        const n = e.getAttribute(np);
        if (
          ((o += 1),
          i.push({
            src: n,
            w: parseInt(e.getAttribute(rp)),
            h: parseInt(e.getAttribute(ap)),
            msrc: n,
          }),
          this.images.length === o)
        ) {
          new Xu(i, {
            history: !1,
            focus: !1,
            index: t,
            mainClass: 1 === o ? `${ip} ${op}` : `${ip}`,
            showHideOpacity: !0,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !0,
            closeEl: !0,
            closeElClasses: ["caption-close", "title"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
            addCaptionHTMLFn: (t, e, s) => {
              this.zoomCaption(t, e, s);
            },
            getThumbBoundsFn: () => {
              const e = this.images[t],
                s = window.scrollY || document.documentElement.scrollTop,
                i = e.getBoundingClientRect();
              return { x: i.left, y: i.top + s, w: i.width };
            },
          }),
            this.thumbsContainer &&
              "" !== s &&
              (this.thumbsContainer.innerHTML = s);
        }
      });
    }
    zoomCaption(t, e) {
      let s = "";
      const i = e.children[0];
      return (
        this.zoomCaptions &&
          ((s = this.zoomCaptions.innerHTML),
          this.zoomCaptions.closest(`.${ep}`)
            ? i.classList.add(ep)
            : i.classList.remove(ep),
          this.zoomCaptions.closest(`.${sp}`)
            ? i.classList.add(sp)
            : i.classList.remove(sp)),
        (i.innerHTML = s),
        !1
      );
    }
    constructor() {
      super(),
        (this.container = this.closest(Gu)),
        (this.images = this.querySelectorAll(Yu)),
        (this.zoomCaptions = this.container.querySelector(Ju)),
        (this.thumbsContainer = document.querySelector(Ku));
    }
  };
  const cp = "[data-add-to-cart]",
    hp = "[data-product-json]",
    dp = "[data-product-form]",
    up = "#cart-bar",
    pp = ".product__submit__add",
    mp = "[data-form-wrapper]",
    vp = "[data-product-variants]",
    gp = "[data-slider]",
    fp = "is-visible",
    yp = "is-loading",
    bp = "data-cart-bar-enabled",
    wp = "data-add-to-cart-bar",
    Ep = "data-cart-bar-scroll",
    Sp = "data-section-id",
    Lp = "data-slider-index",
    kp = {};
  const Ap = {
    onLoad() {
      kp[this.id] = new (class {
        initCartBar() {
          (this.cartBarBtn = this.cartBar.querySelector(pp)),
            this.cartBarBtn &&
              (this.cartBarBtn.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.currentTarget.hasAttribute(wp)
                    ? (this.cartBarEnabled &&
                        (t.currentTarget.classList.add(yp),
                        t.currentTarget.setAttribute("disabled", "disabled")),
                      this.form
                        .querySelector(cp)
                        .dispatchEvent(new Event("click", { bubbles: !0 })))
                    : t.currentTarget.hasAttribute(Ep) && this.scrollToTop();
              }),
              this.cartBarBtn.hasAttribute(wp) &&
                document.addEventListener(
                  "theme:product:add-error",
                  this.scrollToTop
                )),
            this.setCartBarHeight();
        }
        scrollToTop() {
          const t = this.container.querySelector(vp),
            e = (y() ? this.container : t || this.form).getBoundingClientRect()
              .top;
          Tn(y() ? e : e - 10);
        }
        toggleCartBarOnScroll() {
          const t = window.scrollY,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const s = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(fp, s);
          }
        }
        setCartBarHeight() {
          const t = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            "--cart-bar-height",
            `${t}px`
          );
        }
        onUnload() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.cartBarEnabled &&
              (document.removeEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.removeEventListener(
                "theme:resize",
                this.setCartBarHeight
              ));
        }
        onBlockSelect(t) {
          const e = t.srcElement.closest(gp);
          if (e && this.slider.length) {
            const s = e.hasAttribute(Lp) ? e.getAttribute(Lp) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockSelect(t);
          }
        }
        onBlockDeselect(t) {
          const e = t.srcElement.closest(gp);
          if (e && this.slider.length) {
            const s = e.hasAttribute(Lp) ? e.getAttribute(Lp) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockDeselect(t);
          }
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.id = this.container.getAttribute(Sp)),
            (this.sliders = this.container.querySelectorAll(gp)),
            (this.slider = []),
            (this.formWrapper = this.container.querySelector(mp)),
            (this.cartBarEnabled = this.container.hasAttribute(bp)),
            (this.cartBar = this.container.querySelector(up)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.toggleCartBarOnScroll =
              this.toggleCartBarOnScroll.bind(this)),
            (this.unlockTimer = 0),
            (this.accessibility = W);
          const e = this.container.querySelector(hp);
          if ((e && !e.innerHTML) || !e) return;
          const s = JSON.parse(e.innerHTML).handle;
          let i = {};
          s && (i = { handle: s }),
            Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.container.querySelector(dp)),
            this.sliders.length &&
              this.sliders.forEach((t, e) => {
                t.setAttribute(Lp, e),
                  this.slider.push(new An(this.container, t));
              }),
            this.cartBarEnabled &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              document.addEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.addEventListener("theme:resize", this.setCartBarHeight));
        }
      })(this);
    },
    onUnload(t) {
      kp[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      kp[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      kp[this.id].onBlockDeselect(t);
    },
  };
  _o("product", [Ap, Ko, Hc, Sh]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", ch),
    customElements.get("pickup-availability") ||
      customElements.define("pickup-availability", Iu),
    customElements.get("product-form") ||
      customElements.define("product-form", lu),
    customElements.get("product-images") ||
      customElements.define("product-images", Xh),
    customElements.get("product-thumbs") ||
      customElements.define("product-thumbs", yu),
    customElements.get("product-modal") ||
      customElements.define("product-modal", Au),
    customElements.get("product-model") ||
      customElements.define("product-model", Cu),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", mc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", sc),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", mh),
    customElements.get("share-button") ||
      customElements.define("share-button", Th),
    customElements.get("zoom-images") ||
      customElements.define("zoom-images", lp);
  const Cp = "[data-api-related-template]",
    Tp = "[data-related-section]",
    qp = "[data-grid-item]",
    xp = "[data-recent-wrapper]",
    Mp = "[data-recently-viewed-wrapper]",
    Pp = ".product-item",
    Ip = "grid-slider",
    Hp = "data-limit",
    Op = "data-minimum",
    Bp = "data-product-id",
    Dp = "is-hidden",
    Fp = "grid--mobile-slider",
    $p = {};
  const _p = {
    onLoad() {
      $p[this.id] = new (class {
        related() {
          const t = this.container.querySelector(Tp);
          if (!t) return;
          const e = t.getAttribute(Bp),
            s = t.getAttribute(Hp),
            i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
          fetch(i)
            .then((t) => t.text())
            .then((e) => {
              const s = document.createElement("div");
              (s.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(Cp).innerHTML),
                s.querySelector(qp)
                  ? ((t.innerHTML = s.innerHTML),
                    0 ===
                      parseInt(t.style.getPropertyValue("--COLUMNS-MOBILE")) &&
                      t.querySelector(qp).parentElement.classList.add(Fp))
                  : t.dispatchEvent(
                      new CustomEvent("theme:tab:hide", { bubbles: !0 })
                    );
            })
            .catch(function () {
              t.dispatchEvent(
                new CustomEvent("theme:tab:hide", { bubbles: !0 })
              );
            });
        }
        recent() {
          const t = this.container.querySelector(xp),
            e = t ? parseInt(t.getAttribute(Hp)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            target: "api-product-grid-item",
            onComplete: (t, e) => {
              const s = e.container;
              if (!s) return;
              const i = s.querySelector(xp),
                o = s.querySelector(Mp),
                n = t.querySelectorAll(Pp),
                r = i.querySelector(Ip),
                a = i.hasAttribute(Op) ? parseInt(i.getAttribute(Op)) : 4,
                l = !o && n.length > 0,
                c = o && n.length >= a;
              (l || c) &&
                (c && o.classList.remove(Dp),
                i.classList.remove("is-hidden"),
                i.dispatchEvent(
                  new CustomEvent("theme:tab:check", { bubbles: !0 })
                ),
                r &&
                  r.dispatchEvent(
                    new CustomEvent("theme:grid-slider:init", { bubbles: !0 })
                  ));
            },
          });
        }
        constructor(t) {
          (this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent();
        }
      })(this);
    },
  };
  _o("related", [_p, Hc]), _o("reviews", [Cn, hl]);
  const Np = {},
    Rp = "[data-slider-logos]",
    Wp = "[data-slider-text]",
    zp = "[data-slide]",
    Up = "is-selected",
    Vp = "is-initialized",
    jp = "flickity-enabled",
    Xp = "data-slide",
    Jp = "data-slide-index";
  _o("logos", [
    {
      onLoad() {
        Np[this.id] = new (class {
          getSlidesWidth() {
            return 200 * this.logoSlides.length;
          }
          initSlideshowText() {
            this.slideshowText &&
              (this.flkty = new n(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: !1,
                accessibility: !1,
                on: {
                  ready: () => this.sliderAccessibility(),
                  change: () => this.sliderAccessibility(),
                },
              }));
          }
          sliderAccessibility() {
            const t = this.slideshowText.querySelectorAll(
              `${zp} a, ${zp} button`
            );
            t.length &&
              t.forEach((t) => {
                const e = t.closest(zp);
                if (e) {
                  const s = e.classList.contains(Up) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              (this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", () => {
                    const e = parseInt(t.getAttribute(Jp)),
                      s = this.slideshowNav.classList.contains(jp);
                    if ((this.flkty && this.flkty.select(e), s))
                      this.flktyNav.select(e),
                        this.slideshowNav.classList.contains(Up) ||
                          this.flktyNav.playPlayer();
                    else {
                      const e = this.slideshowNav.querySelector(`.${Up}`);
                      e && e.classList.remove(Up), t.classList.add(Up);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            const t = this.slideshowNav.classList.contains(jp);
            if (this.logoSlidesWidth > g()) {
              if (!t) {
                this.slideshowNav.classList.add(Vp);
                const t = this.slideshowNav.querySelector(`.${Up}`);
                t && t.classList.remove(Up),
                  this.logoSlides[0].classList.add(Up),
                  this.flktyNav ||
                    ((this.flktyNav = new o(this.slideshowNav, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      contain: !1,
                      pageDots: !1,
                      wrapAround: !0,
                      watchCSS: !0,
                      selectedAttraction: 0.05,
                      friction: 0.8,
                      initialIndex: 0,
                    })),
                    this.flktyNav.on("deactivate", () => {
                      this.slideshowNav.querySelector(zp).classList.add(Up),
                        this.flkty && this.flkty.select(0);
                    }),
                    this.flkty &&
                      (this.flkty.select(0),
                      this.flktyNav.on("change", (t) => this.flkty.select(t))));
              }
            } else t && this.slideshowNav.classList.remove(Vp);
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            const e = this.slideshowNav.querySelector(
                `[${Xp}="${t.detail.blockId}"]`
              ),
              s = parseInt(e.getAttribute(Jp));
            this.slideshowNav.classList.contains(jp)
              ? (this.flktyNav.select(s),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(Up))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(jp) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(Up));
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize",
              this.setSlideshowNavStateOnResize
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(Rp)),
              (this.slideshowText = this.container.querySelector(Wp)),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              (this.logoSlides = this.slideshowNav.querySelectorAll(zp)),
              (this.logoSlidesWidth = this.getSlidesWidth()),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        Np[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Np[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Np[this.id].onBlockDeselect(t);
      },
    },
    hl,
  ]);
  const Yp = "data-video-play";
  let Qp = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.videoPlay = this.querySelectorAll(`[${Yp}]`)),
        null === (t = this.videoPlay) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("click", (t) => {
              const e = t.currentTarget;
              if ("" !== e.getAttribute(Yp).trim()) {
                t.preventDefault();
                const s = [{ html: e.getAttribute(Yp) }];
                new Xu(s, { mainClass: "pswp--video" }),
                  (window.accessibility.lastElement = e);
              }
            });
          });
    }
    constructor() {
      super();
    }
  };
  const Gp = "[data-video-template]",
    Kp = "is-loading",
    Zp = "data-video-id";
  let tm = class extends HTMLElement {
    connectedCallback() {
      (this.videoId = this.getAttribute(Zp)),
        (this.videoTemplate = this.querySelector(Gp)),
        (this.video = null),
        (this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this)),
        this.videoId && this.renderVideo();
    }
    powerSaverVideoPlay() {
      var t;
      null === (t = this.video) || void 0 === t || t.play();
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(Kp),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                this.video
                  .play()
                  .then(() => {})
                  .catch(() => {
                    document.addEventListener(
                      "click",
                      this.powerSaverVideoPlay,
                      { passive: !0, bubbles: !0, once: !0 }
                    ),
                      document.addEventListener(
                        "touchstart",
                        this.powerSaverVideoPlay,
                        { passive: !0, bubbles: !0, once: !0 }
                      );
                  }),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            e && "function" == typeof this.video.play && this.video.play(),
              e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        { rootMargin: "0px", threshold: [0, 1] }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect(),
        this.videoId &&
          (document.removeEventListener("click", this.powerSaverVideoPlay),
          document.removeEventListener("touchstart", this.powerSaverVideoPlay));
    }
    constructor() {
      super();
    }
  };
  _o("featured-video", [tn]),
    customElements.get("video-background") ||
      customElements.define("video-background", tm),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Qp),
    _o("slideshow", [Cn, tn]);
  const em = "[data-image-holder]",
    sm = "[data-image-element]",
    im = "[data-range-button]",
    om = "[data-range-input]";
  let nm = class extends HTMLElement {
    connectedCallback() {
      this.setOverlapImageSize(),
        this.setImagePosition(),
        this.rangeInput.addEventListener("input", () =>
          this.setImagePosition()
        ),
        document.addEventListener("theme:resize", this.setOverlapImageSize);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.setOverlapImageSize);
    }
    setImagePosition() {
      const t = this.rangeInput.value,
        e = this.imageElement.offsetWidth,
        s = this.rangeButton.offsetWidth;
      (this.rangeButton.style.left = `${t}%`),
        (this.imageHolder.style.width =
          ((e - s) * (100 - t)) / 100 + s / 2 + "px");
    }
    setOverlapImageSize() {
      const t = this.offsetWidth;
      (this.imageElement.style.width = `${t}px`), this.setImagePosition();
    }
    constructor() {
      super(),
        (this.imageHolder = this.querySelector(em)),
        (this.imageElement = this.querySelector(sm)),
        (this.rangeButton = this.querySelector(im)),
        (this.rangeInput = this.querySelector(om)),
        (this.setOverlapImageSize = this.setOverlapImageSize.bind(this));
    }
  };
  _o("custom-content", [Cn, tn, Fn]),
    customElements.get("video-background") ||
      customElements.define("video-background", tm),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Qp),
    customElements.get("compare-images") ||
      customElements.define("compare-images", nm);
  var rm = {};
  function am(t) {
    return rm[t];
  }
  (rm.basic = []),
    (rm.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (rm.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (rm.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let lm = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  _o("map", {
    onLoad() {
      lm[this.id] = new (class {
        initMaps() {
          (function (t) {
            if (null === window.theme.mapAPI) {
              const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
              window.theme.mapAPI = Ou({ url: e });
            }
            return window.theme.mapAPI;
          })(this.key)
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new google.maps.LatLng(this.lat, this.long)
                : ((t = this.address),
                  new Promise((e, s) => {
                    new google.maps.Geocoder().geocode(
                      { address: t },
                      function (t, i) {
                        if ("OK" == i) {
                          var o = {
                            lat: t[0].geometry.location.lat(),
                            lng: t[0].geometry.location.lng(),
                          };
                          e(o);
                        } else s(i);
                      }
                    );
                  }));
              var t;
            })
            .then((t) => {
              const e = {
                  zoom: parseInt(this.zoomString, 10),
                  styles: am(this.styleString),
                  center: t,
                  draggable: !0,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  zoomControl: !1,
                  disableDefaultUI: !0,
                },
                s = (function (t, e) {
                  var s = new google.maps.Map(t, e),
                    i = s.getCenter();
                  return (
                    new google.maps.Marker({ map: s, position: i }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(s, "resize"), s.setCenter(i);
                      }
                    ),
                    s
                  );
                })(this.mapContainer, e);
              return s;
            })
            .then((t) => {
              (this.map = t), (lm[this.id] = t);
            })
            .catch((t) => {
              console.log("Failed to load Google Map"), console.log(t);
            });
        }
        unload() {
          void 0 !== window.google &&
            google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(t) {
          (this.container = t.container),
            (this.mapContainer = this.container.querySelector(
              "[data-map-container]"
            )),
            (this.key = this.container.getAttribute("data-api-key")),
            (this.styleString =
              this.container.getAttribute("data-style") || ""),
            (this.zoomString = this.container.getAttribute("data-zoom") || 14),
            (this.address = this.container.getAttribute("data-address")),
            (this.enableCorrection = this.container.getAttribute(
              "data-latlong-correction"
            )),
            (this.lat = this.container.getAttribute("data-lat")),
            (this.long = this.container.getAttribute("data-long")),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof lm[this.id].unload && lm[this.id].unload();
    },
  });
  const cm = "[data-large-promo]",
    hm = "[data-large-promo-inner]",
    dm = "[data-tracking-consent]",
    um = "[data-confirm-cookies]",
    pm = "cart-bar",
    mm = "[data-newsletter]",
    vm = "[data-newsletter-holder]",
    gm = "[data-newsletter-heading]",
    fm = "[data-newsletter-field]",
    ym = "[data-promo-text]",
    bm = "[data-newsletter-form]",
    wm = "data-popup-delay",
    Em = "data-cookie-name",
    Sm = "data-target-referrer",
    Lm = "hidden",
    km = "has-value",
    Am = "cart-bar-visible",
    Cm = "is-visible",
    Tm = "has-success",
    qm = "selected",
    xm = "has-block-selected",
    Mm = "mobile",
    Pm = "desktop",
    Im = "bottom",
    Hm = "data-enable";
  let Om = {},
    Bm = class {
      always() {
        this.popupActions.popupOpen();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.popupActions.popupOpen();
        }, 1e3 * t);
      }
      idle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupActions.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupActions.popupOpen(),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, s) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute(wm)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.popupActions = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    Dm = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(Sm)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(Sm))
        )
          return !1;
        this.init();
      }
    };
  const Fm = {
    onLoad() {
      Om[this.id] = [];
      this.container.querySelectorAll(cm).forEach((t) => {
        Om[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e = this.popup.classList.contains(Mm),
                s = this.popup.classList.contains(Pm),
                i = !y();
              let o = !0;
              if ((((e && !i) || (s && i)) && (o = !1), !o))
                return (
                  this.a11y.removeTrapFocus(),
                  void document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  )
                );
              (t && !window.Shopify.designMode) ||
                (window.Shopify.designMode ||
                  window.location.pathname.endsWith("/challenge") ||
                  new Bm(this.popup, this.modal, this.popupActions),
                this.form &&
                  this.form.classList.contains(Tm) &&
                  this.checkForSuccess(),
                this.modal.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(qm),
                this.popup.parentNode.classList.add(xm));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(qm),
                this.popup.parentNode.classList.remove(xm));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = this.popup.querySelector(hm)),
                (this.form = this.popup.querySelector(bm)),
                (this.cookie = new qn(
                  this.popup.getAttribute(Em),
                  "user_has_closed"
                )),
                (this.isTargeted = new Dm(this.popup)),
                (this.popupActions = new Lu(this.modal, this.modal, !0, !0)),
                (this.a11y = W),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(dm).forEach((t) => {
        Om[this.id].push(
          new (class {
            init() {
              this.showPopup && this.popupActions.popupOpen(),
                this.clickEvents();
            }
            clickEvents() {
              this.acceptButton.addEventListener("click", (t) => {
                t.preventDefault(),
                  window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                    this.popupActions.popupClose()
                  ),
                  document.documentElement.style.setProperty(
                    "--cookie-bar-height",
                    "0px"
                  );
              }),
                document.addEventListener("trackingConsentAccepted", () => {});
            }
            onSelect() {
              this.showPopup &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(qm),
                this.popup.parentNode.classList.add(xm));
            }
            onDeselect() {
              this.showPopup &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(qm),
                this.popup.parentNode.classList.remove(xm));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = document.querySelector(dm)),
                (this.acceptButton = this.modal.querySelector(um)),
                (this.enable = "true" === this.modal.getAttribute(Hm)),
                (this.showPopup = !1),
                (this.popupActions = new Lu(this.popup, this.popup, !1, !1)),
                window.Shopify.loadFeatures(
                  [{ name: "consent-tracking-api", version: "0.1" }],
                  (t) => {
                    if (t) throw t;
                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                      s = window.Shopify.customerPrivacy.getTrackingConsent();
                    (this.showPopup =
                      !e && "no_interaction" === s && this.enable),
                      window.Shopify.designMode && (this.showPopup = !0),
                      this.init();
                  }
                );
            }
          })(t)
        );
      });
      this.container.querySelectorAll(mm).forEach((t) => {
        Om[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e =
                  -1 !==
                  window.location.search.indexOf("?customer_posted=true"),
                s = [...this.holder.classList].toString().includes(Im);
              e && (this.delay = 0),
                (t && !window.Shopify.designMode) ||
                  (this.show(),
                  this.form.classList.contains(Tm) && this.checkForSuccess()),
                s && this.observeCartBar();
            }
            show() {
              window.location.pathname.endsWith("/challenge") ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Bm(this.popup, this.holder, this.popupActions)),
                this.showForm(),
                this.inputField(),
                this.holder.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                );
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            observeCartBar() {
              if (((this.cartBar = document.getElementById(pm)), !this.cartBar))
                return;
              let t = this.cartBar.classList.contains(Cm);
              document.body.classList.toggle(Am, t),
                (this.observer = new MutationObserver((e) => {
                  for (const s of e)
                    "attributes" === s.type &&
                      ((t = s.target.classList.contains(Cm)),
                      document.body.classList.toggle(Am, t));
                })),
                this.observer.observe(this.cartBar, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                });
            }
            showForm() {
              this.heading.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.heading.classList.add(Lm),
                  this.form.classList.remove(Lm),
                  this.newsletterField.focus();
              }),
                this.heading.addEventListener("keyup", (t) => {
                  "Enter" === t.code &&
                    this.heading.dispatchEvent(new Event("click"));
                });
            }
            inputField() {
              const t = () => {
                this.resetClassTimer && clearTimeout(this.resetClassTimer),
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(km);
              };
              this.newsletterField.addEventListener("input", t),
                this.newsletterField.addEventListener("focus", t),
                this.newsletterField.addEventListener("focusout", () => {
                  this.resetClassTimer && clearTimeout(this.resetClassTimer),
                    (this.resetClassTimer = setTimeout(() => {
                      this.holder.classList.remove(km);
                    }, 2e3));
                });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(qm),
                this.popup.parentNode.classList.add(xm));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(qm),
                this.popup.parentNode.classList.remove(xm));
            }
            onUnload() {
              this.observer && this.observer.disconnect();
            }
            constructor(t) {
              (this.popup = t),
                (this.holder = this.popup.querySelector(vm)),
                (this.heading = this.popup.querySelector(gm)),
                (this.newsletterField = this.popup.querySelector(fm)),
                (this.cookie = new qn(
                  this.popup.getAttribute(Em),
                  "newsletter_is_closed"
                )),
                (this.form = this.popup.querySelector(bm)),
                (this.isTargeted = new Dm(this.popup)),
                (this.popupActions = new Lu(this.holder, this.holder, !1, !1)),
                (this.resetClassTimer = 0),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(ym).forEach((t) => {
        Om[this.id].push(
          new (class {
            init() {
              (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Bm(this.popup, this.popup, this.popupActions),
                this.popup.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            onSelect() {
              this.popupActions.popupOpen(),
                this.popup.classList.add(qm),
                this.popup.parentNode.classList.add(xm);
            }
            onDeselect() {
              this.popupActions.popupClose(),
                this.popup.classList.remove(qm),
                this.popup.parentNode.classList.remove(xm);
            }
            constructor(t) {
              (this.popup = t),
                (this.cookie = new qn(
                  this.popup.getAttribute(Em),
                  "user_has_closed"
                )),
                (this.isTargeted = new Dm(this.popup)),
                (this.popupActions = new Lu(this.popup, this.popup, !1, !1)),
                this.init();
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      Om[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      Om[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
    onSelect() {
      Om[this.id].forEach((t) => {
        "function" == typeof t.onSelect && t.onSelect();
      });
    },
    onDeselect() {
      Om[this.id].forEach((t) => {
        "function" == typeof t.onDeselect && t.onDeselect();
      });
    },
    onUnload() {
      Om[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  _o("popups", [Fm, Fn]);
  const $m = "[data-password-modal]",
    _m = "#login_form .errors";
  _o("password-template", {
    onLoad() {
      new (class {
        constructor(t) {
          (this.container = t.container),
            (this.popupActions = new Lu(
              this.container.querySelector($m),
              this.container,
              !0,
              !0
            )),
            this.container.querySelector(_m) && this.popupActions.popupOpen();
        }
      })(this);
    },
  }),
    _o("list-collections", [Cn, hl]),
    _o("columns", [hl, Cn]),
    _o("newsletter", Fn),
    customElements.get("compare-images") ||
      customElements.define("compare-images", nm);
  const Nm = "[data-scroll-to]",
    Rm = "[data-tooltip]",
    Wm = "[data-collapsible-trigger]",
    zm = "open",
    Um = "data-scroll-to",
    Vm = "data-tooltip-stop-mouseenter",
    jm = {};
  const Xm = {
      onLoad() {
        jm[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                const e = this.container.querySelector(t.getAttribute(Um));
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            Tn(t.getBoundingClientRect().top + 1);
            const e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              const t = null == e ? void 0 : e.querySelector(Wm);
              e.hasAttribute(zm) ||
                null == t ||
                t.dispatchEvent(new Event("click"));
            }
            const s = document.querySelectorAll(`${Rm}:not([${Vm}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(Vm, ""),
                  setTimeout(() => {
                    t.removeAttribute(Vm);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons = this.container.querySelectorAll(Nm)),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    Jm = "[data-scroll-spy]",
    Ym = "is-selected",
    Qm = "data-scroll-spy",
    Gm = "data-scroll-spy-mobile",
    Km = "data-scroll-spy-desktop",
    Zm = "data-scroll-trigger-point",
    tv = {};
  const ev = {
    onLoad() {
      var t;
      (tv[this.id] = []),
        null === (t = this.container.querySelectorAll(Jm)) ||
          void 0 === t ||
          t.forEach((t) => {
            const e = this.container.querySelector(t.getAttribute(Qm));
            tv[this.id].push(
              new (class {
                init() {
                  this.toggleScrollObserver(),
                    document.addEventListener(
                      "theme:resize:width",
                      this.toggleScrollObserver
                    );
                }
                toggleScrollObserver() {
                  this.isEligible()
                    ? this.initialized ||
                      (document.addEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !0))
                    : (document.removeEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !1));
                }
                isEligible() {
                  const t = y();
                  return (
                    (!t && this.anchor.hasAttribute(Gm)) ||
                    (t && this.anchor.hasAttribute(Km)) ||
                    (!this.anchor.hasAttribute(Km) &&
                      !this.anchor.hasAttribute(Gm))
                  );
                }
                onScroll() {
                  this.top = this.elementToSpy.getBoundingClientRect().top;
                  const t = Math.round(window.innerHeight),
                    e = Math.round(window.scrollY),
                    s = e + t,
                    i = Math.round(this.top + e),
                    o = this.elementToSpy.offsetHeight;
                  i < s &&
                    !(i + o < e) &&
                    this.triggerPointReached() &&
                    (this.anchorSiblings.forEach((t) => {
                      t.matches(this.anchorSelector) || t.classList.remove(Ym);
                    }),
                    this.anchor.classList.add(Ym));
                }
                triggerPointReached() {
                  let t = !1;
                  switch (this.triggerPoint) {
                    case "top":
                    default:
                      t = this.top <= 0;
                      break;
                    case "middle":
                      t = this.top <= window.innerHeight / 2;
                      break;
                    case "bottom":
                      t = this.top <= window.innerHeight;
                  }
                  return t;
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:resize:width",
                    this.toggleScrollObserver
                  ),
                    document.removeEventListener(
                      "theme:scroll",
                      this.scrollCallback
                    );
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.elementToSpy = e),
                    (this.anchorSelector = `[${Qm}="#${this.elementToSpy.id}"]`),
                    (this.anchor = this.container.querySelector(
                      this.anchorSelector
                    )),
                    (this.anchorSiblings = this.container.querySelectorAll(
                      `[${Qm}]`
                    )),
                    (this.initialized = !1),
                    this.anchor &&
                      ((this.triggerPoint = this.anchor.getAttribute(Zm)),
                      (this.scrollCallback = () => this.onScroll()),
                      (this.toggleScrollObserver =
                        this.toggleScrollObserver.bind(this)),
                      this.init());
                }
              })(this.container, e)
            );
          });
    },
    onUnload() {
      tv[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  _o("sidebar", [Xm, ev]);
  const sv = "[data-hover-target]",
    iv = "[data-collection-image]",
    ov = "data-hover-target",
    nv = "is-visible",
    rv = "is-selected";
  let av = {};
  _o("collections-hover", [
    {
      onLoad() {
        av[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  const e = t.currentTarget.getAttribute(ov);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            const e = this.container.querySelector(`[${ov}="${t}"]`),
              s = this.container.querySelector(`#${t}:not(.${nv})`),
              i = this.container.querySelector(`${sv}.${rv}`),
              o = this.container.querySelector(`${iv}.${nv}`);
            s &&
              y() &&
              (null == o || o.classList.remove(nv),
              null == i || i.classList.remove(rv),
              s.classList.add(nv),
              e.classList.add(rv));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(sv)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        av[this.id].onBlockSelect(t);
      },
    },
    ev,
  ]);
  const lv = "[data-featured-image]",
    cv = "[data-featured-aside]",
    hv = "[data-featured-content]",
    dv = "[data-featured-wrapper]",
    uv = "data-horizontal-scroll",
    pv = "data-horizontal-scroll-reversed",
    mv = {};
  _o("featured-product", [
    {
      onLoad() {
        mv[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              ((this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              )),
              document.addEventListener("theme:scroll", this.scrollEvent)),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          scrollEvents() {
            this.requestAnimationSticky ||
              (this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              ));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null));
          }
          calculateHorizontalPosition() {
            let t = window.scrollY + this.headerHeight;
            const e = t + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              i = this.imagesHolder.offsetHeight,
              o = s + i + this.headerHeight,
              n = i - (window.innerHeight - this.headerHeight),
              r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
              (a *= this.images.length - 1),
              this.container.style.setProperty("--translateX", a * r + "%"),
              this.lastPercent !== a
                ? (this.requestAnimationSticky = requestAnimationFrame(
                    this.calculateHorizontalPositionEvent
                  ))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.lastPercent = a);
          }
          calculateHeight() {
            let { stickyHeaderHeight: t } = c();
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = t);
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(uv)),
              (this.horizontalScrollReversed = this.container.hasAttribute(pv)),
              (this.images = this.container.querySelectorAll(lv)),
              (this.imagesHolder = this.container.querySelector(cv)),
              (this.contentHolder = this.container.querySelector(hv)),
              (this.wrapper = this.container.querySelector(dv)),
              (this.requestAnimationSticky = null),
              (this.lastPercent = 0),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.calculateHorizontalPositionEvent = () =>
                this.calculateHorizontalPosition()),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        mv[this.id].onUnload(t);
      },
    },
  ]);
  const vv = "[data-timeline-holder]",
    gv = "[data-timeline-rows]",
    fv = "[data-timeline-row]",
    yv = "[data-timeline-row-editor]",
    bv = "[data-timeline-button]",
    wv = "[data-block-scroll]",
    Ev = "is-selected",
    Sv = {};
  _o("timeline", [
    {
      onLoad() {
        Sv[this.id] = new (class {
          init() {
            this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              )),
              this.isDesktopView &&
                !this.isScrollEnabled &&
                ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.addEventListener("scroll", this.scrollEvent),
              document.addEventListener("theme:resize:width", this.resizeEvent),
              this.buttons.length &&
                this.buttons.forEach((t, e) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = t.currentTarget.closest(fv);
                    if (!s) return;
                    const i = Math.max(...this.rowsHeight),
                      o = this.holderHeight / this.rows.length,
                      n = this.holder.getBoundingClientRect().top,
                      r = e > 0 && i < o ? o * e + n : n,
                      a = y() ? r + 1 : s.getBoundingClientRect().top;
                    Tn(a);
                  });
                });
          }
          resizeEvents() {
            (this.holderTop =
              this.holder.getBoundingClientRect().top + window.scrollY),
              (this.holderHeight = this.holder.offsetHeight),
              this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              ));
            const t = y();
            t && !this.isScrollEnabled
              ? ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent))
              : !t &&
                this.isScrollEnabled &&
                ((this.isScrollEnabled = !1),
                document.removeEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            if (!this.requestAnimation) {
              const e = t.currentTarget;
              this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition(e)
              );
            }
          }
          removeAnimationFrame() {
            this.requestAnimation &&
              (cancelAnimationFrame(this.requestAnimation),
              (this.requestAnimation = null));
          }
          calculateRowsDimensions() {
            if (this.rows.length) {
              (this.rowsHeight = []), (this.rowsWidth = 0);
              let t = 0;
              this.rows.forEach((e, s) => {
                if (
                  (this.rowsHeight.push(e.offsetHeight),
                  (this.rowsWidth +=
                    e.offsetWidth + parseInt(getComputedStyle(e).marginRight)),
                  window.Shopify.designMode)
                ) {
                  const n = this.container.querySelectorAll(yv);
                  var i, o;
                  n.length &&
                    ((t += e.offsetHeight),
                    null === (i = n[s]) ||
                      void 0 === i ||
                      i.style.setProperty(
                        "--row-height-min",
                        `${e.offsetHeight}px`
                      ),
                    null === (o = n[s + 1]) ||
                      void 0 === o ||
                      o.style.setProperty("--row-top-mobile", `${t}px`));
                }
              });
            }
          }
          calculatePosition(t = null) {
            this.removeAnimationFrame();
            const e = y(),
              s = this.holderHeight / this.rows.length;
            let i = this.holderTop;
            const o = window.innerHeight,
              n = window.scrollY + 1.5 * o;
            let r = 0;
            if (!e && t) {
              const e = t.scrollLeft - 16,
                s = t.offsetWidth;
              (r = (e / (this.rowsWidth - s)) * 100),
                this.holder.style.setProperty("--percent-mobile", `${r}%`);
            }
            (e &&
              (n < this.holderTop ||
                n > this.holderTop + this.holderHeight + o)) ||
              this.rows.forEach((t, o) => {
                if (o > 0) {
                  const o = (t.offsetLeft / this.rowsWidth) * 100;
                  let l = r > o;
                  var a;
                  e &&
                    ((l = i + s < n),
                    i - s < n &&
                      (null === (a = t.previousElementSibling) ||
                        void 0 === a ||
                        a.style.setProperty(
                          "--percent-desktop",
                          ((n - i) / s) * 100 + "%"
                        ))),
                    t.classList.toggle(Ev, l);
                }
                i += s;
              });
          }
          onUnload() {
            this.isScrollEnabled &&
              ((this.isScrollEnabled = !1),
              document.removeEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.removeEventListener("scroll", this.scrollEvent),
              document.removeEventListener(
                "theme:resize:width",
                this.resizeEvent
              );
          }
          onBlockSelect(t) {
            const e = this.container.querySelector(wv);
            if (e) {
              const s = t.srcElement,
                i = [...s.parentElement.children].indexOf(s),
                o = this.rows[i];
              o &&
                e.scrollTo({ top: 0, left: o.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            (this.container = t.container),
              (this.rows = this.container.querySelectorAll(fv)),
              (this.holder = this.container.querySelector(vv)),
              this.rows.length < 2 ||
                !this.holder ||
                ((this.rowsWidth = 0),
                (this.rowsHeight = []),
                (this.holderTop =
                  this.holder.getBoundingClientRect().top + window.scrollY),
                (this.holderHeight = this.holder.offsetHeight),
                (this.buttons = this.container.querySelectorAll(bv)),
                (this.rowsHolder = this.container.querySelector(gv)),
                (this.requestAnimation = null),
                (this.isDesktopView = y()),
                (this.isScrollEnabled = !1),
                (this.scrollEvent = (t) => this.scrollEvents(t)),
                (this.resizeEvent = () => this.resizeEvents()),
                this.init());
          }
        })(this);
      },
      onUnload(t) {
        Sv[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Sv[this.id].onBlockSelect(t);
      },
    },
  ]),

document.querySelector('details').addEventListener('toggle', function(event) {
  if (event.target.open) {
    document.querySelector('.search-bar').style.display = 'block';
  } else {
    document.querySelector('.search-bar').style.display = 'none';
  }
});

    
    document.addEventListener("DOMContentLoaded", function () {
      No("*");
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          Ou({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));




(() => {
  /* ======================================================
     CONFIG
  ====================================================== */
  const MEDIA_LIST = ".product__slides[data-product-media-list]";
  const FIGURE_SELECTOR = "figure.image-wrapper";
  const ZOOM = 2;
  const TRANSITION_IN = "transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)";
  const TRANSITION_OUT = "transform 360ms cubic-bezier(0.22, 0.61, 0.36, 1)";
  const OPEN_CLASS = "custom-lightbox--open";

  // tap/click zoom target
  const LIGHTBOX_ZOOM = 2.5;

  // pinch bounds
  const LB_MIN = 1;
  const LB_MAX = 4;

  // swipe
  const SWIPE_TRIGGER = 55;
  const MAX_DRAG = 120;

  const isDesktopHover = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ======================================================
     LIGHTBOX STATE
  ====================================================== */
  let lbScale = 1;
  let lbPanX = 0;
  let lbPanY = 0;

  let lbOpenerEl = null;

  const lbZoomed = () => lbScale > 1;

  /* ======================================================
     SLIDES STATE (variant filtered)
  ====================================================== */
  const state = { slides: [], index: 0 };
  const norm = (v) => (v || "").trim().toLowerCase();

  const collectSlides = (listEl, onlyAlt = "") => {
    const want = norm(onlyAlt);
    const figures = [...listEl.querySelectorAll("[data-slide] " + FIGURE_SELECTOR)];

    const slides = figures
      .map((figure) => {
        const img = figure.querySelector("img");
        if (!img) return null;

        const slide = figure.closest("[data-slide]");
        const vAlt = slide?.getAttribute("data-variant-alt") || "";

        return {
          src: img.currentSrc || img.src,
          alt: img.alt || "",
          variantAlt: vAlt,
          figure,
        };
      })
      .filter(Boolean);

    const filtered = want ? slides.filter((s) => norm(s.variantAlt) === want) : slides;
    return filtered.length ? filtered : slides;
  };

  /* ======================================================
     LIGHTBOX DOM + CSS (built once)
  ====================================================== */
  const buildLightbox = () => {
    if (document.querySelector(".custom-lightbox")) return;

    const el = document.createElement("div");
    el.className = "custom-lightbox";
    el.innerHTML = `
      <div class="custom-lightbox__backdrop" data-clb-close></div>
      <div class="custom-lightbox__ui" role="dialog" aria-modal="true" aria-label="Image viewer">
        <button class="custom-lightbox__close" type="button" data-clb-close aria-label="Close">×</button>
        <button class="custom-lightbox__nav custom-lightbox__prev" type="button" data-clb-prev aria-label="Previous">‹</button>
        <button class="custom-lightbox__nav custom-lightbox__next" type="button" data-clb-next aria-label="Next">›</button>

        <div class="custom-lightbox__stage">
          <div class="custom-lightbox__track" aria-hidden="true">
            <img class="custom-lightbox__img custom-lightbox__img--prev" alt="">
            <img class="custom-lightbox__img custom-lightbox__img--current" alt="">
            <img class="custom-lightbox__img custom-lightbox__img--next" alt="">
          </div>
        </div>

        <div class="custom-lightbox__counter" aria-hidden="true"></div>
      </div>
    `;
    document.body.appendChild(el);

    const style = document.createElement("style");
    style.textContent = `
      .custom-lightbox{ position:fixed; inset:0; display:none; z-index:999999; }
      .custom-lightbox.${OPEN_CLASS}{ display:block; }
      .custom-lightbox__backdrop{ position:absolute; inset:0; background:rgba(0,0,0,.78); }
      .custom-lightbox__ui{ position:absolute; inset:0; display:flex; align-items:center; justify-content:center; }

      .custom-lightbox__stage{
        position:relative;
        width:100%;
        max-width:min(92vw,980px);
        max-height:86vh;
        display:flex;
        align-items:center;
        justify-content:center;
        overflow:hidden;
        cursor:none;
        touch-action:none; /* we handle gestures */
      }

      .custom-lightbox__track{
        display:flex;
        width:300%;
        transform:translateX(-100%);
        will-change:transform;
      }

      .custom-lightbox__track > img{
        width:100%;
        flex:0 0 100%;
        max-height:86vh;
        object-fit:contain;
        display:block;
        user-select:none;
        -webkit-user-drag:none;
        touch-action:none;
      }

      .custom-lightbox__close{
        position:absolute; top:18px; right:18px; width:44px; height:44px;
        border-radius:12px; border:0; background:rgba(255,255,255,.9);
        font-size:30px; line-height:44px; cursor:pointer;
      }
      .custom-lightbox__nav{
        position:absolute; top:50%; transform:translateY(-50%);
        width:44px; height:44px; border-radius:12px; border:0;padding-bottom: 5px;
        background:rgba(255,255,255,.9); font-size:38px; cursor:pointer;
      }
      .custom-lightbox__prev{ left:18px; }
      .custom-lightbox__next{ right:18px; }

      .custom-lightbox__counter{
        position:absolute; bottom:10%; left:50%; transform:translateX(-50%);
        padding:6px 10px; border-radius:999px; background:rgba(255,255,255,.9); font-size:13px;
      }

      @media (max-width:749px){
        .custom-lightbox__nav{ display:none; }
        .custom-lightbox__track > img{ max-height:82vh; }
      }

      /* Lightbox cursor icon */
      .custom-lightbox__zoom-cursor{
        position:fixed;
        left:0; top:0;
        width:34px; height:34px;
        border-radius:10px;
        background:rgba(255,255,255,.92);
        box-shadow:0 6px 20px rgba(0,0,0,.15);
        display:grid;
        place-items:center;
        pointer-events:none;
        opacity:0;
        transform:translate(-50%, -50%);
        z-index:1000000;
        transition:opacity 140ms ease;
      }
      .custom-lightbox__zoom-cursor.is-visible{ opacity:1; }
      .custom-lightbox__zoom-cursor::before,
      .custom-lightbox__zoom-cursor::after{
        content:"";
        position:absolute;
        background:#111;
        border-radius:2px;
      }
      .custom-lightbox__zoom-cursor::before{ width:14px; height:2px; }
      .custom-lightbox__zoom-cursor::after{ width:2px; height:14px; }
      .custom-lightbox__zoom-cursor.is-zoomed::after{ height:0; }
    `;
    document.head.appendChild(style);
  };

  /* ======================================================
     SCROLL LOCK
  ====================================================== */
  const lockScroll = () => {
  const y = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.dataset.clbScrollY = String(y);

  const sbw = window.innerWidth - document.documentElement.clientWidth;
  if (sbw > 0) document.body.style.paddingRight = sbw + "px";

  document.body.style.position = "fixed";
  document.body.style.top = `-${y}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
};

const unlockScroll = () => {
  const y = parseInt(document.body.dataset.clbScrollY || "0", 10);


  const html = document.documentElement;
  const prevBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  document.body.style.paddingRight = "";
  delete document.body.dataset.clbScrollY;


  requestAnimationFrame(() => {
    window.scrollTo(0, y);
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevBehavior || "";
    });
  });
};

  const lightboxOpen = () =>
    !!document.querySelector(`.custom-lightbox.${OPEN_CLASS}`);

  /* ======================================================
     LIGHTBOX HELPERS
  ====================================================== */
  const getLb = () => document.querySelector(".custom-lightbox");
  const getStage = () => getLb()?.querySelector(".custom-lightbox__stage") || null;
  const getTrack = () => getLb()?.querySelector(".custom-lightbox__track") || null;
  const getCurImg = () => getLb()?.querySelector(".custom-lightbox__img--current") || null;

  const ensureLightboxCursor = () => {
    let cur = document.querySelector(".custom-lightbox__zoom-cursor");
    if (cur) return cur;
    cur = document.createElement("div");
    cur.className = "custom-lightbox__zoom-cursor";
    cur.setAttribute("aria-hidden", "true");
    document.body.appendChild(cur);
    return cur;
  };

  const setLightboxCursorState = () => {
    const cur = document.querySelector(".custom-lightbox__zoom-cursor");
    if (!cur) return;
    cur.classList.toggle("is-zoomed", lbZoomed());
  };

  const showLbCursor = (x, y) => {
    const cur = ensureLightboxCursor();
    cur.style.left = x + "px";
    cur.style.top = y + "px";
    cur.classList.add("is-visible");
    setLightboxCursorState();
  };

  const hideLbCursor = () => {
    const cur = document.querySelector(".custom-lightbox__zoom-cursor");
    if (cur) cur.classList.remove("is-visible");
  };

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  const getMaxPan = () => {
    const stage = getStage();
    if (!stage) return { maxX: 0, maxY: 0 };

    const rect = stage.getBoundingClientRect();
    const extraX = (lbScale - 1) * rect.width;
    const extraY = (lbScale - 1) * rect.height;

    return { maxX: extraX / 2, maxY: extraY / 2 };
  };

  const clampPan = () => {
    const { maxX, maxY } = getMaxPan();
    lbPanX = clamp(lbPanX, -maxX, maxX);
    lbPanY = clamp(lbPanY, -maxY, maxY);
  };

  const applyLbTransform = () => {
    const img = getCurImg();
    if (!img) return;

    if (lbScale <= 1) {
      img.style.transform = "";
      return;
    }

    clampPan();
    img.style.transformOrigin = "center center";
    img.style.transform = `translate(${lbPanX}px, ${lbPanY}px) scale(${lbScale})`;
  };

  const setPanFromPointer = (e) => {
    const stage = getStage();
    if (!stage) return;

    const rect = stage.getBoundingClientRect();
    const nx = (e.clientX - rect.left) / rect.width - 0.5; // -0.5..0.5
    const ny = (e.clientY - rect.top) / rect.height - 0.5;

    const { maxX, maxY } = getMaxPan();
    lbPanX = clamp(-nx * (maxX * 2), -maxX, maxX);
    lbPanY = clamp(-ny * (maxY * 2), -maxY, maxY);

    applyLbTransform();
  };

  const resetZoom = () => {
    lbScale = 1;
    lbPanX = 0;
    lbPanY = 0;
    applyLbTransform();
    setLightboxCursorState();
  };

  /* ======================================================
     RENDER / OPEN / CLOSE
  ====================================================== */
  const render = () => {
    const lb = getLb();
    if (!lb) return;

    const counter = lb.querySelector(".custom-lightbox__counter");
    const track = getTrack();

    const prevImg = lb.querySelector(".custom-lightbox__img--prev");
    const curImg = lb.querySelector(".custom-lightbox__img--current");
    const nextImg = lb.querySelector(".custom-lightbox__img--next");

    const total = state.slides.length;
    const i = state.index;

    const prevIndex = (i - 1 + total) % total;
    const nextIndex = (i + 1) % total;

    const sPrev = state.slides[prevIndex];
    const sCur = state.slides[i];
    const sNext = state.slides[nextIndex];

    prevImg.src = sPrev.src; prevImg.alt = sPrev.alt || "";
    curImg.src  = sCur.src;  curImg.alt  = sCur.alt  || "";
    nextImg.src = sNext.src; nextImg.alt = sNext.alt || "";

    // reset track to center (no animation)
    if (track) {
      track.style.transition = "none";
      track.style.transform = "translateX(-100%)";
    }

    if (counter) counter.textContent = `${i + 1} / ${total}`;

    // reset zoom when changing slide
    resetZoom();
  };

  const openAt = (clickedFigure, listEl) => {
  buildLightbox();
  ensureLightboxCursor();

  lbOpenerEl = clickedFigure; // 🔑 remember opener

  const clickedSlide = clickedFigure.closest("[data-slide]");
  const onlyAlt = clickedSlide?.getAttribute("data-variant-alt") || "";

  state.slides = collectSlides(listEl, onlyAlt);
  if (!state.slides.length) return;

  state.index = state.slides.findIndex((s) => s.figure === clickedFigure);
  if (state.index < 0) state.index = 0;

  const lb = getLb();
  lb.classList.add(OPEN_CLASS);
  lockScroll();
  render();
};

  const close = () => {
  const lb = getLb?.() || document.querySelector(".custom-lightbox");
  if (!lb) return;

  lb.classList.remove(OPEN_CLASS);

  try {

    lbScale = 1;
    lbPanX = 0;
    lbPanY = 0;


    const track = lb.querySelector(".custom-lightbox__track");
    if (track) {
      track.style.transition = "none";
      track.style.transform = "translateX(-100%)";
    }

   
    hideLbCursor?.();
    const cur = document.querySelector(".custom-lightbox__zoom-cursor");
    if (cur) cur.classList.remove("is-visible");

 
    lb.querySelectorAll(".custom-lightbox__img").forEach((img) => {
      img.style.transform = "";
      img.style.transformOrigin = "";
    });
  } finally {
  
    unlockScroll();

  
    if (lbOpenerEl && typeof lbOpenerEl.focus === "function") {
      try {
        lbOpenerEl.focus({ preventScroll: true });
      } catch (e) {
        lbOpenerEl.focus();
      }
    }
    lbOpenerEl = null;
  }
};

  const next = () => {
    state.index = (state.index + 1) % state.slides.length;
    render();
  };

  const prev = () => {
    state.index = (state.index - 1 + state.slides.length) % state.slides.length;
    render();
  };

  /* ======================================================
     BIND CLICK (CAPTURE to beat PhotoSwipe)
  ====================================================== */
  const bindClicks = (root = document) => {
    const list = root.querySelector(MEDIA_LIST);
    if (!list || list.dataset.customLbCaptureBound) return;
    list.dataset.customLbCaptureBound = "true";

    list.addEventListener(
      "click",
      (e) => {
        const figure = e.target.closest(FIGURE_SELECTOR);
        if (!figure || !list.contains(figure)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        openAt(figure, list);
      },
      true
    );
  };

  /* ======================================================
     HOVER ZOOM (DESKTOP ONLY)
  ====================================================== */
  const bindHover = (root = document) => {
    const list = root.querySelector(MEDIA_LIST);
    if (!list) return;
    if (list.dataset.hoverZoomBound2 === "true") return;
    list.dataset.hoverZoomBound2 = "true";

    let activeImg = null;
    let activeTile = null;
    let rafId = null;
    let lastEvent = null;

    const clearImg = () => {
      if (!activeImg) return;
      activeImg.style.transition = TRANSITION_OUT;
      activeImg.style.transform = "";
      activeImg.style.transformOrigin = "";
      activeImg.style.cursor = "";
      activeImg = null;
      activeTile = null;
    };

    const updateOrigin = () => {
      rafId = null;
      if (!lastEvent || !activeImg || !activeTile) return;

      const rect = activeTile.getBoundingClientRect();
      const x = ((lastEvent.clientX - rect.left) / rect.width) * 100;
      const y = ((lastEvent.clientY - rect.top) / rect.height) * 100;
      activeImg.style.transformOrigin = `${x}% ${y}%`;
    };

    const onMove = (e) => {
      if (!isDesktopHover()) return;
      if (lightboxOpen()) return;

      const tile = e.target.closest(FIGURE_SELECTOR);
      if (!tile || !list.contains(tile)) return;

      const img = tile.querySelector("img");
      if (!img) return;

      if (img !== activeImg) {
        clearImg();
        activeImg = img;
        activeTile = tile;

        setTimeout(() => {
          if (!activeImg) return;
          activeImg.style.transition = TRANSITION_IN;
          activeImg.style.transform = `scale(${ZOOM})`;
        }, 40);

        activeImg.style.cursor = "zoom-in";
      }

      lastEvent = e;
      if (!rafId) rafId = requestAnimationFrame(updateOrigin);
    };

    const onLeave = () => {
      lastEvent = null;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
      clearImg();
    };

    list.addEventListener("pointermove", onMove);
    list.addEventListener("pointerleave", onLeave);
    window.addEventListener("blur", onLeave);
  };

  /* ======================================================
     LIGHTBOX CURSOR + FOLLOW-MOUSE PAN (DESKTOP)
  ====================================================== */
  const bindLightboxCursorAndPan = () => {
    if (!isDesktopHover()) return;
    if (document.body.dataset.clbLbCursorPanBound === "true") return;
    document.body.dataset.clbLbCursorPanBound = "true";

    let raf = null;
    let lastEvent = null;

    const tick = () => {
      raf = null;

      const lb = getLb();
      const stage = getStage();
      if (!lb || !lb.classList.contains(OPEN_CLASS) || !stage || !lastEvent) {
        hideLbCursor();
        return;
      }

      if (!stage.contains(lastEvent.target)) {
        hideLbCursor();
        return;
      }

      showLbCursor(lastEvent.clientX, lastEvent.clientY);

      if (lbZoomed()) setPanFromPointer(lastEvent);
    };

    document.addEventListener(
      "pointermove",
      (e) => {
        lastEvent = e;
        if (raf) return;
        raf = requestAnimationFrame(tick);
      },
      { passive: true }
    );

    // hide cursor if pointer goes anywhere outside stage
    document.addEventListener(
      "pointerover",
      (e) => {
        const lb = getLb();
        const stage = getStage();
        if (!lb || !lb.classList.contains(OPEN_CLASS) || !stage) return;
        if (!stage.contains(e.target)) hideLbCursor();
      },
      true
    );

    window.addEventListener("blur", hideLbCursor);
  };

  /* ======================================================
     MOBILE PINCH + PAN (LIGHTBOX)
  ====================================================== */
  const bindLightboxPinchPan = () => {
    if (document.body.dataset.clbPinchPanBound === "true") return;
    document.body.dataset.clbPinchPanBound = "true";

    let mode = null; // "pan" | "pinch"
    let startPanX = 0, startPanY = 0;
    let startX = 0, startY = 0;

    let startDist = 0;
    let startScale = 1;
    let startMidX = 0, startMidY = 0;

    const dist = (t1, t2) => Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);

    document.addEventListener(
      "touchstart",
      (e) => {
        const lb = getLb();
        if (!lb || !lb.classList.contains(OPEN_CLASS)) return;

        const stage = getStage();
        if (!stage || !stage.contains(e.target)) return;

        if (e.touches.length === 2) {
          mode = "pinch";
          const [t1, t2] = e.touches;
          startDist = dist(t1, t2);
          startScale = lbScale;
          startPanX = lbPanX;
          startPanY = lbPanY;
          startMidX = (t1.clientX + t2.clientX) / 2;
          startMidY = (t1.clientY + t2.clientY) / 2;
        } else if (e.touches.length === 1 && lbZoomed()) {
          mode = "pan";
          const t = e.touches[0];
          startX = t.clientX;
          startY = t.clientY;
          startPanX = lbPanX;
          startPanY = lbPanY;
        } else {
          mode = null;
        }

        if (mode) e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener(
      "touchmove",
      (e) => {
        const lb = getLb();
        if (!lb || !lb.classList.contains(OPEN_CLASS)) return;

        const stage = getStage();
        if (!stage || !stage.contains(e.target)) return;

        if (mode === "pinch" && e.touches.length === 2) {
          const [t1, t2] = e.touches;
          const d = dist(t1, t2);
          const ratio = startDist ? d / startDist : 1;

          lbScale = clamp(startScale * ratio, LB_MIN, LB_MAX);

          const midX = (t1.clientX + t2.clientX) / 2;
          const midY = (t1.clientY + t2.clientY) / 2;

          lbPanX = startPanX + (midX - startMidX);
          lbPanY = startPanY + (midY - startMidY);

          applyLbTransform();
          setLightboxCursorState();
          e.preventDefault();
          return;
        }

        if (mode === "pan" && e.touches.length === 1 && lbZoomed()) {
          const t = e.touches[0];
          lbPanX = startPanX + (t.clientX - startX);
          lbPanY = startPanY + (t.clientY - startY);

          applyLbTransform();
          e.preventDefault();
          return;
        }
      },
      { passive: false }
    );

    document.addEventListener(
      "touchend",
      (e) => {
        if (e.touches.length === 0) mode = null;
      },
      { passive: true }
    );

    document.addEventListener("touchcancel", () => { mode = null; }, { passive: true });
  };

  /* ======================================================
     FAST SWIPE (only when NOT zoomed)
  ====================================================== */
  const bindLightboxSwipe = () => {
    if (document.body.dataset.clbSwipeBound === "true") return;
    document.body.dataset.clbSwipeBound = "true";

    let dragging = false;
    let startX = 0;
    let dx = 0;

    const setTrackX = (track, px, animate = false) => {
      if (!track) return;
      track.style.transition = animate ? "transform 120ms cubic-bezier(.2,.9,.2,1)" : "none";
      track.style.transform = `translateX(calc(-100% + ${px}px))`;
    };

    const onStart = (e) => {
      const lb = getLb();
      if (!lb || !lb.classList.contains(OPEN_CLASS)) return;
      if (lbZoomed()) return;

      const stage = getStage();
      if (!stage || !stage.contains(e.target)) return;

      const t = e.touches?.[0];
      if (!t || e.touches.length !== 1) return;

      dragging = true;
      startX = t.clientX;
      dx = 0;

      const track = getTrack();
      setTrackX(track, 0, false);
    };

    const onMove = (e) => {
      if (!dragging) return;

      const lb = getLb();
      if (!lb || !lb.classList.contains(OPEN_CLASS) || lbZoomed()) return;

      const t = e.touches?.[0];
      if (!t) return;

      dx = clamp(t.clientX - startX, -MAX_DRAG, MAX_DRAG);

      const track = getTrack();
      setTrackX(track, dx, false);

      e.preventDefault();
    };

    const onEnd = () => {
      if (!dragging) return;
      dragging = false;

      const lb = getLb();
      if (!lb || !lb.classList.contains(OPEN_CLASS) || lbZoomed()) return;

      const track = getTrack();

      if (dx <= -SWIPE_TRIGGER) {
        setTrackX(track, -MAX_DRAG, true);
        setTimeout(() => next(), 160);
      } else if (dx >= SWIPE_TRIGGER) {
        setTrackX(track, MAX_DRAG, true);
        setTimeout(() => prev(), 160);
      } else {
        setTrackX(track, 0, true);
      }

      dx = 0;
    };

    document.addEventListener("touchstart", onStart, { passive: true });
    document.addEventListener("touchmove", onMove, { passive: false });
    document.addEventListener("touchend", onEnd, { passive: true });
    document.addEventListener("touchcancel", onEnd, { passive: true });
  };

  /* ======================================================
     GLOBAL CONTROLS
  ====================================================== */
document.addEventListener("click", (e) => {
  const lb = getLb();
  if (!lb || !lb.classList.contains(OPEN_CLASS)) return;


  if (e.target.closest("[data-clb-next]")) {
    e.preventDefault();
    e.stopPropagation();
    return next();
  }

  if (e.target.closest("[data-clb-prev]")) {
    e.preventDefault();
    e.stopPropagation();
    return prev();
  }


  if (e.target.closest("[data-clb-close]")) {
    e.preventDefault();
    e.stopPropagation();
    return close();
  }


  const ui = e.target.closest(".custom-lightbox__ui");
  const stage = e.target.closest(".custom-lightbox__stage");

  if (ui && !stage) {
    e.preventDefault();
    e.stopPropagation();
    return close();
  }
});

  // Click-to-zoom (desktop + mobile)
  document.addEventListener("click", (e) => {
    const lb = getLb();
    if (!lb || !lb.classList.contains(OPEN_CLASS)) return;

    const stage = e.target.closest(".custom-lightbox__stage");
    if (!stage) return;

    e.preventDefault();
    e.stopPropagation();

    if (lbScale <= 1) {
      lbScale = LIGHTBOX_ZOOM;
    } else {
      lbScale = 1;
    }

    lbPanX = 0;
    lbPanY = 0;
    applyLbTransform();
    setLightboxCursorState();
  });

  // keyboard
  document.addEventListener("keydown", (e) => {
    const lb = getLb();
    if (!lb || !lb.classList.contains(OPEN_CLASS)) return;

    if (e.key === "Escape") close();
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  });

  /* ======================================================
     CUSTOM CURSOR (GALLERY - DESKTOP ONLY)
  ====================================================== */
  const bindCustomCursor = (root = document) => {
    if (!isDesktopHover()) return;

    const list = root.querySelector(MEDIA_LIST);
    if (!list || list.dataset.customCursorBound) return;
    list.dataset.customCursorBound = "true";

    if (!document.querySelector("#clb-cursor-css")) {
      const style = document.createElement("style");
      style.id = "clb-cursor-css";
      style.textContent = `.clb-cursor-zone, .clb-cursor-zone * { cursor:none !important; }`;
      document.head.appendChild(style);
    }
    list.classList.add("clb-cursor-zone");

    let cursor = document.querySelector(".custom-cursor");
    if (!cursor) {
      cursor = document.createElement("div");
      cursor.className = "custom-cursor";
      cursor.setAttribute("aria-hidden", "true");
      cursor.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path d="M8 2v12M2 8h12" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
      document.body.appendChild(cursor);
    }

    Object.assign(cursor.style, {
      position: "fixed",
      left: "0px",
      top: "0px",
      width: "34px",
      height: "34px",
      transform: "translate(-50%, -50%)",
      borderRadius: "10px",
      background: "rgba(255,255,255,.92)",
      boxShadow: "0 6px 20px rgba(0,0,0,.15)",
      display: "grid",
      placeItems: "center",
      pointerEvents: "none",
      zIndex: "9999999",
      opacity: "0",
      transition: "opacity 120ms ease",
    });

    let raf = null;
    let lastX = 0, lastY = 0;

    const move = (e) => {
      lastX = e.clientX;
      lastY = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        cursor.style.left = lastX + "px";
        cursor.style.top = lastY + "px";
      });
    };

    const show = () => { cursor.style.opacity = "1"; };
    const hide = () => { cursor.style.opacity = "0"; };

    list.addEventListener("mousemove", move, { passive: true });
    list.addEventListener("mouseenter", show);
    list.addEventListener("mouseleave", hide);
    window.addEventListener("blur", hide);
  };

  /* ======================================================
     INIT
  ====================================================== */
  const setup = (root = document) => {
    bindClicks(root);
    bindHover(root);
    bindCustomCursor(root);

    // Lightbox behavior (global once)
    bindLightboxCursorAndPan();
    bindLightboxPinchPan();
    bindLightboxSwipe();
  };

  setup();
  document.addEventListener("shopify:section:load", (e) => setup(e.target));
})();




window.forceBroadcastGridSlider = function (scope) {
  if (!scope) return;

  scope.querySelectorAll('grid-slider').forEach(function (slider) {
    // fully reset the slider
    slider.dispatchEvent(new CustomEvent('theme:grid-slider:destroy', { bubbles: true }));
    slider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
  });

  // Broadcast also listens to this
  document.dispatchEvent(new CustomEvent('theme:resize:width'));
};






(() => {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function waitForKlaviyoWriteButton(mount, timeoutMs = 10000) {
    return new Promise((resolve, reject) => {
      const find = () =>
        mount.querySelector('.kl_reviews__button') ||
        mount.querySelector('button[aria-label*="Write a review"]');

      const found = find();
      if (found) return resolve(found);

      const obs = new MutationObserver(() => {
        const btn = find();
        if (btn) {
          obs.disconnect();
          resolve(btn);
        }
      });

      obs.observe(mount, { childList: true, subtree: true });

      setTimeout(() => {
        obs.disconnect();
        reject(new Error('Timed out waiting for Klaviyo write button'));
      }, timeoutMs);
    });
  }

  ready(() => {
    const mount = document.getElementById('klaviyo-reviews-all');
    if (!mount) return;

    const accordion = mount.closest('.product-accordion.product__reviews');
    if (!accordion) return;

    const details = accordion.querySelector('details.accordion');
    const summary = details ? details.querySelector('summary.accordion__title') : null;

    const countEl = accordion.querySelector('[data-review-count]');
    const ctaEl   = accordion.querySelector('[data-review-write-cta]');

    // --- Make the CTA usable immediately (even before Klaviyo loads) ---
    if (ctaEl && !ctaEl.dataset.bound) {
      ctaEl.dataset.bound = 'true';

      ctaEl.classList.remove('is-hidden'); // visible straight away (perceived speed)

      ctaEl.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Optional: scroll to the reviews area instantly for feedback
          accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });

          waitForKlaviyoWriteButton(mount, 10000)
            .then((btn) => btn.click())
            .catch(() => {
              // Fallback: if Klaviyo still hasn't loaded, at least open the accordion
              if (details) details.open = true;
            });
        },
        true
      );
    }

    // --- Block summary toggling ONLY when in "no reviews" state ---
    function onSummaryClick(e) {
      if (!accordion.classList.contains('has-no-reviews')) return;

      // Let the CTA work
      if (e.target && e.target.closest && e.target.closest('[data-review-write-cta]')) return;

      // Otherwise block <details> toggling
      e.preventDefault();
      e.stopPropagation();
    }
    if (summary && !summary.dataset.bound) {
      summary.dataset.bound = 'true';
      summary.addEventListener('click', onSummaryClick, true);
    }

    function setNoReviewsState(isNoReviews) {
      if (!details) return;

      if (isNoReviews) {
        accordion.classList.add('has-no-reviews');
        details.open = false;                 // keep closed always
        details.setAttribute('data-no-toggle', '');
      } else {
        accordion.classList.remove('has-no-reviews');
        details.removeAttribute('data-no-toggle');
      }
    }

    function getCount() {
      // Prefer tab count: Reviews <small>1</small>
      const small = mount.querySelector('#kl_reviews_tabs__reviews_tab small');
      if (small && small.textContent) return parseInt(small.textContent.trim(), 10) || 0;

      // Fallback: "1 review"
      const text = (mount.querySelector('.kl_reviews__summary__stars__count') || {}).textContent || '';
      const m = text.match(/(\d+)/);
      return m ? parseInt(m[1], 10) || 0 : 0;
    }

    function update() {
      // Wait until Klaviyo injected the widget
      const hasWidget = mount.querySelector(
        '#klaviyo-product-reviews-wrapper, .kl_reviews__summary, .kl_reviews__reviews_list'
      );
      if (!hasWidget) return;

      accordion.classList.remove('is-hidden');

      const count = getCount();

      // Count badge
      if (countEl) {
        if (count > 0) {
          countEl.textContent = `(${count})`;
          countEl.classList.remove('is-hidden');
        } else {
          countEl.classList.add('is-hidden');
        }
      }

      const noReviews = (count === 0);
      setNoReviewsState(noReviews);

      // CTA visibility:
      // - If no reviews: keep visible (and accordion locked)
      // - If has reviews: you can either hide it or leave it (your choice)
      if (ctaEl) {
        if (noReviews) ctaEl.classList.remove('is-hidden');
        else ctaEl.classList.add('is-hidden'); // change to "remove" if you want it always visible
      }

      document.dispatchEvent(new CustomEvent('theme:resize:width'));
    }

    update();

    const obs = new MutationObserver(() => update());
    obs.observe(mount, { childList: true, subtree: true });

    // Stop observing eventually
    setTimeout(() => obs.disconnect(), 10000);
  });
})();



(() => {
  const STORAGE_KEY = "favourites";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  };

  const write = (arr) => localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));

  const isSaved = (handle) => read().includes(handle);

  const toggle = (handle) => {
    const favs = read();
    const i = favs.indexOf(handle);
    if (i > -1) favs.splice(i, 1);
    else favs.push(handle);
    write(favs);
  };

  const syncAll = (root = document) => {
    root.querySelectorAll("[data-fav-toggle][data-handle]").forEach((btn) => {
      const handle = btn.getAttribute("data-handle");
      const active = isSaved(handle);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-label", active ? "Remove from favourites" : "Add to favourites");
    });
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-fav-toggle]");
    if (!btn) return;

    photo.addEventListener("click", (e) => {
    e.preventDefault();
    openAt(i, root);
    });

    const handle = btn.getAttribute("data-handle");
    if (!handle) return;

    toggle(handle);
    syncAll(document);
    document.dispatchEvent(new CustomEvent("favourites:updated"));
  });


  document.addEventListener("DOMContentLoaded", () => syncAll());

  const mo = new MutationObserver(() => syncAll());
  document.addEventListener("DOMContentLoaded", () => {
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();

(() => {
  const STORAGE_KEY = "favourites";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  };

  const updateHeaderFavCount = () => {
    const count = read().length;
    document.querySelectorAll("[data-favourites-count]").forEach((el) => {
      if (count > 0) {
        el.hidden = false;
        el.textContent = count > 9 ? "9+" : String(count);
      } else {
        el.hidden = true;
        el.textContent = "0";
      }
    });
  };

  document.addEventListener("DOMContentLoaded", updateHeaderFavCount);
  document.addEventListener("favourites:updated", updateHeaderFavCount);

  // also update if another tab changes it
  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY) updateHeaderFavCount();
  });
})();





})(
  themeVendor.ScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);


















